angular.module("templates-main", ["accounting-costs/accounting-costs.html", "client-dashboard/client-dashboard.html", "client-dashboard/components/client-about-component/client-about-component.html", "client-dashboard/components/client-assignments-component/client-assignments-component.html", "client-dashboard/components/client-assignments-component/client-assignments-item-component/client-assignments-item-component.html", "client-dashboard/components/client-comments-component/client-comments-component.html", "client-dashboard/components/client-dashboard-components/identity-component.html", "client-dashboard/components/client-dashboard-components/phone-number-list-component.html", "client-dashboard/components/client-related-contacts-component/client-related-contacts-component.html", "client-dashboard/components/client-related-contacts-component/client-related-contacts-item-component/client-related-contacts-item-component.html", "common/privacy-footer/privacy-footer-content.html", "common/privacy-footer/privacy-footer.html", "common/unsaved-indicator/unsaved-indicator.html", "dashboard/bm-help-widget/bm-common-articles.html", "dashboard/bm-help-widget/bm-help-widget.2js.html", "dashboard/bm-help-widget/help-video-modal.2js.html", "dashboard/close-modals-confirmation-template.html", "dashboard/firm-dashboard.2js.html", "dashboard/landing-page-modal.html", "dashboard/onvio-overview-video/onvio-overview-video.2js.html", "dashboard/setup-step-modal-activities.html", "dashboard/setup-step-modal-client-center.html", "dashboard/setup-step-modal-client-setup.html", "dashboard/setup-step-modal-firm.html", "dashboard/setup-step-modal-formattemplate.html", "dashboard/setup-step-modal-taxgroups.html", "dashboard/setup-step-modal-taxrates.html", "dashboard/setup-step-modal-template.html", "dashboard/trial-purchase-widget/share-trial.2js.html", "dashboard/trial-purchase-widget/trial-purchase-widget.2js.html", "dashboard/widget-templates/bm-common-articles.html", "dashboard/widget-templates/bm-help-widget.html", "dashboard/widget-templates/bm-overview-widget.html", "dashboard/widget-templates/bm-staff-availability-widget.html", "dashboard/widget-templates/bm-time-recap-widget.html", "dashboard/widget-templates/bmp-project-list.html", "dashboard/widgets/client-info/client-info-widget.2js.html", "dashboard/widgets/drive/drive-usage-widget.2js.html", "documents/all-docs/masterlist/all-docs-master.html", "documents/clients/masterlist/client-master.html", "documents/communications/actions/approve-add-edit.html", "documents/communications/actions/informational-add-edit.html", "documents/communications/actions/send-document-add-edit.html", "documents/communications/masterlist/communication-master.html", "documents/dms-main.html", "documents/files/file-view.html", "documents/folders/masterlist/folder-master.html", "documents/legacy-recents/masterlist/legacy-recents-master.html", "documents/recents/masterlist/recents-master.html", "documents/recycle/masterlist/recycle-view.html", "documents/search/document-search-results.html", "documents/storage/masterlist/storage-master.html", "documents/templates/actions/add-edit-request-template-master.html", "documents/templates/masterlist/request-template-master.html", "documents/templates/masterlist/template-master.html", "documents/templates/typeahead-template.html", "documents/tree-view/tree-view.html", "firm-dashboard/firm-dashboard.html", "nav/bm-staff-nav.html", "practice-widgets/accounts-receivable-open/accounts-receivable-open.html", "practice-widgets/accounts-receivable-summary/accounts-receivable-summary.html", "practice-widgets/agings/agings.html", "practice-widgets/billing-services/applied-amounts-dialog.html", "practice-widgets/billing-services/billable-entries-dialog.html", "practice-widgets/bm-practice-widget-scrolling-container/bm-practice-widget-scrolling-container.html", "practice-widgets/bm-practice-widget/bm-practice-widget.html", "practice-widgets/key-totals/key-totals.html", "practice-widgets/my-assignments/my-assignments.html", "practice-widgets/practice-widget-date-search-header.html", "practice-widgets/prior-invoices/prior-invoices.html", "practice-widgets/time-summary/time-summary.html", "practice-widgets/wip-summary/wip-summary.html", "quick-books-integration-callback/quick-books-integration-callback.2js.html", "reports/employee-portal-documents/employee-portal-documents-removal-confirm-modal.html", "reports/employee-portal-documents/employee-portal-documents.html", "reports/firm-management-reports/firm-management-reports-main.html", "reports/firm-management-reports/firm-management-reports-options.html", "reports/firm-management-reports/firm-management-reports.html", "reports/onvio-usage/login-history-modal/login-history-modal.2js.html", "reports/onvio-usage/onvio-usage.html", "reports/onvio-usage/terms-modal/terms-modal.2js.html", "server-check/index.html", "setup/src/activities/activity-detail.html", "setup/src/bm-notifications/bm-notifications.html", "setup/src/client-notifications/client-notifications.html", "setup/src/client-notifications/wording/wording.html", "setup/src/custom-fields/custom-fields-setup.html", "setup/src/engagement-templates/engagement-template-detail.html", "setup/src/import-export-test/import-export-test.html", "setup/src/import-progress/import-progress.html", "setup/src/import-wizard/import-ledger.html", "setup/src/import-wizard/import-wip.html", "setup/src/late-fee-templates/late-fee-template-detail.html", "setup/src/migrations/file-cabinet/fclist-form-toolbar.2js.html", "setup/src/migrations/file-cabinet/fclist-form.2js.html", "setup/src/migrations/file-cabinet/migration-creation/creation-main.2js.html", "setup/src/migrations/file-cabinet/migration-creation/fcapp-network.2js.html", "setup/src/migrations/file-cabinet/migration-creation/fcconfirmation.2js.html", "setup/src/migrations/file-cabinet/migration-creation/fcdrawer-selection.2js.html", "setup/src/migrations/migration-new-client-reg.html", "setup/src/migrations/migration-new.html", "setup/src/migrations/migration-setup.2js.html", "setup/src/migrations/new-migration/application-network.2js.html", "setup/src/migrations/new-migration/confirmation.2js.html", "setup/src/migrations/new-migration/desktop-utility.2js.html", "setup/src/migrations/new-migration/drawer-selection.2js.html", "setup/src/migrations/new-migration/new-main.2js.html", "setup/src/models/accounting-costs/accounting-costs.html", "setup/src/models/add-costs-calculation/add-costs-calculation.html", "setup/src/permission-groups/permission-groups-detail.html", "setup/src/permission-groups/permission-groups.html", "setup/src/security/setting-security.html", "setup/src/terms/terms-setup/enable-terms/terms-enable-confirm-modal.2js.html", "setup/src/terms/terms-setup/published-terms/published-terms-modal.2js.html", "setup/src/terms/terms-setup/sample-terms/sample-terms-modal.2js.html", "setup/src/terms/terms-setup/term-setup-form.2js.html", "setup/src/terms/terms.html", "setup/src/themes/appearance-setup.2js.html", "setup/src/themes/sign-in-options.2js.html", "setup/src/themes/theme-setup-image-preview.html", "setup/src/themes/theme-setup-next.html", "setup/src/themes/theme-setup.2js.html", "views/main/dashboard-tour.html", "views/main/preview-tour.html", "views/main/purchase-confirmation.html", "views/main/setup-widget.html", "views/not-found/not-found.html", "views/test/hybrid-playground.html"]);

angular.module("accounting-costs/accounting-costs.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("accounting-costs/accounting-costs.html",
    "<app-accounting-costs class=\"ng-bento\" (router-changed)=\"vm.navigateTo($event)\"></app-accounting-costs>\n" +
    "");
}]);

angular.module("client-dashboard/client-dashboard.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/client-dashboard.html",
    "<div class=\"client-dashboard-background\">\n" +
    "    <div class=\"client-header-combobox\">\n" +
    "        <div class=\"col-md-6 col-sm-12\">\n" +
    "            <label class=\"control-label client-dashboard-combo-label\"\n" +
    "                   class=\"col-sm-12\"\n" +
    "                   for=\"client\">{{'Bluemoon.Shell.Navigation.ClientDashboard' | translate}}</label>\n" +
    "            <bmp-select-combo list=\"clients#active\"\n" +
    "                              class=\"col-sm-12 client-select-combobox\"\n" +
    "                              name=\"client\"\n" +
    "                              ng-model=\"$ctrl.$selectedClient\"\n" +
    "                              on-change=\"$ctrl.loadCurrentClient($ctrl.$selectedClient.id)\"\n" +
    "                              frp=\"Onvio.ClientDashboard\"\n" +
    "                              custom-display-type=\"{{$ctrl.customDisplayType}}\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div style=\"height: 85px;\"></div>\n" +
    "    <app-client-dash [is-loading]=\"$ctrl.isLoading\"\n" +
    "                     [is-linked-to-on-balance]=\"$ctrl.isClientLinkedToOnBalance\"\n" +
    "                     [is-simple-tax-payer]=\"$ctrl.isSimpleTaxPayer\"\n" +
    "                     [background]=\"'client-dashboard-' + $ctrl.backgroundName\"\n" +
    "                     [client]=\"$ctrl.client\">\n" +
    "        <div id=\"about\" data-qe-id=\"client-dashboard-about\">\n" +
    "            <client-about-component client=\"$ctrl.client\" is-loading=\"$ctrl.isLoading\" on-edit=\"$ctrl.edit(client, 'client')\"></client-about-component>\n" +
    "        </div>\n" +
    "        <div id=\"staff-relationships\" data-qe-id=\"client-dashboard-staff-relationships\">\n" +
    "            <client-assignments client=\"$ctrl.client\"></client-assignments>\n" +
    "        </div>\n" +
    "        <div id=\"related-contacts\" data-qe-id=\"client-dashboard-related-contacts\">\n" +
    "            <client-related-contacts client=\"$ctrl.client\" view-Contacts=\"$ctrl.openContactModal(client, 'client')\"></client-related-contacts>\n" +
    "        </div>\n" +
    "        <div id=\"comments\" data-qe-id=\"client-dashboard-comments\">\n" +
    "\n" +
    "            <!-- <client-comments-component client=\"$ctrl.client\"></client-comments-component> -->\n" +
    "            <!-- This is replaced by the latest version of the blue notes. client-comments-component must be removed later -->\n" +
    "            <div class=\"comments-row\">\n" +
    "                <bmcn-notes-modal ng-if=\"$ctrl.client.primaryContact && $ctrl.client.primaryContact.id\"\n" +
    "                    [entity-id]=\"$ctrl.client.primaryContact.id\" [icon]=\"''\" [name]=\"$ctrl.client.name\" note-type=\"general\" [user-contact-id]=\"$ctrl.userContactId\" [is-notes-modal]=\"true\">\n" +
    "                </bmcn-notes-modal>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div id=\"client-button\">\n" +
    "            <a class=\"btn btn-outline-primary\"\n" +
    "                ng-click=\"$ctrl.goToClientCompany()\"\n" +
    "                ng-keydown=\"$ctrl.goToClientCompany()\"\n" +
    "                tabindex=\"0\"\n" +
    "                bento-busy-loader=\"$ctrl.isOBButtonLoading\"\n" +
    "                ng-disabled=\"$ctrl.isOBButtonLoading\">\n" +
    "                <span translate=\"Onvio.Reports.ClientDashboard.AccessClientInOnbalance\"></span><i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "        <notifications current-client=\"$ctrl.client\"></notifications>\n" +
    "        <quarter-report-statements-ar current-client=\"$ctrl.client\"></quarter-report-statements-ar>\n" +
    "        <div id=\"wip-summary\" data-qe-id=\"client-dashboard-wip-summary\">\n" +
    "            <bm-practice-widget widget=\"wip-summary\" context=\"$ctrl.billingWidgetContext()\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"ar-summary\" data-qe-id=\"client-dashboard-ar-summary\">\n" +
    "            <bm-practice-widget widget=\"accounts-receivable-summary\" context=\"$ctrl.billingWidgetContext()\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"wip-agings\" data-qe-id=\"client-dashboard-wip-agings\">\n" +
    "            <bm-practice-widget widget=\"agings\" type=\"wip\" context=\"$ctrl.billingWidgetContext()\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"ar-agings\" data-qe-id=\"client-dashboard-ar-agings\">\n" +
    "            <bm-practice-widget widget=\"agings\" type=\"ar\" context=\"$ctrl.billingWidgetContext()\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"key-totals\" data-qe-id=\"client-dashboard-key-totals\">\n" +
    "            <bm-practice-widget widget=\"key-totals\" context=\"$ctrl.billingWidgetContext()\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"prior-invoices\" data-qe-id=\"client-dashboard-prior-invoices\">\n" +
    "            <bm-practice-widget widget=\"prior-invoices\" context=\"$ctrl.billingWidgetContext()\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"ar-open\" data-qe-id=\"client-dashboard-ar-open\">\n" +
    "            <bm-practice-widget widget=\"accounts-receivable-open\" context=\"$ctrl.billingWidgetContext()\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"my-assignments\" data-qe-id=\"client-dashboard-my-assignments\">\n" +
    "            <bm-practice-widget widget=\"my-assignments\" context=\"$ctrl.client\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "    </app-client-dash>\n" +
    "</div>\n" +
    "");
}]);

angular.module("client-dashboard/components/client-about-component/client-about-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/components/client-about-component/client-about-component.html",
    "<ul class=\"list-group client-information-container\"\n" +
    "    bento-busy-loader=\"$ctrl.isLoading\"\n" +
    "    bento-busy-loader-size=\"small\">\n" +
    "    <li class=\"client-information-list-item\">\n" +
    "        <contact-identity contact=\"$ctrl.contact\"\n" +
    "                          substring=\"{{$ctrl.entityType}}\"></contact-identity>\n" +
    "        <span class=\"label client-information-status-label\"\n" +
    "              ng-class=\"{ 'label-success': $ctrl.status.id === 'ACTIVE',\n" +
    "                                'label-warning': $ctrl.status.id === 'ONHOLD',\n" +
    "                                'label-danger': $ctrl.status.id === 'INACTIVE'}\">\n" +
    "            {{$ctrl.status.name}}\n" +
    "        </span>\n" +
    "        <button tabindex=\"0\" style=\"justify-content: center; display: flex; align-items: baseline;\n" +
    "            position: relative; top: 10px;\"\n" +
    "            class=\"btn btn-icon btn-lg btn-default\"\n" +
    "             ng-click=\"$ctrl.onEdit({'client': $ctrl.client})\"\n" +
    "                ng-if=\"$ctrl.contact\"\n" +
    "                uib-tooltip=\"{{'Bluemoon.Practice.Common.Actions.Edit' | translate}}\">\n" +
    "                <i class=\"ng-bento bento-icon-edit ng-star-inserted edit-pencil-icon\"></i>\n" +
    "        </button>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\">\n" +
    "        <phone-number-list phone-numbers=\"$ctrl.contact.phoneNumbers\"></phone-number-list>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\"\n" +
    "        ng-if=\"$ctrl.displayAddressPanel()\">\n" +
    "        <i class=\"bento-icon-home\"></i>\n" +
    "        <div class=\"client-information-info\">\n" +
    "            <span class=\"no-margin-b client-information-header-truncate\">\n" +
    "                <a role=\"button\"\n" +
    "                   href=\"{{$ctrl.getAddressLink($ctrl.primaryAddress)}}\"\n" +
    "                   target=\"_blank\">\n" +
    "                    {{$ctrl.formatAddress($ctrl.primaryAddress)}}\n" +
    "                </a>\n" +
    "            </span>\n" +
    "            <span class=\"panel-time no-margin\">\n" +
    "                {{$ctrl.formatPrimaryString($ctrl.primaryAddress.addressType.name)}}\n" +
    "            </span>\n" +
    "\n" +
    "            <div ng-repeat=\"address in $ctrl.otherAddresses\">\n" +
    "                <span class=\"no-margin-b client-information-header-truncate\">\n" +
    "                    <a role=\"button\"\n" +
    "                       href=\"{{$ctrl.getAddressLink(address)}}\"\n" +
    "                       target=\"_blank\">\n" +
    "                        {{$ctrl.formatAddress(address)}}\n" +
    "                    </a>\n" +
    "                </span>\n" +
    "                <span class=\"panel-time no-margin\">{{address.addressType.name}}</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\">\n" +
    "        <app-email-list [email-addresses]=\"$ctrl.contact.emailAddresses\"></app-email-list>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\"\n" +
    "        ng-if=\"$ctrl.contact.socialMedia.length > 0\">\n" +
    "        <i class=\"bento-icon-earth\"></i>\n" +
    "        <div class=\"client-information-info\">\n" +
    "            <div ng-repeat=\"social in $ctrl.contact.socialMedia\">\n" +
    "                <span class=\"no-margin-b client-information-header-truncate\">\n" +
    "                    <a role=\"button\"\n" +
    "                       href=\"{{social.url}}\"\n" +
    "                       target=\"_blank\">\n" +
    "                        {{social.url}}\n" +
    "                    </a>\n" +
    "                </span>\n" +
    "                <span class=\"panel-time no-margin\">{{social.socialMediumType.name}}</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("client-dashboard/components/client-assignments-component/client-assignments-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/components/client-assignments-component/client-assignments-component.html",
    "<ul class=\"list-group client-information-container\"\n" +
    "    bento-busy-loader=\"$ctrl.isLoading\"\n" +
    "    bento-busy-loader-size=\"small\">\n" +
    "    <li class=\"client-information-list-item\"\n" +
    "        ng-if=\"!$ctrl.manager && !$ctrl.associate && !$ctrl.partner\">\n" +
    "        <span class=\"no-assignments\" data-ng-bind-html=\"$ctrl.getNoAssignmentsString()\"></span>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\"\n" +
    "        ng-if=\"$ctrl.partner\">\n" +
    "        <client-assignments-item employee=\"$ctrl.partner\"\n" +
    "                                 sub-string=\"Core.Captions.ClientPartner.ClassOne\">\n" +
    "        </client-assignments-item>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\"\n" +
    "        ng-if=\"$ctrl.manager\">\n" +
    "        <client-assignments-item employee=\"$ctrl.manager\"\n" +
    "                                 sub-string=\"Core.Captions.ClientEngagement.Manager\">\n" +
    "        </client-assignments-item>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\"\n" +
    "        ng-if=\"$ctrl.associate\">\n" +
    "        <client-assignments-item employee=\"$ctrl.associate\"\n" +
    "                                 sub-string=\"Core.Captions.ClientMain.AssociateEmployee\">\n" +
    "        </client-assignments-item>\n" +
    "    </li>\n" +
    "</ul>");
}]);

angular.module("client-dashboard/components/client-assignments-component/client-assignments-item-component/client-assignments-item-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/components/client-assignments-component/client-assignments-item-component/client-assignments-item-component.html",
    "<contact-identity contact=\"$ctrl.employee.primaryContactExpanded\" substring=\"{{$ctrl.subString}}\"></contact-identity>\n" +
    "<a class=\"client-assignment-link\" ng-href=\"{{$ctrl.generateMailToLink()}}\"\n" +
    "    ng-if=\"$ctrl.displayEmailButton()\">\n" +
    "    <i class=\"bento-icon-envelope send-email\"></i>\n" +
    "</a>\n" +
    "");
}]);

angular.module("client-dashboard/components/client-comments-component/client-comments-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/components/client-comments-component/client-comments-component.html",
    "<div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\" style=\"margin-bottom: 10px\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <bmn-edit-note ng-if=\"isInEditMode\" note=\"noteToEdit\" is-locked=\"{{note.entity.locked}}\"\n" +
    "                    parent-update=\"update(noteToEdit)\"></bmn-edit-note>\n" +
    "                <bmn-new-note ng-if=\"!isInEditMode\" entity-id=\"{{note.entity.id}}\" is-locked=\"{{note.entity.locked}}\"\n" +
    "                    note-type=\"{{note.type}}\"></bmn-new-note>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <ul class=\"bmn-comment-list\">\n" +
    "                    <bmn-existing-note ng-repeat=\"thisNote in notes | orderBy: '-changed' track by thisNote.id\"\n" +
    "                        note=\"thisNote\" is-locked=\"{{note.entity.locked}}\"></bmn-existing-note>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("client-dashboard/components/client-dashboard-components/identity-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/components/client-dashboard-components/identity-component.html",
    "<bm-profile-photo-select\n" +
    "    class=\"client-information-photo\"\n" +
    "    image=\"$ctrl.getPhoto()\"\n" +
    "    initials=\"{{$ctrl.getInitials()}}\"\n" +
    "    view-only=\"true\"\n" +
    "    shape=\"circle\"\n" +
    "    size=\"small\">\n" +
    "</bm-profile-photo-select>\n" +
    "<div class=\"client-information-info\">\n" +
    "    <span class=\"client-information-header-truncate no-margin-b\">\n" +
    "        {{$ctrl.contact.displayAs}}\n" +
    "    </span>\n" +
    "    <span class=\"panel-time no-margin-tb\" translate=\"{{$ctrl.substring}}\"></span>\n" +
    "</div>");
}]);

angular.module("client-dashboard/components/client-dashboard-components/phone-number-list-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/components/client-dashboard-components/phone-number-list-component.html",
    "<i class=\"bento-icon-mobile\"></i>\n" +
    "<div class=\"client-information-info\">\n" +
    "    <div class=\"no-entries\" ng-if=\"$ctrl.phoneNumbers.length === 0\">\n" +
    "        <span class=\"client-information-header-truncate\"\n" +
    "              translate=\"Bluemoon.Core.ClientDashboard.None\">\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div ng-if=\"$ctrl.phoneNumbers.length > 0\">\n" +
    "        <span class=\"no-margin-b client-information-header-truncate\">\n" +
    "            {{$ctrl.formatPhoneNumber($ctrl.primaryPhoneNumber)}}\n" +
    "        </span>\n" +
    "        <span class=\"panel-time no-margin\">\n" +
    "            {{$ctrl.formatPrimaryString($ctrl.primaryPhoneNumber.phoneType.name)}}\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div ng-repeat=\"phoneNumber in $ctrl.otherPhoneNumbers\">\n" +
    "        <span class=\"no-margin-b client-information-header-truncate\">\n" +
    "            {{$ctrl.formatPhoneNumber(phoneNumber)}}\n" +
    "        </span>\n" +
    "        <span class=\"panel-time no-margin\">{{phoneNumber.phoneType.name}}</span>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("client-dashboard/components/client-related-contacts-component/client-related-contacts-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/components/client-related-contacts-component/client-related-contacts-component.html",
    "<div class=\"client-related-contacts client-related-contacts-{{ $ctrl.contactsSummary.items.length }}\" bento-busy-loader=\"$ctrl.isLoading\" bento-busy-loader-size=\"small\"\n" +
    "    ng-class=\"{ 'client-related-contacts-multiple': $ctrl.contactsSummary.items.length > 3 }\"\n" +
    "    id=\"ClientRelatedContacts\">\n" +
    "    <!-- one, two, or three related contacts -->\n" +
    "    <ul class=\"list-group related-contacts-list client-information-container\"\n" +
    "        ng-if=\"$ctrl.contactsSummary && $ctrl.contactsSummary.items.length <= 3\">\n" +
    "        <li class=\"client-information-list-item\" ng-if=\"!$ctrl.contactsSummary\">\n" +
    "            <span class=\"no-assignments\" data-ng-bind-html=\"$ctrl.getNoRelatedContactsString()\"></span>\n" +
    "        </li>\n" +
    "        <client-related-contacts-item\n" +
    "            ng-repeat=\"contact in $ctrl.contactsSummary.items\" contact=\"contact\"\n" +
    "            on-edit=\"$ctrl.edit(contact, 'contact')\"\n" +
    "            data-contact-type=\"{{$ctrl.contactType(contact.$relationshipSide.code)}}\">\n" +
    "        </client-related-contacts-item>\n" +
    "    </ul>\n" +
    "    <!-- more than three related contacts -->\n" +
    "    <div ng-if=\"$ctrl.contactsSummary && $ctrl.contactsSummary.items.length > 3\" id=\"ClientRelatedContactsCarousel\">\n" +
    "        <div bento-carousel gutter-size=\"5px\" class=\"client-related-contacts-carousel\" offsetHeight=\"0\">\n" +
    "            <ul class=\"list-group related-contacts-list client-information-container\" id=\"ClientRelatedCarouselList\">\n" +
    "                <client-related-contacts-item ng-if=\"$ctrl.contactsSummary.items && $ctrl.contactsSummary.items.length > 3\"\n" +
    "                    bento-carousel-card card-data=\"contact\"\n" +
    "                    card-template-url=\"'./client-related-contacts-item-component/client-related-contacts-item-component.html'\"\n" +
    "                    ng-repeat=\"contact in $ctrl.contactsSummary.items\" contact=\"contact\"\n" +
    "                    on-edit=\"$ctrl.edit(contact, 'contact')\"\n" +
    "                    data-contact-type=\"{{$ctrl.contactType(contact.$relationshipSide.code)}}\">\n" +
    "                </client-related-contacts-item>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <p ng-if=\"!$ctrl.isLoading\" class=\"viewAllContacts-Alignment\"\n" +
    "        ng-class=\"{'viewAllContacts-Alignment-With-Carousel': $ctrl.contactsSummary.items && $ctrl.contactsSummary.totalItems > 3}\">\n" +
    "        <button type=\"button\" class=\"viewAllContacts\"\n" +
    "            ng-click=\"$ctrl.viewContacts({'client': $ctrl.client})\">{{'Bluemoon.Core.ContactView.ViewAllContacts' | translate}}</button>\n" +
    "    </p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("client-dashboard/components/client-related-contacts-component/client-related-contacts-item-component/client-related-contacts-item-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("client-dashboard/components/client-related-contacts-component/client-related-contacts-item-component/client-related-contacts-item-component.html",
    "<ul class=\"list-group related-contacts-list list-group client-information-container related-contact-spacing\">\n" +
    "    <li class=\"client-information-list-item\" id=\"ClientContactIdentity\">\n" +
    "        <contact-identity contact=\"$ctrl.contact\" substring=\"{{$ctrl.contact.$relationshipSide.name}}\">\n" +
    "        </contact-identity>\n" +
    "        <i ng-click=\"$ctrl.onEdit({'contact': $ctrl.contact})\" class=\"bento-icon-edit\"\n" +
    "            ng-hide=\"!$ctrl.contact.id\"\n" +
    "            uib-tooltip=\"{{'Bluemoon.Practice.Common.Actions.Edit' | translate}}\">\n" +
    "        </i>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\">\n" +
    "        <phone-number-list phone-numbers=\"$ctrl.contact.phoneNumbers\"></phone-number-list>\n" +
    "    </li>\n" +
    "    <li class=\"client-information-list-item\">\n" +
    "        <app-email-list [email-addresses]=\"$ctrl.contact.emailAddresses\"></app-email-list>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "<br>\n" +
    "");
}]);

angular.module("common/privacy-footer/privacy-footer-content.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("common/privacy-footer/privacy-footer-content.html",
    "<div class=\"bento-footer sticky-footer\">\n" +
    "    <div class=\"bento-footer-logo\">\n" +
    "        <div class=\"bento-tr-logo-white\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"bento-footer-fine-prints privacy-content\">\n" +
    "        <div class=\"footer-fine-prints-content\">\n" +
    "            <h4 class=\"header-color\" translate=\"Bluemoon.Common.PrivacyFooter.Header\"></h4>\n" +
    "            <p id=\"footer-links-container\" translate=\"Bluemoon.Common.PrivacyFooter.Description\"></p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"bento-footer-options\">\n" +
    "        <a id=\"footer-links-close\" role=\"button\" tabindex=\"0\" ng-click=\"$ctrl.Close()\" ng-keydown=\"$ctrl.HandletTab($event)\">\n" +
    "            <i class=\"bento-icon-close-thick closeIconSize\"></i>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("common/privacy-footer/privacy-footer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("common/privacy-footer/privacy-footer.html",
    "<privacy-footer-content ng-if=\"$ctrl.isVisible\"></privacy-footer-content>");
}]);

angular.module("common/unsaved-indicator/unsaved-indicator.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("common/unsaved-indicator/unsaved-indicator.html",
    "<i class=\"bento-icon-warning unsaved-changes\" uib-tooltip=\"{{unsavedTranslated}}\" aria-label=\"{{unsavedTranslated}} on {{tabname}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\" role=\"alert\" aria-hidden=\"{{!tabname}}\" ng-if=\"toggle\"></i>\n" +
    "\n" +
    "");
}]);

angular.module("dashboard/bm-help-widget/bm-common-articles.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/bm-help-widget/bm-common-articles.html",
    "<div class=\"bm-help-widget\">\n" +
    "    <div id=\"common-topics\"\n" +
    "         data-qe-id=\"common-topics\"\n" +
    "         class=\"hhtc-category common-topics\"\n" +
    "         ng-if=\"vm.helpTopics.length > 0\">\n" +
    "        <div class=\"category-content\">\n" +
    "            <div class=\"help-link\"\n" +
    "                 ng-repeat=\"topic in vm.helpTopics\">\n" +
    "                <a\n" +
    "                   target=\"_blank\"\n" +
    "                   href=\"{{topic.url}}\"\n" +
    "                   class=\"btn btn-link\"\n" +
    "                   aria-describedby=\"new-tab\"\n" +
    "                   >\n" +
    "                   {{topic.name}}\n" +
    "\n" +
    "                   <i class=\"ml-2 bento-icon-newtab\"></i>\n" +
    "                </a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<span hidden id=\"new-tab\" translate=\"Bluemoon.Practice.Common.Actions.OpenInNewTab\"></span>");
}]);

angular.module("dashboard/bm-help-widget/bm-help-widget.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/bm-help-widget/bm-help-widget.2js.html",
    "<div class=\"bm-help-widget\">\n" +
    "	<div class=\"help-widget-container\" ng-if=\"vm.videosLoaded\">\n" +
    "	    <div class=\"bento-collapse-content\">\n" +
    "	    	<div class=\"hhtc-widget-content\">\n" +
    "	    		<!-- video library -->\n" +
    "		    	<div id=\"video-library\" data-qe-id=\"video-library\" class=\"hhtc-category video-library\" ng-if=\"vm.helpVideos.length > 0\">\n" +
    "		    		<div class=\"category-content\">\n" +
    "						<div class=\"help-link\" ng-repeat=\"video in vm.helpVideos\">\n" +
    "							<button ng-click=\"vm.openHelpVideoModal(video)\" class=\"btn btn-link px-1\">\n" +
    "                                <i class=\"bento-icon-play\"></i>&nbsp;{{video.title}}\n" +
    "                            </button>\n" +
    "						</div>\n" +
    "		    		</div>\n" +
    "		    	</div>\n" +
    "		    </div>\n" +
    "	    </div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("dashboard/bm-help-widget/help-video-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/bm-help-widget/help-video-modal.2js.html",
    "<div class=\"bento-modal\">\n" +
    "    <div class=\"modal-body\">\n" +
    "        <video class=\"video\" controls video-control=\"vm.videoControl\">\n" +
    "            <source src=\"{{vm.videoUrl}}\" type=\"video/mp4\">\n" +
    "            <span translate=\"onvio.dashboard.helpWidget.BrowserNotSuportHtml5Video\"></span>\n" +
    "        </video>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "            <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.closeModal()\" translate>\n" +
    "                    bm.components.common.close\n" +
    "            </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("dashboard/close-modals-confirmation-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/close-modals-confirmation-template.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <span>{{'Onvio.SetupAssistant.Modal.CloseConfirmationModal.Title' | translate}}</span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body modal-confirm-body\">\n" +
    "        <i class=\"glyphicons warning_sign modal-confirm-icon\"></i>\n" +
    "        <span class=\"modal-confirm-message display-inline-block\">\n" +
    "            {{'Onvio.SetupAssistant.Modal.CloseConfirmationModal.Body' | translate}}\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button id=\"close-confirmation-modal-confirm\"\n" +
    "        data-qe-id=\"close-confirmation-modal-confirm\"\n" +
    "        class=\"btn btn-primary\"\n" +
    "        data-ng-click=\"closeWizardModals()\">\n" +
    "            {{'Onvio.SetupAssistant.Modal.CloseConfirmationModal.Confirm' | translate}}\n" +
    "        </button>\n" +
    "        <button id=\"close-confirmation-modal-cancel\"\n" +
    "        data-qe-id=\"close-confirmation-modal-cancel\"\n" +
    "        class=\"btn btn-default\"\n" +
    "        data-ng-click=\"cancelCloseWizardModals()\"\n" +
    "        formnovalidate>\n" +
    "            {{'Onvio.SetupAssistant.Modal.CloseConfirmationModal.Cancel' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("dashboard/firm-dashboard.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/firm-dashboard.2js.html",
    "<div\n" +
    "    class=\"nucleus-dashboard nucleus-dashboard-background client-dashboard-{{vm.backgroundName}}\"\n" +
    "    bento-busy-loader=\"vm.wizardTranslationLoading || vm.landingPageTranslationsLoading\"\n" +
    ">\n" +
    "    <app-staff-dash\n" +
    "        [wizard-definition]=\"vm.definition\"\n" +
    "        [wizard-landing-page-definition]=\"vm.landingPageDefinition\"\n" +
    "        (wizard-open-modal)=\"vm.openWorkspaceModal($event.value,$event.sectionId)\"\n" +
    "        [background]=\"'client-dashboard-' + vm.backgroundName\"\n" +
    "        (dashboard-content-initialized)=\"vm.onDashboardContentInitialized($event)\"\n" +
    "        (dashboard-section-is-visible)=\"vm.onSectionIsVisible($event)\"\n" +
    "        (dashboard-widget-is-visible)=\"vm.onWidgetIsVisible($event)\"\n" +
    "        [wizard-translations-loaded]=\"!vm.wizardTranslationLoading && !vm.landingPageTranslationsLoading\"\n" +
    "    >\n" +
    "        <!--dynamic-widget-template directive is used to load widget on demand, when they are shown-->\n" +
    "        <div\n" +
    "            id=\"my-assignments-widget\"\n" +
    "            dynamic-widget-template\n" +
    "            load=\"vm.myAssignmentWidgetVisible\"\n" +
    "            content=\"bmp-project-list\"\n" +
    "        ></div>\n" +
    "\n" +
    "        <div\n" +
    "            id=\"availability\"\n" +
    "            dynamic-widget-template\n" +
    "            load=\"vm.availabilityWidgetVisible\"\n" +
    "            content=\"bm-staff-availability-widget\"\n" +
    "        ></div>\n" +
    "\n" +
    "        <div\n" +
    "            id=\"bm-time-recap-widget\"\n" +
    "            dynamic-widget-template\n" +
    "            load=\"vm.timeRecapWidgetVisible\"\n" +
    "            content=\"bm-time-recap-widget\"\n" +
    "        ></div>\n" +
    "\n" +
    "        <div\n" +
    "            id=\"bm-help-widget\"\n" +
    "            dynamic-widget-template\n" +
    "            load=\"vm.helpWidgetVisible\"\n" +
    "            content=\"bm-help-widget\"\n" +
    "        ></div>\n" +
    "\n" +
    "        <div\n" +
    "            id=\"bm-common-articles\"\n" +
    "            dynamic-widget-template\n" +
    "            load=\"vm.commonArticlesVisible\"\n" +
    "            content=\"bm-common-articles\"\n" +
    "        ></div>\n" +
    "\n" +
    "        <div\n" +
    "            id=\"onvio-overview\"\n" +
    "            dynamic-widget-template\n" +
    "            load=\"vm.onvioOverviewVisible\"\n" +
    "            content=\"bm-overview-widget\"\n" +
    "        ></div>\n" +
    "\n" +
    "        <setup-module\n" +
    "            id=\"setup-module\"\n" +
    "            company-id=\"vm.companyId\"\n" +
    "            contact-id=\"vm.contactId\"\n" +
    "            lang=\"vm.lang\"\n" +
    "        ></setup-module>\n" +
    "\n" +
    "        <trial-purchase\n" +
    "            lang=\"vm.lang\"\n" +
    "            id=\"trial-purchase\"\n" +
    "            bm-if-perm=\"Platform.Trial\"\n" +
    "        ></trial-purchase>\n" +
    "    </app-staff-dash>\n" +
    "</div>\n" +
    "");
}]);

angular.module("dashboard/landing-page-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/landing-page-modal.html",
    "<div class=\"modal-header\">\n" +
    "    <button type=\"button\" ng-click=\"vm.cancelLandingPageModal()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Close' | translate }}</button>\n" +
    "    <h3 class=\"modal-title\">{{'Onvio.SetupAssistant.Definition.SetupTitle' | translate}}</h3>\n" +
    "</div>\n" +
    "");
}]);

angular.module("dashboard/onvio-overview-video/onvio-overview-video.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/onvio-overview-video/onvio-overview-video.2js.html",
    "<div class=\"onvio-overview\">\n" +
    "    <video id=\"onvio-overview-video\" preload=\"none\" controls poster=\"legacy/app/common/styles/images/onvio-overview-video.png\">\n" +
    "        <source src=\"{{$ctrl.video.url}}\" type=\"video/mp4\">\n" +
    "        <span translate=\"onvio.dashboard.helpWidget.BrowserNotSuportHtml5Video\"></span>\n" +
    "    </video>\n" +
    "</div>");
}]);

angular.module("dashboard/setup-step-modal-activities.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/setup-step-modal-activities.html",
    "<div class=\"modal-header\" ng-hide=\"vm.showDetailHeader\">\n" +
    "        <button type=\"button\" ng-click=\"cancel()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Close' | translate }}</button>\n" +
    "        <h3 class=\"modal-title\">{{vm.modalTitle}}</h3>\n" +
    "        <bm-help-dropdown class=\"help-dropdown-on-step\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-header modal-bmWorkspace-header master-view-modal-header\" ng-show=\"vm.showDetailHeader\">\n" +
    "        <button type=\"button\" ng-click=\"cancelDetail()\" class=\"btn close\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Cancel' | translate }}</button>\n" +
    "        <button type=\"button\" ng-click=\"save()\" class=\"btn btn-primary btn btn-default save btn-save-close ng-scope\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.SaveAndClose' | translate }}</button>\n" +
    "            <h3 class=\"modal-title modal-title-activities\">{{vm.modalDetailTitle}}</h3>\n" +
    "            <bm-help-dropdown class=\"help-dropdown-on-step help-dropdown-on-step-cards\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "\n" +
    "<iframe hide-header-on-iframe id=\"setup-assistant-iframe\" class=\"embed-responsive-item\" src=\"{{vm.stepModalUrl}}\" allowfullscreen></iframe>");
}]);

angular.module("dashboard/setup-step-modal-client-center.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/setup-step-modal-client-center.html",
    "<div class=\"modal-header\">\n" +
    "  <button type=\"button\" ng-click=\"cancel()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Cancel' | translate }}</button>\n" +
    "  <button type=\"button\" ng-click=\"save()\" class=\"btn btn-primary btn btn-default save btn-save-close ng-scope\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.SaveAndClose' | translate }}</button>\n" +
    "  <h3 class=\"modal-title\">{{'Onvio.SetupAssistant.Modal.CustomizeClientCenter.Title' | translate}}</h3>\n" +
    "  <bm-help-dropdown class=\"help-dropdown-on-step help-dropdown-on-step-client-center\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "\n" +
    "<app-site-settings></app-site-settings>");
}]);

angular.module("dashboard/setup-step-modal-client-setup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/setup-step-modal-client-setup.html",
    "<div class=\"modal-header\" ng-hide=\"vm.showDetailHeader\">\n" +
    "    <button type=\"button\" ng-click=\"cancel()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Close' | translate }}</button>\n" +
    "    <h3 class=\"modal-title\">{{'Onvio.SetupAssistant.Modal.ClientSetup.Title' | translate}}</h3>\n" +
    "    <bm-help-dropdown class=\"help-dropdown-on-step\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "<iframe hide-header-on-iframe id=\"setup-assistant-iframe\" class=\"embed-responsive-item\" src=\"{{vm.stepModalUrl}}\" allowfullscreen></iframe>\n" +
    "");
}]);

angular.module("dashboard/setup-step-modal-firm.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/setup-step-modal-firm.html",
    "<div class=\"modal-header firm\">\n" +
    "  <button type=\"button\" ng-click=\"cancel()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Cancel' | translate }}</button>\n" +
    "  <button type=\"button\" ng-click=\"save()\" class=\"btn btn-primary btn btn-default save btn-save-close ng-scope\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.SaveAndClose' | translate }}</button>\n" +
    "  <h3 title=\"{{vm.modalTitle}}\" class=\"modal-title setup-step-firm-modal-title\">{{vm.modalTitle}}</h3>\n" +
    "  <div class=\"bmp-page-header-display-as\">\n" +
    "    <a href class=\"btn btn-default setup-no-pad-l\" role=\"button\" ng-click=\"openDisplayAsDialog()\" ng-show=\"showDisplayAsLink\" title=\"{{'Bluemoon.Core.Setup.Client.DisplayAs.Firm' | translate}}\"><span class=\"bento-icon-edit\"></span></a>\n" +
    "  </div>\n" +
    "  <bm-help-dropdown class=\"help-dropdown-on-step-firm\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "\n" +
    "<iframe hide-header-on-iframe id=\"setup-assistant-iframe\" hide-header-on-setup-firm-iframe class=\"embed-responsive-item\" src=\"{{vm.stepModalUrl}}\" allowfullscreen></iframe>");
}]);

angular.module("dashboard/setup-step-modal-formattemplate.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/setup-step-modal-formattemplate.html",
    "<div class=\"modal-header\">\n" +
    "  <button type=\"button\" ng-click=\"cancel()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Close' | translate }}</button>\n" +
    "  <h3 title=\"{{vm.modalTitle}}\" class=\"modal-title\">{{vm.modalTitle}}</h3>\n" +
    "  <bm-help-dropdown class=\"help-dropdown-on-step\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "\n" +
    "<iframe hide-header-on-iframe id=\"setup-assistant-iframe\" class=\"embed-responsive-item\" src=\"{{vm.stepModalUrl}}\" allowfullscreen></iframe>\n" +
    "\n" +
    "");
}]);

angular.module("dashboard/setup-step-modal-taxgroups.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/setup-step-modal-taxgroups.html",
    "<div class=\"modal-header\" ng-hide=\"vm.showDetailHeader\">\n" +
    "    <button type=\"button\" ng-click=\"cancel()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Close' | translate }}</button>\n" +
    "    <h3 class=\"modal-title\">{{vm.modalTitle}}</h3>\n" +
    "    <bm-help-dropdown class=\"help-dropdown-on-step\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "<div class=\"modal-header modal-bmWorkspace-header master-view-modal-header\" ng-show=\"vm.showDetailHeader\">\n" +
    "    <button type=\"button\" ng-click=\"cancelDetail()\" class=\"btn close\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Cancel' | translate }}</button>\n" +
    "    <button type=\"button\" ng-click=\"save()\" class=\"btn btn-primary btn btn-default save btn-save-close ng-scope\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.SaveAndClose' | translate }}</button>\n" +
    "        <h3 class=\"modal-title modal-title-taxgroups\">{{vm.modalDetailTitle}}</h3>\n" +
    "        <bm-help-dropdown class=\"help-dropdown-on-step help-dropdown-on-step-cards\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "\n" +
    "<iframe hide-header-on-iframe id=\"setup-assistant-iframe\" class=\"embed-responsive-item\" src=\"{{vm.stepModalUrl}}\" allowfullscreen></iframe>\n" +
    "");
}]);

angular.module("dashboard/setup-step-modal-taxrates.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/setup-step-modal-taxrates.html",
    "<div class=\"modal-header\" ng-hide=\"vm.showDetailHeader\">\n" +
    "    <button type=\"button\" ng-click=\"cancel()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Close' | translate }}</button>\n" +
    "    <h3 class=\"modal-title\">{{vm.modalTitle}}</h3>\n" +
    "    <bm-help-dropdown class=\"help-dropdown-on-step\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "<div class=\"modal-header modal-bmWorkspace-header master-view-modal-header\" ng-show=\"vm.showDetailHeader\">\n" +
    "    <button type=\"button\" ng-click=\"cancelDetail()\" class=\"btn close\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Cancel' | translate }}</button>\n" +
    "    <button type=\"button\" ng-click=\"save()\" class=\"btn btn-primary btn btn-default save btn-save-close ng-scope\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.SaveAndClose' | translate }}</button>\n" +
    "        <h3 class=\"modal-title modal-title-taxrates\">{{vm.modalDetailTitle}}</h3>\n" +
    "        <bm-help-dropdown class=\"help-dropdown-on-step help-dropdown-on-step-cards\" location=\"{{vm.location}}\"></bm-help-dropdown>\n" +
    "</div>\n" +
    "\n" +
    "<iframe hide-header-on-iframe id=\"setup-assistant-iframe\" class=\"embed-responsive-item\" src=\"{{vm.stepModalUrl}}\" allowfullscreen></iframe>\n" +
    "");
}]);

angular.module("dashboard/setup-step-modal-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/setup-step-modal-template.html",
    "<div class=\"modal-header\">\n" +
    "    <button type=\"button\" ng-click=\"cancel()\" class=\"close btn\" datadismiss=\"modal\" aria-hidden=\"true\">{{ 'Bluemoon.Practice.Common.Actions.Close' | translate }}</button>\n" +
    "    <h3 class=\"modal-title\">{{vm.modalTitle}}</h3>\n" +
    "    <bm-help-dropdown class=\"help-dropdown-on-step\" location=\"{{vm.location}}\" ></bm-help-dropdown>\n" +
    "</div>\n" +
    "\n" +
    "<iframe hide-header-on-iframe id=\"setup-assistant-iframe\" class=\"embed-responsive-item\" src=\"{{vm.stepModalUrl}}\" allowfullscreen></iframe>");
}]);

angular.module("dashboard/trial-purchase-widget/share-trial.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/trial-purchase-widget/share-trial.2js.html",
    "<div class=\"tour-confirmation-modal\" bento-busy-loader=\"share.loading\">\n" +
    "    <div bento-alert bento-alert-object=\"share.shareTrialAlert\" bento-alert-close=\"closeAlert($index)\"></div>\n" +
    "    <div class=\"modal-header\" translate=\"onvio.dashboard.shareTrial.header\"></div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p translate=\"onvio.dashboard.shareTrial.description\"></p>\n" +
    "        <div ng-form=\"shareTrialForm\">\n" +
    "            <div aa-notify></div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-12\">\n" +
    "                    <label><span translate=\"onvio.dashboard.shareTrial.form.name\"></span> *</label>\n" +
    "                    <div class=\"form-group\" ng-class=\"{'has-error': share.staffNameError}\">\n" +
    "                        <input required\n" +
    "                               name=\"staffname\"\n" +
    "                               type=\"text\"\n" +
    "                               class=\"bento-input form-control\"\n" +
    "                               ng-model=\"share.staffNameValue\"\n" +
    "                               ng-focus=\"share.onFocus('staffNameError')\"\n" +
    "                               ng-blur=\"share.onStaffNameBlur()\"/>\n" +
    "                        <p class=\"msg\" ng-show=\"shareTrialForm.staffname.$error\">{{share.staffNameErrorMsg}}</p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-12\">\n" +
    "                    <label><span translate=\"onvio.dashboard.shareTrial.form.email\"></span> *</label>\n" +
    "                    <div class=\"form-group\" ng-class=\"{'has-error': share.staffEmailError}\">\n" +
    "                        <input required\n" +
    "                               name=\"staffemail\"\n" +
    "                               type=\"email\"\n" +
    "                               ng-maxlength=\"250\"\n" +
    "                               class=\"bento-input form-control\"\n" +
    "                               ng-model=\"share.staffEmailValue\"\n" +
    "                               ng-focus=\"share.onFocus('staffEmailError')\"\n" +
    "                               ng-blur=\"share.onStaffEmailBlur()\">\n" +
    "                        <p class=\"msg\" ng-show=\"shareTrialForm.staffemail.$error.required\" translate=\"onvio.dashboard.shareTrial.form.error.email.required\"></p>\n" +
    "                        <p class=\"msg\" ng-show=\"shareTrialForm.staffemail.$error.email && !shareTrialForm.staffemail.$error.maxlength\" translate=\"onvio.dashboard.shareTrial.form.error.email.format\"></p>\n" +
    "                        <p class=\"msg\" ng-show=\"shareTrialForm.staffemail.$error.maxlength\" translate=\"onvio.dashboard.shareTrial.form.error.email.maxlength\"></p>\n" +
    "                        <p class=\"msg\" ng-show=\"share.duplicateEmail\" translate=\"onvio.dashboard.shareTrial.form.error.email.duplicate\"></p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-12\">\n" +
    "                    <label><span translate=\"onvio.dashboard.shareTrial.form.permissionGroup\"></span> *</label>\n" +
    "                    <div class=\"form-group\" ng-class=\"{'has-error': share.permissionGroupError}\">\n" +
    "                        <input\n" +
    "                          bento-combobox\n" +
    "                          required\n" +
    "                          class=\"bento-input form-control\"\n" +
    "                          name=\"permissiongroup\"\n" +
    "                          searchable=\"true\"\n" +
    "                          get-data=\"share.permissionGroups\"\n" +
    "                          ng-model=\"share.selectedGroup\"\n" +
    "                          on-change=\"share.onPermissionGroupChange()\"\n" +
    "                          ng-focus=\"share.onFocus('permissionGroupError')\"\n" +
    "                          ng-blur=\"share.onPermissionGroupBlur()\"\n" +
    "                        />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <p>* <span translate=\"onvio.dashboard.shareTrial.requiredFields\"></span></p>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary\" ng-click=\"share.send()\" translate=\"onvio.dashboard.shareTrial.actions.send\"></button>\n" +
    "        <button class=\"btn btn-default\" ng-click=\"share.cancel()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("dashboard/trial-purchase-widget/trial-purchase-widget.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/trial-purchase-widget/trial-purchase-widget.2js.html",
    "<div bento-alert\n" +
    "     bento-alert-object=\"vm.tialPurchaseAlert\"\n" +
    "     bento-alert-close=\"closeAlert($index)\"></div>\n" +
    "<div id=\"trial-purchase\">\n" +
    "	<div class=\"invite-container\"\n" +
    "	     ng-if=\"vm.permissionExists\">\n" +
    "		<div id=\"share-trial-icon\">\n" +
    "			<i class=\"bento-icon-users\"></i>\n" +
    "		</div>\n" +
    "		<div id=\"share-trial-options\">\n" +
    "			<h1 class=\"header-text\"\n" +
    "			    translate=\"Invite others to try Onvio with you.\"></h1>\n" +
    "			<button class=\"btn btn-primary\"\n" +
    "			        ng-click=\"vm.shareTrial()\"\n" +
    "			        translate=\"Share Trial\"></button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"status-container\">\n" +
    "		<div class=\"col-md-7 header-text\">\n" +
    "			<i class=\"bento-icon-clock\"></i>&nbsp;\n" +
    "			<span translate=\"You have\"></span>&nbsp;<span class=\"days-remaining\">{{vm.daysRemaining}}</span>&nbsp;<span class=\"days-remaining\"\n" +
    "			      translate=\"days\"></span>&nbsp;<span translate=\"left in your free trial.\"></span>\n" +
    "		</div>\n" +
    "		<a ng-if=\"vm.daysRemaining > 5\"\n" +
    "		   ng-href=\"/trial/{{vm.lang}}/purchase\"\n" +
    "		   class=\"col-md-4 btn btn-primary buy-now\"\n" +
    "		   translate=\"Buy Now\"></a>\n" +
    "		<div class=\"btn-row\"\n" +
    "		     ng-if=\"vm.daysRemaining <= 5\">\n" +
    "			<a ng-href=\"/trial/{{vm.lang}}/purchase\"\n" +
    "			   class=\"btn btn-primary\"\n" +
    "			   translate=\"Buy Now\"></a>\n" +
    "			<button class=\"btn btn-secondary\"\n" +
    "			        ng-click=\"vm.extendTrial()\"\n" +
    "			        translate=\"Extend Trial\"></button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("dashboard/widget-templates/bm-common-articles.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/widget-templates/bm-common-articles.html",
    "<bm-common-articles id=\"bm-common-articles\">  </bm-common-articles>");
}]);

angular.module("dashboard/widget-templates/bm-help-widget.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/widget-templates/bm-help-widget.html",
    "<bm-help-widget id=\"bm-help-widget\"></bm-help-widget>");
}]);

angular.module("dashboard/widget-templates/bm-overview-widget.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/widget-templates/bm-overview-widget.html",
    "<bm-overview-widget id=\"onvio-overview\"></bm-overview-widget>");
}]);

angular.module("dashboard/widget-templates/bm-staff-availability-widget.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/widget-templates/bm-staff-availability-widget.html",
    "<bm-staff-availability-widget></bm-staff-availability-widget>");
}]);

angular.module("dashboard/widget-templates/bm-time-recap-widget.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/widget-templates/bm-time-recap-widget.html",
    "<bm-practice-widget id=\"bm-time-recap-widget\" widget=\"time-summary\"></bm-practice-widget>");
}]);

angular.module("dashboard/widget-templates/bmp-project-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/widget-templates/bmp-project-list.html",
    "<bmp-project-list\n" +
    "    bmp-project-list-name=\"'HomeDashboard.MyAssignmentsProjectList'\"\n" +
    "    bmp-project-list-projects-and-tasks-title=\"'Bluemoon.Core.Setup.ProjectsAndTasks.Header'\"\n" +
    "    bmp-project-list-projects-title=\"'Core.Captions.Project.ClassOther'\"\n" +
    "    bmp-project-list-tasks-title=\"'Core.Captions.Task.ClassOther'\"\n" +
    "    bmp-project-list-analytics-context=\"'homeDashboard_myAssignmentsWidget'\"\n" +
    "    bmp-project-list-style=\"'widget.staff'\">\n" +
    "</bmp-project-list>");
}]);

angular.module("dashboard/widgets/client-info/client-info-widget.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/widgets/client-info/client-info-widget.2js.html",
    "<div class=\"panel panel-default bm-widget client-info-widget\">\n" +
    "    <div class=\"panel-heading\">\n" +
    "        {{ widgetData.title }}\n" +
    "        <span class=\"glyphicons more\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"panel-body\">\n" +
    "        <div class=\"widget-title\">\n" +
    "            {{ widgetData.data.primaryContactExpanded.fullName }}\n" +
    "        </div>\n" +
    "        <div class=\"widget-content\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-4\">\n" +
    "                    <bm-profile-photo-select image=\"widgetData.data.userImage\" view-only=\"true\" initials=\"{{ userInitials }}\" shape=\"circle\"></bm-profile-photo-select>\n" +
    "                </div>\n" +
    "                <div class=\"col-sm-8\">\n" +
    "                    <ul class=\"list-group\">\n" +
    "                        <li class=\"list-group-item\" ng-repeat=\"email in ::widgetData.data.primaryContactExpanded.emailAddresses\">\n" +
    "                            <div class=\"widget-list-label\">{{ email.emailType.name }} email</div>\n" +
    "                            <a href=\"mailto:{{ email.emailAddress }}\">{{ email.emailAddress }}</a>\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("dashboard/widgets/drive/drive-usage-widget.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("dashboard/widgets/drive/drive-usage-widget.2js.html",
    "<div class=\"panel panel-default bm-widget\">\n" +
    "    <div class=\"panel-heading\">\n" +
    "        <strong>{{ widgetData.title }}</strong>\n" +
    "        <span class=\"glyphicon glyphicon-remove\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"panel-body\">\n" +
    "        Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n" +
    "        Quisque tempor elementum leo sit amet posuere. Donec facilisis risus et sem luctus viverra.\n" +
    "    </div>\n" +
    "    <ul class=\"list-group\">\n" +
    "        <li class=\"list-group-item\">value 1</li>\n" +
    "        <li class=\"list-group-item\">value 2</li>\n" +
    "        <li class=\"list-group-item\">value 3</li>\n" +
    "        <li class=\"list-group-item\">value 4</li>\n" +
    "        <li class=\"list-group-item\">value 5</li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/all-docs/masterlist/all-docs-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/all-docs/masterlist/all-docs-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"all-docs-master-container\">\n" +
    "        <div dms-toolbar></div>\n" +
    "\n" +
    "        <dms-all-docs-grid></dms-all-docs-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/clients/masterlist/client-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/clients/masterlist/client-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"client-master-container\">\n" +
    "        <div dms-toolbar container=\"container\" use-search-document-placeholder=\"true\" show-clients-combobox=\"true\">\n" +
    "        </div>\n" +
    "\n" +
    "        <dms-client-grid></dms-client-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/communications/actions/approve-add-edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/communications/actions/approve-add-edit.html",
    "<div dms-approval-add-edit request-id=\"ctrl.requestId\" approval-edit-mode=\"ctrl.approvalEditMode\" done=\"ctrl.returnToParent\" validate-contact-national-identity-on-focus=\"true\"></div>");
}]);

angular.module("documents/communications/actions/informational-add-edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/communications/actions/informational-add-edit.html",
    "<div dms-request-add-edit request-id=\"requestId\" is-edit-mode=\"isEditMode\" done=\"returnToParent\"></div>");
}]);

angular.module("documents/communications/actions/send-document-add-edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/communications/actions/send-document-add-edit.html",
    "<div dms-communication-send-document request-id=\"requestId\" approval-edit-mode=\"isEditMode\" done=\"returnToParent\" email-template-type='\"SendDocumentLinks\"'></div>");
}]);

angular.module("documents/communications/masterlist/communication-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/communications/masterlist/communication-master.html",
    "<div class=\"dms\">\n" +
    "\n" +
    "    <div id=\"dmsCommunicationsSplitterContainer\" bm-busy-loader=\"{offset:0}\">\n" +
    "        <dms-communications-grid-manager>\n" +
    "            <!--<bento-alert bento-alert-object=\"alerts\"></bento-alert>-->\n" +
    "\n" +
    "            <div\n" +
    "                bento-splitter-group\n" +
    "                event-tracking=\"onSplitterEvent(eventName)\"\n" +
    "                on-resize=\"onResizeEvent(data)\"\n" +
    "                is-left-collapsed=\"isLeftCollapsed\"\n" +
    "                left-width=\"400px\">\n" +
    "                <aside bento-splitter-group-left>\n" +
    "                    <div>\n" +
    "                        <dms-communications-grid-filter></dms-communications-grid-filter>\n" +
    "                    </div>\n" +
    "                </aside>\n" +
    "\n" +
    "                <section bento-splitter-group-main>\n" +
    "                    <dms-communications-grid></dms-communications-grid>\n" +
    "                </section>\n" +
    "            </div>\n" +
    "        </dms-communications-grid-manager>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ui-view></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/dms-main.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/dms-main.html",
    "<uib-tabset ng-if=\"dmsMain.showTabs()\" class=\"dms-main-tabset tabs-top\" active=\"dmsMain.activeIndex\">\n" +
    "\n" +
    "	<uib-tab ng-repeat=\"tab in dmsMain.tabs\"\n" +
    "		ng-click=\"tab.select()\" ng-show=\"tab.visible\" index=\"tab.index\">\n" +
    "		<uib-tab-heading>\n" +
    "			<i class=\"tab.icon\"></i>\n" +
    "			<span data-qe-id=\"{{tab.label}}\">\n" +
    "				{{tab.label | translate}}\n" +
    "			</span>\n" +
    "		</uib-tab-heading>\n" +
    "	</uib-tab>\n" +
    "\n" +
    "</uib-tabset>\n" +
    "<div ui-view></div>\n" +
    "");
}]);

angular.module("documents/files/file-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/files/file-view.html",
    "<div class=\"dms\">\n" +
    "\n" +
    "    <!-- FILE NAME TITLE -->\n" +
    "    <h2 ng-if=\"lock\">{{ fileName }}<span class=\"bento-icon-lock dms-lock-icon\" uib-tooltip=\"{{lockToolTip}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"></span></h2>\n" +
    "\n" +
    "    <h2 ng-if=\"!lock\">{{ fileName }}</h2>\n" +
    "\n" +
    "    <!-- BREADCRUMB -->\n" +
    "    <dms-nav-breadcrumb ng-if=\"canViewDocument\" container-type=\"{{container.itemType}}\" container-id=\"{{container.id}}\" collapse-length=\"3\" ng-cloak></dms-nav-breadcrumb>\n" +
    "\n" +
    "    <!-- TOOLBAR -->\n" +
    "    <dms-toolbar ng-if=\"canViewDocument\" buttons=\"buttons\" selection-id=\"documentView\" container=\"container\" show-search=\"false\" client-id=\"clientId\"></dms-toolbar>\n" +
    "\n" +
    "    <!-- DOCUMENT VIEWER -->\n" +
    "    <div bm-if-has-no-access=\"DMS_IFRAMEVIEWER\">\n" +
    "        <div ng-if=\"file\" id=\"previewWrapper\">\n" +
    "            <app-file-preview\n" +
    "                [use-pdf-tron]=\"false\"\n" +
    "                [annotations-allowed]=\"false\"\n" +
    "                [documents]=\"file\"\n" +
    "                [current-index]=\"0\"\n" +
    "                [hide-help]=\"true\"\n" +
    "                [hide-bookmarks]=\"false\"\n" +
    "                [hide-close]=\"true\"\n" +
    "                [hide-print]=\"false\">\n" +
    "            </app-file-preview>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- DOCUMENT VIEWER LEGACY -->\n" +
    "     <!-- TODO: DEPRECATE -->\n" +
    "    <div bm-if-has-access=\"DMS_IFRAMEVIEWER\">\n" +
    "        <div ng-if=\"canViewDocument\">\n" +
    "            <dms-document-view-pane src=\"{{downloadUrl}}\" mime-type=\"{{previewMimeType}}\"></dms-document-view-pane>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- NO DOCUMENT MESSAGE -->\n" +
    "    <div id=\"no-document\" ng-if=\"!file\">\n" +
    "        <p> {{'Bluemoon.DMS.Preview.NoDocument' | translate}} </p>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/folders/masterlist/folder-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/folders/masterlist/folder-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"folder-master-container\">\n" +
    "\n" +
    "        <div class=\"dms-header\">\n" +
    "            <div class=\"folder-client-dropdown\" ng-show=\"isClientDocuments\">\n" +
    "                <dms-clients-combobox bm-focus=\"true\" ng-model=\"contacts\" client-id=\"stateParams.clientId\" ng-required=\"true\" on-selected=\"clientSelected(item)\" view-client-details=\"true\" add-new-client=\"true\">\n" +
    "                </dms-clients-combobox>\n" +
    "            </div>\n" +
    "            <div class=\"folder-breadcrumb\">\n" +
    "                <dms-nav-breadcrumb\n" +
    "                    container-type=\"{{container.itemType}}\"\n" +
    "                    container-id=\"{{container.id}}\"\n" +
    "                    collapse-length=\"3\" ng-cloak>\n" +
    "                </dms-nav-breadcrumb>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <dms-document-grid-toolbar container=\"container\" client-id=\"stateParams.clientId\" show-column-chooser=\"true\" grid-columns=\"gridColumns\"></dms-document-grid-toolbar>\n" +
    "        <div dms-drag-over\n" +
    "            dms-drag-over-class=\"file-drop-over\"\n" +
    "            dms-drop\n" +
    "            dms-item=\"{{flatContainer}}\">\n" +
    "            <dms-document-grid\n" +
    "                container=\"container\"\n" +
    "                client-id=\"stateParams.clientId\"\n" +
    "                project-id=\"stateParams.projectId\"\n" +
    "                template-id=\"stateParams.templateId\"\n" +
    "                on-grid-initialized=\"gridInitialized(grid)\"\n" +
    "                tab-name=\"folder-templates\">\n" +
    "            </dms-document-grid>\n" +
    "        </div>\n" +
    "        <input id=\"dms-file-select\"\n" +
    "            type=\"file\"\n" +
    "            style=\"visibility:hidden\"\n" +
    "            ng-file-select=\"onFileSelect($files)\" multiple/>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/legacy-recents/masterlist/legacy-recents-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/legacy-recents/masterlist/legacy-recents-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"recents-master-container\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "\n" +
    "        <dms-legacy-recents-grid control=\"gridControlContainer\"></dms-legacy-recents-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/recents/masterlist/recents-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/recents/masterlist/recents-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"recents-master-container\">\n" +
    "        <!--<alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>-->\n" +
    "\n" +
    "        <dms-recents-grid control=\"gridControlContainer\"></dms-recents-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/recycle/masterlist/recycle-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/recycle/masterlist/recycle-view.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"recycle-master-container\" id=\"dmsRecycleSplitterContainer\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "        <dms-recycle-grid-manager ng-if=\"hasCurrentDevelopmentPermission\">\n" +
    "            <div\n" +
    "                bento-splitter-group\n" +
    "                is-left-collapsed=\"false\"\n" +
    "                left-width=\"{{leftWidth}}\"\n" +
    "                event-tracking=\"onSplitterEvent(eventName)\"\n" +
    "                class=\"recycle-bin-filter-splitter-group\">\n" +
    "                <aside bento-splitter-group-left>\n" +
    "                    <div>\n" +
    "                        <dms-recycle-grid-filter></dms-recycle-grid-filter>\n" +
    "                    </div>\n" +
    "                </aside>\n" +
    "                <section bento-splitter-group-main>\n" +
    "                    <dms-recycle-grid control=\"gridControlContainer\" selected-items=\"selectedGridItems\"></dms-recycle-grid>\n" +
    "                </section>\n" +
    "            </div>\n" +
    "        </dms-recycle-grid-manager>\n" +
    "        <dms-recycle-grid control=\"gridControlContainer\" selected-items=\"selectedGridItems\" ng-if=\"!hasCurrentDevelopmentPermission\"></dms-recycle-grid>\n" +
    "\n" +
    "    </div>\n" +
    "    <div ui-view></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/search/document-search-results.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/search/document-search-results.html",
    "<div class=\"dms dms-search\">\n" +
    "    <div class=\"search-master-container\">\n" +
    "\n" +
    "        <h1 class=\"no-top-margin\" translate=\"Bluemoon.DMS.SearchResults\"></h1>\n" +
    "\n" +
    "        <dms-nav-breadcrumb\n" +
    "            container-type=\"{{containerType}}\"\n" +
    "            container-id=\"{{containerId}}\"\n" +
    "            path-loaded-callback=\"breadcrumbPathCallback(path)\"\n" +
    "            collapse-length=\"1\" ng-cloak>\n" +
    "        </dms-nav-breadcrumb>\n" +
    "\n" +
    "        <dms-search-grid></dms-search-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/storage/masterlist/storage-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/storage/masterlist/storage-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"storage-master-container\">\n" +
    "        <uib-alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>\n" +
    "        <div class=\"dms-header\">\n" +
    "            <div class=\"storage-client-dropdown\">\n" +
    "                <dms-clients-combobox bm-focus=\"true\" ng-model=\"contacts\" client-id=\"clientId\" ng-required=\"true\" on-selected=\"clientSelected(item)\" view-client-details=\"true\" add-new-client=\"true\" >\n" +
    "                </dms-clients-combobox>\n" +
    "            </div>\n" +
    "            <div class=\"storage-breadcrumb\">\n" +
    "                <dms-nav-breadcrumb\n" +
    "                    container-type=\"Client\"\n" +
    "                    container-id=\"{{clientId}}\"\n" +
    "                    collapse-length=\"3\" ng-cloak>\n" +
    "                </dms-nav-breadcrumb>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div dms-toolbar container=\"container\" selection-id=\"storage\" buttons=\"buttons\" client-id=\"clientId\" show-grouping-toggle=\"true\">\n" +
    "        </div>\n" +
    "\n" +
    "        <dms-storage-grid\n" +
    "            get-grid-items=\"getGridItems\"\n" +
    "            client-id=\"clientId\"\n" +
    "            show-comments=\"true\"\n" +
    "            show-app=\"true\"\n" +
    "            show-date=\"true\"\n" +
    "            show-year=\"true\"\n" +
    "            show-shared=\"true\"\n" +
    "            show-default-for-clients=\"false\"\n" +
    "            is-tree-nav=\"false\"\n" +
    "            icon-service=\"iconService\">\n" +
    "        </dms-storage-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/templates/actions/add-edit-request-template-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/templates/actions/add-edit-request-template-master.html",
    "<div dms-request-template request-template-id=\"requestTemplateId\" is-edit-mode=\"isEditMode\" done=\"returnToParent\"></div>");
}]);

angular.module("documents/templates/masterlist/request-template-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/templates/masterlist/request-template-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"request-template-master-container\">\n" +
    "        <!--<uib-alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>-->\n" +
    "        <h1 class=\"no-top-margin\" translate=\"Onvio.DMS.Templates.RequestTemplates\"></h1>\n" +
    "\n" +
    "        <dms-request-templates-grid></dms-request-templates-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("documents/templates/masterlist/template-master.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/templates/masterlist/template-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"template-master-container\">\n" +
    "        <!--<uib-alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>-->\n" +
    "        <h1 class=\"no-top-margin\" translate=\"Bluemoon.DMS.SpecialFolders.Templates\"></h1>\n" +
    "\n" +
    "        <dms-toolbar show-search=\"false\" container=\"container\" selection-id=\"storage\" buttons=\"buttons\" show-column-chooser=\"false\"></dms-toolbar>\n" +
    "\n" +
    "        <dms-storage-grid\n" +
    "            get-grid-items=\"getGridItems\"\n" +
    "            show-shared=\"false\"\n" +
    "            show-comments=\"false\"\n" +
    "            show-app=\"false\"\n" +
    "            show-year=\"false\"\n" +
    "            show-date=\"false\"\n" +
    "            show-default-for-clients=\"true\"\n" +
    "            on-grid-initialized=\"gridInitialized(grid)\">\n" +
    "        </dms-storage-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/templates/typeahead-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/templates/typeahead-template.html",
    "<!--<pre ng-bind=\"match | json\"></pre>-->\n" +
    "<div class=\"typeahead-group-header\" style=\"padding:10px;width:700px;font-weight:bold;background-color:#37383D;color:white;\" ng-if=\"match.model.firstInGroup\">\n" +
    "	<span ng-bind=\"match.model.group\"></span>\n" +
    "</div>\n" +
    "<a style=\"display:block;width: 100%;padding:10px;\">\n" +
    "	<span ng-bind=\"match.model.displayAs\" style=\"display:inline-block;width:33%\"></span>\n" +
    "	<span ng-bind=\"match.model.emailAddresses[0].emailAddress\" style=\"display:inline-block;width:33%\"></span>\n" +
    "</a>");
}]);

angular.module("documents/tree-view/tree-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("documents/tree-view/tree-view.html",
    "<div id=\"dms-documents-master\">\n" +
    "\n" +
    "    <!-- TOOLBAR/CLIENT DROPDOWN -->\n" +
    "    <div dms-toolbar\n" +
    "        container=\"ctrl.toolbarContainer\"\n" +
    "        id=\"dmsDocumentsMasterToolbar\"\n" +
    "        clients-combobox-placeholder=\"{{'DMS.ClientMasterTree.SelectClient' | translate}}\"\n" +
    "        show-clients-combobox=\"ctrl.isClientDocuments\"\n" +
    "        show-read-state-filter=\"ctrl.showReadStateFilter && ctrl.isClientDocuments && !ctrl.isRootFolder\"\n" +
    "        show-search=\"true\"\n" +
    "        client-id=\"ctrl.selected.drawerId\"\n" +
    "        is-tree-nav=\"true\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div id=\"dmsDocumentsSplitterContainer\">\n" +
    "        <div bento-splitter-group\n" +
    "            left-width=\"{{ctrl.treePaneWidth}}\"\n" +
    "            resizable=\"true\"\n" +
    "            event-tracking=\"ctrl.onSplitterResize()\"\n" +
    "            is-left-collapsed=\"ctrl.isLeftCollapsed\"\n" +
    "            id=\"documentsTreeNavSplitter\">\n" +
    "\n" +
    "            <!-- TREE PANE -->\n" +
    "            <aside bento-splitter-group-left>\n" +
    "                <div class=\"ng-bento\">\n" +
    "                    <bdc-document-tree-pane\n" +
    "                        ng-if=\"!ctrl.isLeftCollapsed\"\n" +
    "                        [selected]=\"ctrl.navSelection\"\n" +
    "                        [get-href]=\"ctrl.getHrefForItem\"\n" +
    "                        (selected-change)=\"ctrl.onNavSelectionChange($event)\"\n" +
    "                        [group-projects-by]=\"ctrl.groupProjectsBy\"\n" +
    "                    ></bdc-document-tree-pane>\n" +
    "                </div>\n" +
    "            </aside>\n" +
    "\n" +
    "            <!-- DETAIL PANE -->\n" +
    "            <section\n" +
    "                bento-splitter-group-main\n" +
    "                ng-class=\"[{noscroll: ctrl.previewDocs && ctrl.previewDocs.length > 0}]\">\n" +
    "                <!-- DOCUMENT PREVIEW -->\n" +
    "                <app-file-preview\n" +
    "                    ng-if=\"ctrl.viewerInitialized\"\n" +
    "                    ng-show=\"!!ctrl.previewDocs && ctrl.previewDocs.length > 0\"\n" +
    "                    class=\"detail-pane-preview\"\n" +
    "                    [documents]=\"ctrl.previewDocs\"\n" +
    "                    [current-index]=\"ctrl.previewCurrentIndex\"\n" +
    "                    [close-callback]=\"ctrl.closePreview\"\n" +
    "                    [is-current-development]=\"ctrl.isCurrentDev\"\n" +
    "                    [drawer]=\"ctrl.selected.drawer\"\n" +
    "                    [use-pdf-tron]=\"true\"\n" +
    "                    [annotations-allowed]=\"ctrl.annotationsAllowed\"\n" +
    "                    [finalization-function-container]=\"ctrl.finalizationFunctionContainer\"\n" +
    "                    [show-download-modal]=\"ctrl.showDownloadModal\"\n" +
    "                    [hide-document-preview]=\"ctrl.hideDocumentPreview\"\n" +
    "                    [toolbar-services-facade]=\"ctrl.toolbarServicesFacade\"\n" +
    "                    (document-nav)=\"ctrl.onDocumentNav($event)\"\n" +
    "                    (loaded)=\"ctrl.resizePreview()\"\n" +
    "                    (download-modal-closed)=\"ctrl.onDownloadModalClosed()\">\n" +
    "                </app-file-preview>\n" +
    "                <documents-detail-pane\n" +
    "                    ng-if=\"!ctrl.showNewGrid\"\n" +
    "                    ng-hide=\"!!ctrl.previewDocs && ctrl.previewDocs.length > 0 && hideDocumentPreview\"\n" +
    "                    selected=\"ctrl.selected\"\n" +
    "                    get-href=\"ctrl.getHref(selected)\"\n" +
    "                    selected-change=\"ctrl.onSelectedChange(newValue)\"\n" +
    "                    show-shared=\"!!ctrl.isClientDocuments\"\n" +
    "                    is-client=\"ctrl.isRootFolder\"\n" +
    "                    root-drawer=\"ctrl.selected.drawer\"\n" +
    "                    tab-name=\"{{ctrl.getTabName()}}\">\n" +
    "                </documents-detail-pane>\n" +
    "                <div class=\"ng-bento\">\n" +
    "                    <bdc-document-grid-pane\n" +
    "                        ng-if=\"ctrl.showNewGrid\"\n" +
    "                        [selection]=\"ctrl.navSelection\"\n" +
    "                        [group-projects-by]=\"ctrl.groupProjectsBy\"\n" +
    "                        [get-href]=\"ctrl.getHrefForItem\"\n" +
    "                        (item-clicked)=\"ctrl.onGridRowClicked($event)\"\n" +
    "                        (toolbar-button-clicked)=\"ctrl.onToolbarButtonClicked($event)\"\n" +
    "                    ></bdc-document-grid-pane>\n" +
    "                </div>\n" +
    "            </section>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <bento-alert bento-alert-object=\"alerts\"></bento-alert>\n" +
    "</div>\n" +
    "");
}]);

angular.module("firm-dashboard/firm-dashboard.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("firm-dashboard/firm-dashboard.html",
    "<div class=\"client-dashboard-background\">\n" +
    "    <app-firm-dash [background]=\"'client-dashboard-'+ $ctrl.backgroundName\" [is-loading]=\"$ctrl.isLoading\">\n" +
    "        <div id=\"wip-summary\" data-qe-id=\"firm-dashboard-wip-summary\">\n" +
    "            <bm-practice-widget widget=\"wip-summary\" context=\"$ctrl.context\" identifier=\"firm\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"ar-summary\" data-qe-id=\"firm-dashboard-ar-summary\">\n" +
    "            <bm-practice-widget widget=\"accounts-receivable-summary\" context=\"$ctrl.context\" identifier=\"firm\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"wip-agings\" data-qe-id=\"firm-dashboard-wip-agings\">\n" +
    "            <bm-practice-widget widget=\"agings\" type=\"wip\" context=\"$ctrl.context\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"ar-agings\" data-qe-id=\"firm-dashboard-ar-agings\">\n" +
    "            <bm-practice-widget widget=\"agings\" type=\"ar\" context=\"$ctrl.context\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "        <div id=\"key-totals\" data-qe-id=\"firm-dashboard-key-totals\">\n" +
    "            <bm-practice-widget widget=\"key-totals\" context=\"$ctrl.context\"></bm-practice-widget>\n" +
    "        </div>\n" +
    "    </app-firm-dash>\n" +
    "</div>\n" +
    "");
}]);

angular.module("nav/bm-staff-nav.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("nav/bm-staff-nav.html",
    "<bm-nav sync-doc-title=\"true\">\n" +
    "  <ul app-nav-toggle-state role=\"menubar\" bm-if-perm-some=\"['Applications.Onvio', 'Applications.OnvioDocumentsBasic']\" class=\"bm-staff-nav-list\">\n" +
    "    <li role=\"none\" bm-if-perm=\"Applications.Onvio\">\n" +
    "      <a role=\"menuitem\" href=\"#/\" class=\"bm-staff-nav-menu-expand\">\n" +
    "        <span translate=\"Bluemoon.Shell.Navigation.Home\" data-qe-id=\"Bluemoon.Shell.Navigation.Home\"></span>\n" +
    "      </a>\n" +
    "    </li>\n" +
    "    <!-- Client & Firm Dashboard links (when only one is available) -->\n" +
    "    <li role=\"none\" id=\"firm-dashboard\" ng-if=\"$ctrl.showFirmDashboard && !$ctrl.showClientDashboard\">\n" +
    "      <a role=\"menuitem\" href=\"#/firm-dashboard\" translate=\"Bluemoon.Shell.Navigation.FirmDashboard\" data-qe-id=\"Bluemoon.Shell.Navigation.FirmDashboard\"></a>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"client-dashboard\" ng-if=\"$ctrl.showClientDashboard && !$ctrl.showFirmDashboard\">\n" +
    "      <a role=\"menuitem\" href=\"#/client-dashboard\" translate=\"Bluemoon.Shell.Navigation.ClientDashboard\" data-qe-id=\"Bluemoon.Shell.Navigation.ClientDashboard\"></a>\n" +
    "    </li>\n" +
    "    <!-- Client & Form Dashboard dropdown (when both are available) -->\n" +
    "    <li role=\"none\" id=\"dashboard\" ng-hide=\"!$ctrl.showFirmDashboard || !$ctrl.showClientDashboard\">\n" +
    "        <a role=\"menuitem\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "        <span translate=\"Bluemoon.Shell.Navigation.Dashboard\" data-qe-id=\"Bluemoon.Shell.Navigation.Dashboard\"></span>\n" +
    "        <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "      </a>\n" +
    "      <ul role=\"menu\" id=\"dashboard-dropdown\">\n" +
    "        <li role=\"none\" id=\"firm-dashboard\" ng-if=\"$ctrl.showFirmDashboard\">\n" +
    "          <a role=\"menuitem\" href=\"#/firm-dashboard\" translate=\"Bluemoon.Shell.Navigation.FirmDashboard\" data-qe-id=\"Bluemoon.Shell.Navigation.FirmDashboard\"></a>\n" +
    "        </li>\n" +
    "        <li role=\"none\" id=\"client-dashboard\" ng-if=\"$ctrl.showClientDashboard\">\n" +
    "          <a role=\"menuitem\" href=\"#/client-dashboard\" translate=\"Bluemoon.Shell.Navigation.ClientDashboard\" data-qe-id=\"Bluemoon.Shell.Navigation.ClientDashboard\"></a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </li>\n" +
    "    <!-- BR Messenger -->\n" +
    "    <li role=\"none\" id=\"br-messenger\" ng-if=\"$ctrl.showBRMessenger\">\n" +
    "      <a role=\"menuitem\" ng-href=\"{{ $ctrl.brMessengerURL }}\" translate=\"Bluemoon.Shell.Navigation.BRMessenger\" data-qe-id=\"Bluemoon.Shell.Navigation.BRMessenger\" target=\"_blank\" rel=\"noreferrer noopener\"></a>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"documents\" bm-if-perm=\"OnvioDrive.Documents\">\n" +
    "      <a role=\"menuitem\" href=\"#/documents\" translate=\"Bluemoon.Shell.Navigation.Documents\" data-qe-id=\"Bluemoon.Shell.Navigation.Documents\"></a>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"costs\" bm-if-perm=\"BRCustos.AllPermissions\">\n" +
    "      <a role=\"menuitem\" href=\"#/costs\" translate=\"Bluemoon.Shell.Navigation.Costs\" data-qe-id=\"Bluemoon.Shell.Navigation.Costs\"></a>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"projects\" bm-if-perm=\"ProjectManagement.Projects\">\n" +
    "      <a role=\"menuitem\" href=\"#/setup/core\" bm-href-aliases=\"#/setup/projects\" translate=\"Bluemoon.Shell.Navigation.Projects\" data-qe-id=\"Bluemoon.Shell.Navigation.Projects\"></a>\n" +
    "    </li>\n" +
    "    <li role=\"none\" bm-if-perm-every=\"['Internal.FE_Rebuild', 'ProjectManagement.Projects']\">\n" +
    "        <a role=\"menuitem\" href=\"#/preview/projects\" data-qe-id=\"Bluemoon.Shell.Navigation.ProjectsNew\">\n" +
    "            {{ 'Bluemoon.Shell.Navigation.Projects' | translate }} (New look!)\n" +
    "        </a>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"time-and-expense\" ng-if=\"$ctrl.showTimeAndExpenses && !$ctrl.showBilling  && !$ctrl.showReceiptsAndAdjustments\">\n" +
    "      <a role=\"menuitem\" href=\"#/time-and-expense\" translate=\"Bluemoon.Shell.Navigation.TimeAndExpense\" data-qe-id=\"Bluemoon.Shell.Navigation.TimeAndExpense\"></a>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"timeAndBilling\" ng-if=\"$ctrl.showBilling  || $ctrl.showReceiptsAndAdjustments\">\n" +
    "      <a role=\"menuitem\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "        <span translate=\"Bluemoon.Shell.Navigation.TimeAndBilling\" data-qe-id=\"Bluemoon.Shell.Navigation.TimeAndBilling\"></span>\n" +
    "        <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "      </a>\n" +
    "      <ul role=\"menu\">\n" +
    "        <li role=\"none\" bm-if-perm=\"TimeAndBilling.TimeAndExpense\">\n" +
    "          <a role=\"menuitem\" href=\"#/time-and-expense\" translate=\"Bluemoon.Shell.Navigation.TimeAndExpense\" data-qe-id=\"Bluemoon.Shell.Navigation.TimeAndExpense\"></a>\n" +
    "        </li>\n" +
    "        <li role=\"none\" bm-if-perm-some=\"['TimeAndBilling.Billing', 'TimeAndBilling.ReviewInvoices', 'TimeAndBilling.PrintStatements', 'TimeAndBilling.LateFees', 'TimeAndBilling.FixedFeeBilling']\">\n" +
    "          <a role=\"menuitem\" href=\"#/billing\" translate=\"Bluemoon.Billing.Navigation.Billing\" data-qe-id=\"Bluemoon.Billing.Navigation.Billing\"></a>\n" +
    "        </li>\n" +
    "        <li role=\"none\" bm-if-perm=\"TimeAndBilling.ReceiptAndAdjustment\">\n" +
    "          <a role=\"menuitem\" href=\"#/receipt-and-adjustment\" translate=\"Bluemoon.Billing.Navigation.ReceiptAndAdjustment\" data-qe-id=\"Bluemoon.Billing.Navigation.ReceiptAndAdjustment\"></a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"br-api\" bm-if-has-access=\"BR_APIMenu\">\n" +
    "      <a  role=\"menuitem\" href=\"/br-api-integration/#/\" target=\"_blank\" translate=\"Bluemoon.Shell.Navigation.BRApi\" data-qe-id=\"Bluemoon.Shell.Navigation.BRApi\"></a>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"reports-nav-bar-button\" bm-if-perm-some=\"['Reports.OnvioUsage','Reports.FirmManagement','TimeAndBilling.InternalComponent','Internal.Internal','Reports.BREmployeePortal']\">\n" +
    "      <a role=\"menuitem\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "        <span translate=\"Bluemoon.Shell.Navigation.Reports\" data-qe-id=\"Bluemoon.Shell.Navigation.Reports\"></span>\n" +
    "        <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "      </a>\n" +
    "      <ul role=\"menu\">\n" +
    "        <li role=\"none\" ng-if=\"$ctrl.showFirmReports\">\n" +
    "          <a role=\"menuitem\" href=\"#/firm-management-reports\" bm-href-aliases=\"#/firm-management-reports-options,#/firm-management-reports-options-add\" translate=\"Bluemoon.Shell.Navigation.FirmManagementReports\" data-qe-id=\"Bluemoon.Shell.Navigation.FirmManagementReports\"></a>\n" +
    "        </li>\n" +
    "        <li role=\"none\" bm-if-perm=\"Internal.Internal\">\n" +
    "          <a role=\"menuitem\" href=\"#/firm-management-reports-tree\" translate=\"Bluemoon.Shell.Navigation.FirmManagementReports.tree\" data-qe-id=\"Bluemoon.Shell.Navigation.FirmManagementReports\"></a>\n" +
    "        </li>\n" +
    "        <li role=\"none\" bm-if-perm=\"Reports.OnvioUsage\">\n" +
    "          <a role=\"menuitem\" href=\"#/onvio-usage\" translate=\"Bluemoon.Shell.Navigation.OnvioUsage\" data-qe-id=\"Bluemoon.Shell.Navigation.OnvioUsage\"></a>\n" +
    "        </li>\n" +
    "        <li role=\"none\" bm-if-perm=\"Reports.BREmployeePortal\">\n" +
    "          <a ng-if=\"$ctrl.showReportEmployee\" role=\"menuitem\" href=\"#/employee-portal-documents\" translate=\"Bluemoon.Shell.Navigation.EmployeePortalDocuments\" data-qe-id=\"Bluemoon.Shell.Navigation.EmployeePortalDocuments\"></a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </li>\n" +
    "    <li role=\"none\" id=\"bm-setup\" bm-if-perm-some=\"$ctrl.setupPermissions\">\n" +
    "      <a role=\"menuitem\" aria-haspopup=\"true\" aria-expanded=\"false\" id=\"setup-menu\" class=\"bm-staff-nav-menu-expand\">\n" +
    "        <span translate=\"Bluemoon.Shell.Navigation.Setup\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup\"></span>\n" +
    "        <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "      </a>\n" +
    "      <ul role=\"menu\" class=\"navmore-flex\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup.Menu\" id=\"menus\">\n" +
    "        <li role=\"menu\" bm-if-perm-some=\"['OnvioSetup.Clients','OnvioSetup.Staff','OnvioSetup.Contacts','OnvioSetup.ContactCategories']\">\n" +
    "          <a role=\"none\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "            <span translate=\"Bluemoon.Shell.Navigation.Setup.Contacts\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup.Contacts\"></span>\n" +
    "            <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "            <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "            </a>\n" +
    "          <ul role=\"group\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Setup.Contacts' | translate }}\">\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.Clients\">\n" +
    "              <a role=\"menuitem\" bm-if-has-no-access=\"BR_DisableSetupOptions\" href=\"#/setup/clients\" translate=\"Bluemoon.Shell.Navigation.Clients\" data-qe-id=\"Bluemoon.Shell.Navigation.Clients\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.Staff\">\n" +
    "              <a role=\"menuitem\" ng-show=\"!$ctrl.hasLicenseForBrazilStaffPermissionGroup\" href=\"#/setup/staff\" translate=\"Bluemoon.Shell.Navigation.Staff\" data-qe-id=\"Bluemoon.Shell.Navigation.Staff\"></a>\n" +
    "              <a role=\"menuitem\" ng-show=\"$ctrl.hasLicenseForBrazilStaffPermissionGroup\" href=\"#/br/company-staff/staff\" translate=\"Bluemoon.Shell.Navigation.FirmUsers\" data-qe-id=\"Bluemoon.Shell.Navigation.FirmUsers\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.Contacts\">\n" +
    "              <a role=\"menuitem\" bm-if-has-no-access=\"BR_DisableSetupOptions\" href=\"#/setup/contacts\" translate=\"Bluemoon.Shell.Navigation.Contacts\" data-qe-id=\"Bluemoon.Shell.Navigation.Contacts\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm-every=\"['OnvioSetup.ContactCategories','TimeAndBilling.InternalComponent']\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/contact-categories\" translate=\"Bluemoon.Shell.Navigation.ContactCategories\" data-qe-id=\"Bluemoon.Shell.Navigation.ContactCategories\"></a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </li>\n" +
    "        <li role=\"menu\" bm-if-perm=\"BRCustos.AllPermissions\">\n" +
    "          <a role=\"none\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "              <span translate=\"Bluemoon.Shell.Navigation.Setup.Models\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup.Models\"></span></a>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "          <ul role=\"group\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Setup.Models' | translate }}\">\n" +
    "            <li role=\"none\" bm-if-perm=\"BRCustos.AllPermissions\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/models\" translate=\"Bluemoon.Shell.Navigation.CostsSetup\" data-qe-id=\"Bluemoon.Shell.Navigation.CostsSetup\"></a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </li>\n" +
    "        <li role=\"menu\" bm-if-perm-some=\"['OnvioSetup.Firm','OnvioSetup.SecurityGroups','OnvioDrive.Templates','OnvioSetup.Offices','OnvioSetup.Departments','TimeAndBilling.StandardText']\">\n" +
    "          <a role=\"none\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "              <span translate=\"Bluemoon.Shell.Navigation.Setup.Firm\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup.Firm\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "            </a>\n" +
    "          <ul role=\"group\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Setup.Firm' | translate }}\">\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.Firm\">\n" +
    "              <div bm-if-has-access=\"HideFERebuild_FirmSettings\">\n" +
    "                <a role=\"menuitem\" bm-if-has-no-access=\"BR_DisableSetupOptions\" href=\"#/setup/firm\" translate=\"Bluemoon.Shell.Navigation.Firm\" data-qe-id=\"Bluemoon.Shell.Navigation.Firm\"></a>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm-some=\"['OnvioSetup.Firm','OnvioSetup.Departments','OnvioSetup.Offices']\">\n" +
    "              <a role=\"menuitem\" bm-if-has-no-access=\"HideFERebuild_FirmSettings\" href=\"#/preview/setup/firm-settings\" data-qe-id=\"Bluemoon.Shell.Navigation.FirmSettingsNew\">\n" +
    "                {{ 'Bluemoon.Shell.Navigation.Firm' | translate }}\n" +
    "              </a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.SecurityGroups\">\n" +
    "              <a role=\"menuitem\" ng-show=\"!$ctrl.hasLicenseForBrazilStaffPermissionGroup\" href=\"#/setup/permission-groups\" translate=\"Bluemoon.Shell.Navigation.SecurityGroups\" data-qe-id=\"Bluemoon.Shell.Navigation.SecurityGroups\"></a>\n" +
    "              <a role=\"menuitem\" ng-show=\"$ctrl.hasLicenseForBrazilStaffPermissionGroup\" href=\"#/br/permissions-group/group\" translate=\"Bluemoon.Shell.Navigation.SecurityGroups\" data-qe-id=\"Bluemoon.Shell.Navigation.SecurityGroups\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioDrive.Templates\">\n" +
    "              <a role=\"menuitem\" bm-if-has-no-access=\"DMS_HideFolderTemplateManagement\" ng-href=\"#/documents/templates\" translate=\"Bluemoon.Shell.Navigation.DocumentsTemplates\" data-qe-id=\"Bluemoon.Shell.Navigation.DocumentsTemplates\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioDrive.ReqTemplateEdit\">\n" +
    "              <a role=\"menuitem\" ng-href=\"#/documents/request-templates\" translate=\"Bluemoon.Shell.Navigation.RequestTemplates\" data-qe-id=\"Bluemoon.Shell.Navigation.RequestTemplates\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.Offices\">\n" +
    "              <a role=\"menuitem\" bm-if-has-access=\"HideFERebuild_FirmSettings\" href=\"#/setup/offices\" translate=\"Bluemoon.Shell.Navigation.Offices\" data-qe-id=\"Bluemoon.Shell.Navigation.Offices\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.Departments\">\n" +
    "              <a role=\"menuitem\" bm-if-has-access=\"HideFERebuild_FirmSettings\" ng-show=\"!$ctrl.showBRDepartments\" href=\"#/setup/departments\" translate=\"Bluemoon.Shell.Navigation.Departments\" data-qe-id=\"Bluemoon.Shell.Navigation.Departments\"></a>\n" +
    "              <a role=\"menuitem\" bm-if-has-access=\"HideFERebuild_FirmSettings\" ng-show=\"$ctrl.showBRDepartments\" href=\"#/setup/br-departments\" translate=\"Bluemoon.Shell.Navigation.Departments\" data-qe-id=\"Bluemoon.Shell.Navigation.Departments\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"TimeAndBilling.StandardText\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/standard-text\" translate=\"Bluemoon.Shell.Navigation.StandardText\" data-qe-id=\"Bluemoon.Shell.Navigation.StandardText\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.CustomFields\" id=\"custom-fields\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/custom-fields\" translate=\"Bluemoon.Shell.Navigation.CustomFields\" data-qe-id=\"Bluemoon.Shell.Navigation.CustomFields\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.SendClientReminders\">\n" +
    "              <a role=\"menuitem\" href=\"#/preview/setup/send-client-reminders\" translate=\"Bluemoon.Shell.Navigation.ClientReminders\" data-qe-id=\"Bluemoon.Shell.Navigation.ClientReminders\"></a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </li>\n" +
    "        <li role=\"menu\" bm-if-perm-some=\"['OnvioSetup.Activities','OnvioSetup.ActivityCategories','OnvioSetup.EngagementTemplates','OnvioSetup.EngagementCategories','OnvioSetup.StaffLevels','OnvioSetup.StaffRateDescriptions']\">\n" +
    "          <a role=\"none\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "              <span translate=\"Bluemoon.Shell.Navigation.Setup.TimeEntry\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup.TimeEntry\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "            </a>\n" +
    "          <ul role=\"group\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Setup.TimeEntry' | translate }}\">\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.Activities\">\n" +
    "              <a role=\"menuitem\" ng-if=\"$ctrl.hideNewActivity\" href=\"#/setup/activities\" translate=\"Bluemoon.Shell.Navigation.Activities\" data-qe-id=\"Bluemoon.Shell.Navigation.Activities\"></a>\n" +
    "\n" +
    "              <a role=\"menuitem\" ng-if=\"!$ctrl.hideNewActivity\"  href=\"#/preview/setup/activity\" data-qe-id=\"Bluemoon.Shell.Navigation.ActivitiesNew\">\n" +
    "                {{ 'Bluemoon.Shell.Navigation.Activities' | translate }}\n" +
    "            </a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm-every=\"['OnvioSetup.ActivityCategories']\">\n" +
    "              <a role=\"menuitem\" ng-if=\"$ctrl.hideNewActivityCategory\" href=\"#/setup/activity-categories\" translate=\"Bluemoon.Shell.Navigation.ActivityCategories\" data-qe-id=\"Bluemoon.Shell.Navigation.ActivityCategories\"></a>\n" +
    "\n" +
    "              <a role=\"menuitem\" ng-if=\"!$ctrl.hideNewActivityCategory\"  href=\"#/preview/setup/activity-category\" data-qe-id=\"Bluemoon.Shell.Navigation.ActivityCategoriesNew\">\n" +
    "                {{ 'Bluemoon.Shell.Navigation.ActivityCategories' | translate }}\n" +
    "            </a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.EngagementTemplates\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/engagement-templates\" translate=\"Bluemoon.Shell.Navigation.EngagementTemplates\" data-qe-id=\"Bluemoon.Shell.Navigation.EngagementTemplates\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.EngagementCategories\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/engagement-categories\" translate=\"Bluemoon.Shell.Navigation.EngagementCategories\" data-qe-id=\"Bluemoon.Shell.Navigation.EngagementCategories\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.StaffLevels\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/staff-levels\" translate=\"Bluemoon.Shell.Navigation.EmployeeLevels\" data-qe-id=\"Bluemoon.Shell.Navigation.EmployeeLevels\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.StaffRateDescriptions\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/staff-rate-descriptions\" translate=\"Bluemoon.Shell.Navigation.EmployeeRateDescriptions\" data-qe-id=\"Bluemoon.Shell.Navigation.EmployeeRateDescriptions\"></a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </li>\n" +
    "        <li role=\"menu\" bm-if-perm-some=\"['OnvioSetup.FixedFeeTemplates','OnvioSetup.FormatTemplates','OnvioSetup.LateFeeTemplates','OnvioSetup.BankAccounts','OnvioSetup.TaxRates','OnvioSetup.TaxGroups']\">\n" +
    "          <a role=\"none\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "              <span translate=\"Bluemoon.Shell.Navigation.Setup.BillingAndAr\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup.BillingAndAr\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "            </a>\n" +
    "          <ul role=\"group\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Setup.BillingAndAr' | translate }}\">\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.FixedFeeTemplates\">\n" +
    "              <a role=\"menuitem\" ng-href=\"#/setup/fixed-fee-templates\" translate=\"Bluemoon.Shell.Navigation.FixedFeeTemplates\" data-qe-id=\"Bluemoon.Shell.Navigation.FixedFeeTemplates\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.FormatTemplates\">\n" +
    "              <a role=\"menuitem\" href=\"#/format-templates/invoice-formats\" translate=\"Bluemoon.Shell.Navigation.FormatTemplates\" data-qe-id=\"Bluemoon.Shell.Navigation.FormatTemplates\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.FormatTemplates\">\n" +
    "              <a role=\"menuitem\" href=\"#/format-templates/statement-formats\" translate=\"Bluemoon.Shell.Navigation.StatementFormats\" data-qe-id=\"Bluemoon.Shell.Navigation.StatementFormats\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.LateFeeTemplates\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/late-fees\" translate=\"Bluemoon.Shell.Navigation.LateFeeTemplates\" data-qe-id=\"Bluemoon.Shell.Navigation.LateFeeTemplates\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.BankAccounts\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/bank-accounts\" translate=\"Bluemoon.Shell.Navigation.BankAccounts\" data-qe-id=\"Bluemoon.Shell.Navigation.BankAccounts\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.TaxRates\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/taxrates\" translate=\"Bluemoon.Shell.Navigation.TaxRates\" data-qe-id=\"Bluemoon.Shell.Navigation.TaxRates\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.TaxGroups\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/taxgroups\" translate=\"Bluemoon.Shell.Navigation.TaxGroups\" data-qe-id=\"Bluemoon.Shell.Navigation.TaxGroups\"></a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </li>\n" +
    "        <li role=\"menu\" bm-if-perm-some=\"['OnvioSetup.ClientNotifications','OnvioSetup.Appearances', 'OnvioSetup.OnvioSecurity']\">\n" +
    "          <a role=\"none\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "              <span translate=\"Bluemoon.Shell.Navigation.Setup.Portal\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup.Portal\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "            </a>\n" +
    "          <ul role=\"group\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Setup.Portal' | translate }}\">\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.OnvioSecurity\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/setting-security\" translate=\"Bluemoon.Shell.Navigation.SettingSecurity\" data-qe-id=\"Bluemoon.Shell.Navigation.SettingSecurity\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.ClientNotifications\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/client-notifications\" translate=\"Bluemoon.Shell.Navigation.ClientNotifications\" data-qe-id=\"Bluemoon.Shell.Navigation.ClientNotifications\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm=\"OnvioSetup.Appearances\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/themes\" translate=\"Bluemoon.Shell.Navigation.BluemoonSite\" data-qe-id=\"Bluemoon.Shell.Navigation.BluemoonSite\"></a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </li>\n" +
    "        <li role=\"menu\" ng-if=\"$ctrl.showImports || $ctrl.showMigrations\">\n" +
    "          <a role=\"none\"  aria-haspopup=\"true\" aria-expanded=\"false\" class=\"bm-staff-nav-menu-expand\">\n" +
    "              <span translate=\"Bluemoon.Shell.Navigation.Setup.Utilities\" data-qe-id=\"Bluemoon.Shell.Navigation.Setup.Utilities\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-up\"></span>\n" +
    "              <span class=\"glyphicon glyphicon-chevron-down\"></span>\n" +
    "            </a>\n" +
    "          <ul role=\"group\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Setup.Utilities' | translate }}\">\n" +
    "            <li role=\"none\" ng-if=\"$ctrl.showOldMigrationsLink\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/migration-results\" translate=\"Bluemoon.Shell.Navigation.MigrationResults\" data-qe-id=\"Bluemoon.Shell.Navigation.MigrationResults\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" bm-if-perm-every=\"['OnvioSetup.MigrationDashboard', 'OnvioSetup.MigrateData']\">\n" +
    "                <a role=\"menuitem\" href=\"#/preview/setup/migrations\" bm-if-perm=\"MigrationDashboard.NewExperience\" data-qe-id=\"Bluemoon.Shell.Navigation.MigrationsNew\">\n" +
    "                    {{ 'Bluemoon.Shell.Navigation.Migrations' | translate }}\n" +
    "                </a>\n" +
    "                <a role=\"menuitem\" href=\"#/setup/migrations\" bm-if-not-perm=\"MigrationDashboard.NewExperience\" data-qe-id=\"Bluemoon.Shell.Navigation.Migrations\">\n" +
    "                    {{ 'Bluemoon.Shell.Navigation.Migrations' | translate }}\n" +
    "                </a>\n" +
    "              </li>\n" +
    "            <li role=\"none\" bm-if-has-access=\"MigrationResults\">\n" +
    "              <a role=\"menuitem\" bm-if-perm=\"OnvioSetup.DataServices\" href=\"#/setup/import-export-test\" translate=\"Bluemoon.Shell.Navigation.ImportExportData\" data-qe-id=\"Bluemoon.Shell.Navigation.ImportExportData\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" ng-if=\"$ctrl.showImports\">\n" +
    "              <a role=\"menuitem\" bm-if-perm=\"OnvioSetup.ImportWIP\" href=\"#/setup/import-wip-transactions\" translate=\"Bluemoon.Shell.Navigation.ImportWIPTransactions\" data-qe-id=\"Bluemoon.Shell.Navigation.ImportWIPTransactions\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" ng-if=\"$ctrl.showImports\">\n" +
    "              <a role=\"menuitem\" bm-if-perm=\"OnvioSetup.ImportLedgerItems\" href=\"#/setup/import-ledger\" translate=\"Bluemoon.Shell.Navigation.ImportLedger\" data-qe-id=\"Bluemoon.Shell.Navigation.ImportLedger\"></a>\n" +
    "            </li>\n" +
    "            <li role=\"none\" ng-if=\"$ctrl.showImports\">\n" +
    "              <a role=\"menuitem\" href=\"#/setup/import-progress\" translate=\"Bluemoon.Shell.Navigation.ImportProgress\" data-qe-id=\"Bluemoon.Shell.Navigation.ImportProgress\"></a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </li>\n" +
    "    <li role=\"none\" class=\"bm-staff-nav-badges\"  bm-if-perm-some=\"['Internal.DebugMode', 'Internal.CurrentDevelopment']\">\n" +
    "      <a role=\"menuitem\">\n" +
    "        <span bm-if-perm=\"Internal.DebugMode\" class=\"label label-info\"> Debug</span>\n" +
    "        <span bm-if-perm=\"Internal.CurrentDevelopment\" class=\"label label-info\">Current development</span>\n" +
    "      </a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</bm-nav>\n" +
    "");
}]);

angular.module("practice-widgets/accounts-receivable-open/accounts-receivable-open.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/accounts-receivable-open/accounts-receivable-open.html",
    "<bm-practice-widget-scrolling-container>\n" +
    "    <div class=\"repeating-item\" ng-repeat=\"item in ctrl.data.items track by item.id\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6 col-sm-6 col-xs-6 tighten-margins\">\n" +
    "                <table>\n" +
    "                    <tr>\n" +
    "                        <td class=\"bm-practice-widget-toolbox\">\n" +
    "                            <a class=\"bm-practice-widget-toolbox-item bento-icon-edit\"\n" +
    "                                data-qe-id=\"client-dashboard-open-items-widget-edit-icon\"\n" +
    "                                ng-if=\"item.isInvoice\"\n" +
    "                                tooltip-placement=\"right\"\n" +
    "                                tooltip-trigger=\"mouseenter\"\n" +
    "                                tooltip-append-to-body=\"true\"\n" +
    "                                uib-tooltip=\"{{::'Bluemoon.Practice.Common.Actions.Edit' | translate}}\"\n" +
    "                                aria-label=\"{{::'Bluemoon.Practice.Common.Actions.Edit' | translate}} {{'Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber' | translate}} {{item.entryNumber}}\"\n" +
    "                                role=\"button\"\n" +
    "                                href=\"#/billing/detail?accountsReceivableId={{item.id}}&clientId={{item.client.id}}&clientCode={{item.client.code}}&invoiceDate={{item.entryDateInvariant}}\"\n" +
    "                                target=\"_blank\">\n" +
    "                            </a>\n" +
    "                            <a class=\"bm-practice-widget-toolbox-item bento-icon-edit\"\n" +
    "                                ng-if=\"item.isReceiptOrAdjustment\"\n" +
    "                                tooltip-placement=\"top\"\n" +
    "                                tooltip-trigger=\"mouseenter\"\n" +
    "                                tooltip-append-to-body=\"true\"\n" +
    "                                uib-tooltip=\"{{::'Bluemoon.Practice.Common.Actions.Edit' | translate}}\"\n" +
    "                                aria-label=\"{{::'Bluemoon.Practice.Common.Actions.Edit' | translate}} {{'Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber' | translate}} {{item.entryNumber}}\"\n" +
    "                                href=\"#/receipt-and-adjustment/daily/{{item.id}}\" target=\"_blank\">\n" +
    "                            </a>\n" +
    "                            <a class=\"bm-practice-widget-toolbox-item bento-icon-edit\"\n" +
    "                                ng-if=\"item.isLateFee\"\n" +
    "                                tooltip-placement=\"top\"\n" +
    "                                tooltip-trigger=\"mouseenter\"\n" +
    "                                tooltip-append-to-body=\"true\"\n" +
    "                                uib-tooltip=\"{{::'Bluemoon.Practice.Common.Actions.Edit' | translate}}\"\n" +
    "                                aria-label=\"{{::'Bluemoon.Practice.Common.Actions.Edit' | translate}} {{'Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber' | translate}} {{item.entryNumber}}\"\n" +
    "                                href=\"#/billing/latefee?openDate={{item.entryDateInvariant}}\" target=\"_blank\">\n" +
    "                            </a>\n" +
    "                            <div class=\"bm-practice-widget-toolbox-item bento-icon-export-group\"\n" +
    "                                data-qe-id=\"client-dashboard-open-items-widget-send-button\"\n" +
    "                                ng-if=\"item.isInvoice\"\n" +
    "                                ng-click=\"ctrl.service.sendInvoice(item.id)\"\n" +
    "                                ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && ctrl.service.sendInvoice(item.id)\"\n" +
    "                                tooltip-placement=\"right\"\n" +
    "                                tooltip-trigger=\"mouseenter\"\n" +
    "                                tooltip-append-to-body=\"true\"\n" +
    "                                tabindex=\"0\"\n" +
    "                                aria-label=\"{{::'Bluemoon.Billing.ReviewInvoices.SendModal.SendButton' | translate}} {{'Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber' | translate}} {{item.entryNumber}}\"\n" +
    "                                uib-tooltip=\"{{::'Bluemoon.Billing.ReviewInvoices.SendModal.SendButton' | translate}}\">\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-md-12 col-sm-12 col-xs-12 tight-right\">\n" +
    "                                    <!-- Invoice -->\n" +
    "                                    <a ng-if=\"item.isInvoice\" ng-click=\"ctrl.service.previewInvoice(item.id)\"\n" +
    "                                       tooltip-placement=\"right\"\n" +
    "                                       ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && ctrl.service.previewInvoice(item.id)\"\n" +
    "                                        tabindex=\"0\"\n" +
    "                                       tooltip-trigger=\"mouseenter\"\n" +
    "                                       tooltip-append-to-body=\"true\"\n" +
    "                                       aria-label=\"{{::'Bluemoon.Practice.Common.Actions.OpenInNewTab' | translate}} {{'Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber' | translate}} {{item.entryNumber}}\"\n" +
    "                                       uib-tooltip=\"{{::'Bluemoon.Practice.Common.Actions.OpenInNewTab' | translate}}\">\n" +
    "                                        <span data-qe-id=\"client-dashboard-open-items-widget-invoice-number-link\" translate=\"Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber\" class=\"mainlink\"></span>: {{item.entryNumber}} <i class=\"small bento-icon-newtab\"></i>\n" +
    "                                    </a>\n" +
    "                                    <!-- Other -->\n" +
    "                                    <span ng-if=\"!item.isInvoice\" class=\"mainlink\">{{item.type.name}}</span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                    <table>\n" +
    "                                        <tr>\n" +
    "                                            <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceDate\"></td>\n" +
    "                                            <td>{{item.entryDate}}</td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.AccountsReceivableOpen.Reference\"></td>\n" +
    "                                            <td>{{item.reference}}</td>\n" +
    "                                        </tr>\n" +
    "                                    </table>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6 col-sm-6 col-xs-6 tighten-margins\">\n" +
    "                <table>\n" +
    "                    <tr>\n" +
    "                        <td class=\"caption\">\n" +
    "                            <span ng-if=\"item.isInvoice\" translate=\"Bluemoon.Practice.Widget.AccountsReceivableOpen.DueDate\"></span>\n" +
    "                            <span ng-if=\"!item.isInvoice\">&nbsp;</span>\n" +
    "                        </td>\n" +
    "                        <td class=\"text-right\">\n" +
    "                            <span ng-if=\"item.isInvoice\">{{item.dueDate}}</span>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.AccountsReceivableOpen.Amount\"></td>\n" +
    "                        <td class=\"text-right\">\n" +
    "                            <a href=\"\"\n" +
    "                               data-qe-id=\"client-dashboard-open-items-widget-amount-link\"\n" +
    "                               ng-if=\"item.isInvoice\"\n" +
    "                               ng-click=\"ctrl.service.showBillableEntries(item.id)\"\n" +
    "                               tooltip-placement=\"left\"\n" +
    "                               tooltip-trigger=\"mouseenter\"\n" +
    "                               tooltip-append-to-body=\"true\"\n" +
    "                               role=\"button\"\n" +
    "                               uib-tooltip=\"{{'Bluemoon.Practice.Widget.AccountsReceivableOpen.Amount.Tooltip' | translate}}\">{{item.amount}}</a>\n" +
    "                            <span ng-if=\"!item.isInvoice\">{{item.amount}}</span>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.AccountsReceivableOpen.OpenAmount\"></td>\n" +
    "                        <td class=\"text-right\">\n" +
    "                            <a href=\"\"\n" +
    "                               data-qe-id=\"client-dashboard-open-items-widget-open-amount-link\"\n" +
    "                               ng-click=\"ctrl.service.showAppliedAmounts(item.id)\"\n" +
    "                               tooltip-placement=\"left\"\n" +
    "                               tooltip-trigger=\"mouseenter\"\n" +
    "                               tooltip-append-to-body=\"true\"\n" +
    "                               role=\"button\"\n" +
    "                               uib-tooltip=\"{{'Bluemoon.Practice.Widget.AccountsReceivableOpen.OpenAmount.Tooltip' | translate}}\">{{item.openAmount}}</a>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</bm-practice-widget-scrolling-container>\n" +
    "");
}]);

angular.module("practice-widgets/accounts-receivable-summary/accounts-receivable-summary.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/accounts-receivable-summary/accounts-receivable-summary.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <ul class=\"summary-blocks\">\n" +
    "            <li ng-repeat=\"summary in ctrl.service.summaries\">\n" +
    "                {{summary.name | translate}}\n" +
    "                <p>{{ctrl.data[summary.id].amountFormatted}}</p>\n" +
    "                <span ng-if=\"!!ctrl.data[summary.id].chart\" uib-tooltip=\"{{ctrl.data[summary.id].chart.tooltip}}\" tooltip-placement=\"top\">\n" +
    "                    {{ctrl.data[summary.id].chart.percentileGroup | translate}}\n" +
    "                    <div class=\"item-line-chart\"><div ng-style=\"ctrl.data[summary.id].chart.lineStyle\"></div></div>\n" +
    "                </span>\n" +
    "                <span ng-if=\"ctrl.data.percentileObservations === 0\" translate=\"Bluemoon.Practice.Widget.Percentile.NA\"></span>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"information-footer\" ng-if=\"ctrl.data.percentileObservations > 0\">\n" +
    "    <span>{{ 'Bluemoon.Practice.Widget.Percentile.InformationFooter' | translate }}</span>\n" +
    "</div>");
}]);

angular.module("practice-widgets/agings/agings.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/agings/agings.html",
    "<div ng-repeat=\"item in ctrl.data.items\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col item-label\">{{ item.label }}</div>\n" +
    "        <div class=\"col item-value\">{{ item.valueFormatted }}</div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col\">\n" +
    "        <div class=\"item-line-chart\"><div ng-style=\"item.lineStyle\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("practice-widgets/billing-services/applied-amounts-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/billing-services/applied-amounts-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"appliedAmountsDialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"appliedAmountsDialog.onClose()\"\n" +
    "                aria-hidden=\"true\">&times;</button>\n" +
    "        {{'Bluemoon.Practice.Widget.AppliedAmountsDialog.Title' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "\n" +
    "        <bmp-grid bmp-grid-definition=\"appliedAmountsDialog.gridDefinition\"\n" +
    "                    bmp-grid-service=\"appliedAmountsDialog.serviceProxy\"\n" +
    "                    bmp-grid-before-load=\"appliedAmountsDialog.gridLoaded($sender)\"></bmp-grid>\n" +
    "        <br />\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button id=\"appliedAmountsDialog.ok\"\n" +
    "                    class=\"btn btn-primary\"\n" +
    "                    data-ng-click=\"appliedAmountsDialog.onClose()\" translate=\"Bluemoon.Practice.Common.Actions.Close\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("practice-widgets/billing-services/billable-entries-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/billing-services/billable-entries-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"billableEntriesDialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"billableEntriesDialog.onClose()\"\n" +
    "                aria-hidden=\"true\" aria-label=\"{{'bmt.notifications.closeDialog' | translate}}\">&times;</button>\n" +
    "        {{'Bluemoon.Practice.Widget.BillableEntriesDialog.Title' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "\n" +
    "        <bmp-grid bmp-grid-definition=\"billableEntriesDialog.gridDefinition\"\n" +
    "                    bmp-grid-service=\"billableEntriesDialog.serviceProxy\"\n" +
    "                    bmp-grid-before-load=\"billableEntriesDialog.gridLoaded($sender)\"></bmp-grid>\n" +
    "        <br />\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button id=\"billableEntriesDialog.ok\"\n" +
    "                    class=\"btn btn-primary\"\n" +
    "                    data-ng-click=\"billableEntriesDialog.onClose()\" translate=\"Bluemoon.Practice.Common.Actions.Close\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("practice-widgets/bm-practice-widget-scrolling-container/bm-practice-widget-scrolling-container.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/bm-practice-widget-scrolling-container/bm-practice-widget-scrolling-container.html",
    "<div bmp-scroll-container=\"\" class=\"bm-widget-scrolling-container\" ng-transclude=\"\">\n" +
    "    <!-- Widget here -->\n" +
    "</div>");
}]);

angular.module("practice-widgets/bm-practice-widget/bm-practice-widget.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/bm-practice-widget/bm-practice-widget.html",
    "<div class=\"bm-practice-widget\" ng-class=\"ctrl.css\">\n" +
    "    <div class=\"bm-practice-widget-header\" id=\"header\" ng-include=\"ctrl.service.headerTemplate\" ng-if=\"ctrl.hasHeader\"></div>\n" +
    "    <div class=\"bm-practice-widget-body\" id=\"body\" bento-busy-loader=\"ctrl.isBusy\" ng-include=\"ctrl.service.bodyTemplate\"></div>\n" +
    "    <!-- Footer is for debug at the moment but could be used more effectively -->\n" +
    "    <div class=\"bm-practice-widget-footer\" id=\"footer\" ng-if=\"false\">\n" +
    "        <table>\n" +
    "            <tr>\n" +
    "                <td>{{widget}}</td>\n" +
    "                <td>{{context.name}}</td>\n" +
    "                <td><!-- load args -->\n" +
    "                    <span class=\"footer-inactive\" ng-show=\"ctrl.loadDataArgs.dateRangeId\" ng-class=\"{ 'footer-active': ctrl.loadDataArgs.dateRangeId }\">{{ctrl.loadDataArgs.dateRangeId}}</span>\n" +
    "                    <span class=\"footer-active\" ng-show=\"ctrl.loadDataArgs.searchText\">\"{{ctrl.loadDataArgs.searchText}}\"</span>\n" +
    "                    <span class=\"footer-inactive\" ng-class=\"{ 'footer-active': ctrl.loadDataArgs.pageIndex>1 }\">{{ctrl.loadDataArgs.pageIndex}}</span>\n" +
    "                </td>\n" +
    "                <td><!-- data -->\n" +
    "                    <span class=\"footer-inactive\" ng-class=\"{ 'footer-active': ctrl.isLoadingData }\">LOADING</span>\n" +
    "                    <span class=\"footer-inactive\" ng-class=\"{ 'footer-active': ctrl.data }\">DATA</span>\n" +
    "                    <span class=\"footer-active\" ng-show=\"ctrl.data.items\">({{ctrl.data.items.length}} Items)</span>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("practice-widgets/key-totals/key-totals.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/key-totals/key-totals.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <ul class=\"summary-blocks\">\n" +
    "            <li ng-repeat=\"summary in ctrl.service.indicators\">\n" +
    "                {{summary.name | translate}}\n" +
    "                <p>{{ctrl.data.period[summary.id+'Formatted']}}</p>\n" +
    "                <span uib-tooltip=\"{{ctrl.data.period[summary.id+'Chart'].tooltip}}\" tooltip-placement=\"top\">\n" +
    "                    {{ctrl.data.period[summary.id+'Chart'].changeText | translate}}\n" +
    "                    <div class=\"item-line-chart-svg\">\n" +
    "                        <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\">\n" +
    "                            <line x1=\"0\" x2=\"100%\" y1=\"50%\" y2=\"50%\" stroke-width=\"3\" stroke=\"#ebebeb\"></line>\n" +
    "                            <line x1=\"50%\" x2=\"50%\" y1=\"50%\" y2=\"50%\" stroke-width=\"3\" stroke=\"#DC0A0A\" ng-attr-x1=\"{{ctrl.data.period[summary.id+'Chart'].negativeLineStart}}\"></line>\n" +
    "                            <line x1=\"50%\" x2=\"50%\" y1=\"50%\" y2=\"50%\" stroke-width=\"3\" stroke=\"#00A25D\" ng-attr-x2=\"{{ctrl.data.period[summary.id+'Chart'].positiveLineEnd}}\"></line>\n" +
    "                            <line x1=\"50%\" x2=\"50%\" y1=\"calc(50% - 10px)\" y2=\"calc(50% + 10px)\" style=\"stroke:#aaaaaa;stroke-width: 1px;\"></line>\n" +
    "                        </svg>\n" +
    "                    </div>\n" +
    "                </span>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"information-footer\">\n" +
    "    <span>{{ 'Bluemoon.Practice.Widget.KeyTotals.InformationFooter' | translate }}</span>\n" +
    "</div>");
}]);

angular.module("practice-widgets/my-assignments/my-assignments.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/my-assignments/my-assignments.html",
    "<bmp-project-list bmp-project-list-name=\"'ClientDashboard.MyAssignmentsProjectList'\"\n" +
    "                  bmp-project-list-projects-and-tasks-title=\"'Bluemoon.Core.Setup.ProjectsAndTasks.Header'\"\n" +
    "                  bmp-project-list-projects-title=\"'Core.Captions.Project.ClassOther'\"\n" +
    "                  bmp-project-list-tasks-title=\"'Core.Captions.Task.ClassOther'\"\n" +
    "                  bmp-project-list-analytics-context=\"'clientDashboard_myAssignmentsWidget'\"\n" +
    "                  bmp-project-list-style=\"'widget.client'\"\n" +
    "                  bmp-project-list-client-filter=\"context.id\"\n" +
    "                  ng-if=\"context.id\">\n" +
    "</bmp-project-list>\n" +
    "");
}]);

angular.module("practice-widgets/practice-widget-date-search-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/practice-widget-date-search-header.html",
    "<!-- Standard header containing a date range and search box -->\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-sm-12 col-xs-12\" ng-if=\"ctrl.hasDateSelector\" ng-class=\"{ 'col-md-8': ctrl.hasSearchBox, 'col-md-12': !ctrl.hasSearchBox }\">\n" +
    "        <bmp-date-range-selector\n" +
    "            name=\"bm-practice-widget-{{widget}}{{!!identifier ? '-' + identifier : ''}}\"\n" +
    "            bmp-date-range-selector-label=\"false\"\n" +
    "            bmp-date-range-selector-options=\"ctrl.dateRangeSelectorOptions\"\n" +
    "            bmp-date-range-selector-options-default=\"{{ ctrl.dateRangeSelectorDefault || 'ALL' }}\"\n" +
    "            bmp-date-range-selector-changed=\"ctrl.applyDateRange(dateRangeId, startDate, endDate)\">\n" +
    "        </bmp-date-range-selector>\n" +
    "    </div>\n" +
    "    <div class=\"col-sm-12 col-xs-12 bm-practice-widget-search\" ng-form=\"\" ng-if=\"ctrl.hasSearchBox\" ng-class=\"{ 'col-md-4': ctrl.hasDateSelector, 'col-md-12': !ctrl.hasDateSelector }\">\n" +
    "        <label class=\"sr-only ng-binding\" for=\"widgetSearch\" translate=\"Bluemoon.Practice.Common.Label.Search\"></label>\n" +
    "        <i class=\"bento-icon-search\"></i>\n" +
    "        <input type=\"text\" autocomplete=\"off\" bento-reset=\"\" class=\"form-control\"\n" +
    "                data-qe-id=\"client-dashboard-invoices-widget-searchbox\"\n" +
    "                placeholder=\"{{'Bluemoon.Practice.Common.Placeholder.Search' | translate}}\"\n" +
    "                ng-model=\"ctrl._searchTerm\"\n" +
    "                ng-model-options=\"{ debounce: 400 }\"\n" +
    "                ng-change=\"ctrl.applySearch(ctrl._searchTerm)\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("practice-widgets/prior-invoices/prior-invoices.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/prior-invoices/prior-invoices.html",
    "<bm-practice-widget-scrolling-container>\n" +
    "    <div class=\"repeating-item\" ng-repeat=\"item in ctrl.data.items track by item.id\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6 col-sm-6 col-xs-6 tighten-margins\">\n" +
    "                <table>\n" +
    "                    <tr>\n" +
    "                        <td class=\"bm-practice-widget-toolbox\">\n" +
    "                            <a class=\"bm-practice-widget-toolbox-item bento-icon-edit\"\n" +
    "                                href=\"#/billing/detail?accountsReceivableId={{item.id}}&clientId={{item.client.id}}&clientCode={{item.client.code}}&invoiceDate={{item.entryDateInvariant}}\"\n" +
    "                                target=\"_blank\"\n" +
    "                                tooltip-placement=\"right\"\n" +
    "                                tooltip-trigger=\"mouseenter\"\n" +
    "                                tooltip-append-to-body=\"true\"\n" +
    "                                tabindex=\"0\"\n" +
    "                                role=\"button\"\n" +
    "                                aria-label=\"{{::'Bluemoon.Practice.Common.Actions.Edit' | translate}} {{'Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber' | translate}} {{item.entryNumber}}\"\n" +
    "                                uib-tooltip=\"{{::'Bluemoon.Practice.Common.Actions.Edit' | translate}}\">\n" +
    "                            </a>\n" +
    "                            <div class=\"bm-practice-widget-toolbox-item bento-icon-export-group\"\n" +
    "                                ng-click=\"ctrl.service.send(item.id)\"\n" +
    "                                ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && ctrl.service.send(item.id)\"\n" +
    "                                tabindex=\"0\"\n" +
    "                                tooltip-placement=\"right\"\n" +
    "                                tooltip-trigger=\"mouseenter\"\n" +
    "                                tooltip-append-to-body=\"true\"\n" +
    "                                aria-label=\"{{::'Bluemoon.Billing.ReviewInvoices.SendModal.SendButton' | translate}} {{'Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber' | translate}} {{item.entryNumber}}\"\n" +
    "                                uib-tooltip=\"{{::'Bluemoon.Billing.ReviewInvoices.SendModal.SendButton' | translate}}\">\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-md-12 col-sm-12 col-xs-12 tight-right\">\n" +
    "                                    <a ng-click=\"ctrl.service.preview(item.id)\"\n" +
    "                                    ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && ctrl.service.preview(item.id)\"\n" +
    "                                    tabindex=\"0\"\n" +
    "                                       tooltip-placement=\"right\"\n" +
    "                                       tooltip-trigger=\"mouseenter\"\n" +
    "                                       tooltip-append-to-body=\"true\"\n" +
    "                                        aria-label=\"{{::'Bluemoon.Practice.Common.Actions.OpenInNewTab' | translate}} {{'Bluemoon.Practice.Widget.AccountsReceivableOpen.InvoiceNumber' | translate}} {{item.entryNumber}}\"\n" +
    "                                       uib-tooltip=\"{{::'Bluemoon.Practice.Common.Actions.OpenInNewTab' | translate}}\">\n" +
    "                                        <span translate=\"Bluemoon.Practice.Widget.PriorInvoices.InvoiceNumber\" class=\"mainlink\"></span> {{item.entryNumber}} <i class=\"small bento-icon-newtab\"></i>\n" +
    "                                    </a>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                    <table>\n" +
    "                                        <tr>\n" +
    "                                            <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.InvoiceDate\"></td>\n" +
    "                                            <td>{{item.entryDate}}</td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.Reference\"></td>\n" +
    "                                            <td>{{item.reference}}</td>\n" +
    "                                        </tr>\n" +
    "                                    </table>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                    <span class=\"label label-issue-high\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.Overdue\" ng-if=\"item.isOverdue\"></span>\n" +
    "                                    <span class=\"label label-issue-med\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.NotPaid\" ng-if=\"!item.isPaid && !item.isPartPaid\"></span>\n" +
    "                                    <span class=\"label label-issue-low\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.PartPaid\" ng-if=\"item.isPartPaid\"></span>\n" +
    "                                    <span class=\"label label-info\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.NotSent\" ng-if=\"!item.isSent\"></span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6 col-sm-6 col-xs-6 tighten-margins\">\n" +
    "                <table>\n" +
    "                    <tr>\n" +
    "                        <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.DueDate\"></td>\n" +
    "                        <td class=\"text-right\">{{item.dueDate}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.Amount\"></td>\n" +
    "                        <td class=\"text-right\">\n" +
    "                            <a href=\"\"\n" +
    "                               ng-click=\"ctrl.service.showBillableEntries(item.id)\"\n" +
    "                               tooltip-placement=\"left\"\n" +
    "                               tooltip-trigger=\"mouseenter\"\n" +
    "                               tooltip-append-to-body=\"true\"\n" +
    "                               role=\"button\"\n" +
    "                               uib-tooltip=\"{{'Bluemoon.Practice.Widget.PriorInvoices.Amount.Tooltip' | translate}}\">{{item.invoiceAmount}}</a>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.Realization\"></td>\n" +
    "                        <td class=\"text-right\">{{item.realization}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"caption\" translate=\"Bluemoon.Practice.Widget.PriorInvoices.OpenAmount\"></td>\n" +
    "                        <td class=\"text-right\">\n" +
    "                            <a href=\"\"\n" +
    "                               ng-click=\"ctrl.service.showAppliedAmounts(item.id)\"\n" +
    "                               tooltip-placement=\"left\"\n" +
    "                               tooltip-trigger=\"mouseenter\"\n" +
    "                               tooltip-append-to-body=\"true\"\n" +
    "                               role=\"button\"\n" +
    "                               uib-tooltip=\"{{'Bluemoon.Practice.Widget.PriorInvoices.OpenAmount.Tooltip'| translate}}\">{{item.openAmount}}</a>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</bm-practice-widget-scrolling-container>\n" +
    "");
}]);

angular.module("practice-widgets/time-summary/time-summary.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/time-summary/time-summary.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <ul class=\"summary-blocks\">\n" +
    "            <li ng-repeat=\"summary in ctrl.service.summaries\">\n" +
    "                <a href=\"\" ng-click=\"ctrl.service.openDetails(summary, ctrl.loadDataArgs)\">{{summary.name | translate}}</a>\n" +
    "                <p>{{ctrl.data[summary.id+'Formatted']}}</p>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<script type=\"text/ng-template\" id=\"timesummary-modal.html\">\n" +
    "    <div class=\"modal-header\">{{modal.summary.name | translate}}</div>\n" +
    "    <div class=\"modal-body bm-practice-widget-modal-body\" bento-busy-loader=\"!modal.summary.details\">\n" +
    "        <wj-flex-grid\n" +
    "        ng-if=\"!!modal.summary.details\"\n" +
    "        auto-generate-columns=\"false\"\n" +
    "        class=\"bento-flex-grid\"\n" +
    "        headers-visibility=\"Column\"\n" +
    "        control=\"flex\"\n" +
    "        items-source=\"modal.summary.details\"\n" +
    "        is-read-only=\"true\"\n" +
    "        sort-row-index=\"0\">\n" +
    "            <wj-flex-grid-column width=\"105\" header=\"{{ 'Core.Captions.TimeAndExpense.EntryDate' | translate }}\" binding=\"$date\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"*\" header=\"{{ 'Bluemoon.Core.Setup.ProjectList.Client.Code' | translate }}\" binding=\"client.code\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"*\" header=\"{{ 'Core.Captions.TimeAndExpense.ProjectScheduleItem' | translate }}\" binding=\"projectScheduleItem.name\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"*\" header=\"{{ 'Core.Captions.TimeAndExpense.TaskScheduleItem' | translate }}\" binding=\"taskScheduleItem.name\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"*\" header=\"{{ 'Core.Captions.TimeAndExpense.Engagement' | translate }}\" binding=\"engagement.name\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"*\" header=\"{{ 'Core.Captions.TimeAndExpense.Activity' | translate }}\" binding=\"activity.name\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"70\" header=\"{{ modal.summary.timeColumnHeaderKey | translate }}\" binding=\"$hours\" align=\"right\"></wj-flex-grid-column>\n" +
    "        </wj-flex-grid>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary\" type=\"button\" aria-hidden=\"true\" ng-click=\"modal.close()\">\n" +
    "            {{ 'Bluemoon.Practice.Common.Actions.Close' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</script>");
}]);

angular.module("practice-widgets/wip-summary/wip-summary.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("practice-widgets/wip-summary/wip-summary.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <ul class=\"summary-blocks\">\n" +
    "            <li ng-repeat=\"summary in ctrl.service.summaries\">\n" +
    "                {{summary.name | translate}}\n" +
    "                <p>{{ctrl.data[summary.id].amountFormatted}}</p>\n" +
    "                <span ng-if=\"!!ctrl.data[summary.id].chart\" uib-tooltip=\"{{ctrl.data[summary.id].chart.tooltip}}\" tooltip-placement=\"top\">\n" +
    "                    {{ctrl.data[summary.id].chart.percentileGroup | translate}}\n" +
    "                    <div class=\"item-line-chart\"><div ng-style=\"ctrl.data[summary.id].chart.lineStyle\"></div></div>\n" +
    "                </span>\n" +
    "                <span ng-if=\"ctrl.data.percentileObservations === 0\" translate=\"Bluemoon.Practice.Widget.Percentile.NA\"></span>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"information-footer\" ng-if=\"ctrl.data.percentileObservations > 0\">\n" +
    "    <span>{{ 'Bluemoon.Practice.Widget.Percentile.InformationFooter' | translate }}</span>\n" +
    "</div>");
}]);

angular.module("quick-books-integration-callback/quick-books-integration-callback.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("quick-books-integration-callback/quick-books-integration-callback.2js.html",
    "<bmei-quickbooks-callback-component></bmei-quickbooks-callback-component>");
}]);

angular.module("reports/employee-portal-documents/employee-portal-documents-removal-confirm-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("reports/employee-portal-documents/employee-portal-documents-removal-confirm-modal.html",
    "<div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <h3>{{ 'Reports.EmployeePortalDocuments.Modal.Remove.Text' | translate }}</h3>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button id=\"close-confirmation-modal-confirm\"\n" +
    "        data-qe-id=\"close-confirmation-modal-confirm\"\n" +
    "        class=\"btn btn-primary\"\n" +
    "        ng-click=\"confirmDelete()\"\n" +
    "        ng-disabled=\"isLoadingDelete\">\n" +
    "            {{ 'Reports.EmployeePortalDocuments.Modal.Remove.Button.Confirm' | translate }}\n" +
    "      </button>\n" +
    "      <button id=\"close-confirmation-modal-cancel\"\n" +
    "        data-qe-id=\"close-confirmation-modal-cancel\"\n" +
    "        class=\"btn btn-default\"\n" +
    "        ng-click=\"closeConfirmModal()\">\n" +
    "          {{ 'Reports.EmployeePortalDocuments.Modal.Remove.Button.Cancel' | translate }}\n" +
    "      </button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("reports/employee-portal-documents/employee-portal-documents.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("reports/employee-portal-documents/employee-portal-documents.html",
    "<div id=\"employee-portal-documents\">\n" +
    "  <h1>{{ vm.pageTitle }}</h1>\n" +
    "\n" +
    "  <section bento-fm-form ng-form=\"form\" validations=\"vm.validations\">\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-3 form-group\">\n" +
    "        <label><span translate=\"Reports.EmployeePortalDocuments.Filters.Client\"></span> *</label>\n" +
    "        <div\n" +
    "          bento-combobox\n" +
    "          id=\"client\"\n" +
    "          data-qe-id=\"client\"\n" +
    "          bento-fm-field\n" +
    "          bento-fm-label=\"{{'Reports.EmployeePortalDocuments.Filters.Client' | translate}}\"\n" +
    "          required\n" +
    "          searchable=\"true\"\n" +
    "          name=\"client\"\n" +
    "          headers=\"vm.comboboxClients.headers\"\n" +
    "          row-template=\"vm.comboboxClients.customRowTemplate\"\n" +
    "          columns-width=\"vm.comboboxClients.columnsWidth\"\n" +
    "          get-data=\"vm.getClients(page, search)\"\n" +
    "          use-server=\"true\"\n" +
    "          on-change=\"vm.onComboboxClientsChange(item)\"\n" +
    "          ng-model=\"vm.filter.client\">\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-sm-3 form-group\">\n" +
    "        <label><span translate=\"Reports.EmployeePortalDocuments.Filters.TypeOfDocument\"></span> *</label>\n" +
    "        <div\n" +
    "          bento-combobox\n" +
    "          id=\"document\"\n" +
    "          data-qe-id=\"document\"\n" +
    "          bento-fm-field\n" +
    "          bento-fm-label=\"{{'Reports.EmployeePortalDocuments.Filters.TypeOfDocument' | translate}}\"\n" +
    "          required\n" +
    "          name=\"document\"\n" +
    "          label-name=\"label\"\n" +
    "          get-data=\"vm.getDocuments()\"\n" +
    "          on-change=\"vm.onComboboxDocumentsChange(item)\"\n" +
    "          ng-model=\"vm.filter.document\">\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-sm-2 form-group\">\n" +
    "        <label for=\"initialBasis\" translate>Reports.EmployeePortalDocuments.Filters.InitialBasis</label>\n" +
    "          <input\n" +
    "            id=\"initialBasis\"\n" +
    "            type=\"text\"\n" +
    "            name=\"initialBasis\"\n" +
    "            class=\"form-control\"\n" +
    "            ng-model=\"vm.filter.initialBasis\"\n" +
    "            ng-change=\"vm.onChangeInitialBasisDate()\"\n" +
    "            data-qe-id=\"initialBasis\"\n" +
    "            validate-basis-date\n" +
    "            placeholder=\"{{'Reports.EmployeePortalDocuments.Placeholder.MonthYear' | translate}}\"\n" +
    "            autocomplete=\"off\"\n" +
    "            fef-maxlength=\"7\"\n" +
    "            bento-fm-label=\"{{'Reports.EmployeePortalDocuments.Filters.InitialBasis' | translate}}\"\n" +
    "            bento-fm-field>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-sm-2 form-group\">\n" +
    "        <label for=\"finalBasis\" translate>Reports.EmployeePortalDocuments.Filters.FinalBasis</label>\n" +
    "        <input\n" +
    "          id=\"finalBasis\"\n" +
    "          type=\"text\"\n" +
    "          name=\"finalBasis\"\n" +
    "          class=\"form-control\"\n" +
    "          ng-model=\"vm.filter.finalBasis\"\n" +
    "          ng-change=\"vm.onChangeFinalBasisDate()\"\n" +
    "          data-qe-id=\"finalBasis\"\n" +
    "          validate-basis-date\n" +
    "          placeholder=\"{{'Reports.EmployeePortalDocuments.Placeholder.MonthYear' | translate}}\"\n" +
    "          autocomplete=\"off\"\n" +
    "          fef-maxlength=\"7\"\n" +
    "          bento-fm-label=\"{{'Reports.EmployeePortalDocuments.Filters.FinalBasis' | translate}}\"\n" +
    "          bento-fm-field>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-sm-2 form-group\">\n" +
    "        <label translate>Reports.EmployeePortalDocuments.Filters.Viewed</label>\n" +
    "        <div>\n" +
    "          <div class=\"btn-group\">\n" +
    "            <button type=\"button\"\n" +
    "                    id=\"viewed-all\"\n" +
    "                    data-qe-id=\"viewed-all\"\n" +
    "                    class=\"btn btn-default btn-toggle\"\n" +
    "                    ng-model=\"vm.filter.viewed\"\n" +
    "                    uib-btn-radio=\"vm.viewedAllConstant\">\n" +
    "                    {{ 'Reports.EmployeePortalDocuments.Filters.All' | translate }}\n" +
    "            </button>\n" +
    "            <button type=\"button\"\n" +
    "                    id=\"viewed-yes\"\n" +
    "                    data-qe-id=\"viewed-yes\"\n" +
    "                    class=\"btn btn-default btn-toggle\"\n" +
    "                    ng-model=\"vm.filter.viewed\"\n" +
    "                    uib-btn-radio=\"vm.viewedYesConstant\">\n" +
    "                    {{ 'Reports.EmployeePortalDocuments.Filters.Yes' | translate }}\n" +
    "            </button>\n" +
    "            <button type=\"button\"\n" +
    "                    id=\"viewed-no\"\n" +
    "                    data-qe-id=\"viewed-no\"\n" +
    "                    class=\"btn btn-default btn-toggle\"\n" +
    "                    ng-model=\"vm.filter.viewed\"\n" +
    "                    uib-btn-radio=\"vm.viewedNoConstant\">\n" +
    "                    {{ 'Reports.EmployeePortalDocuments.Filters.No' | translate }}\n" +
    "            </button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-12\">\n" +
    "        * {{ 'Reports.EmployeePortalDocuments.Filters.RequiredFields' | translate }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row filters-button-group\">\n" +
    "      <div class=\"col-sm-12\">\n" +
    "        <button type=\"button\"\n" +
    "                id=\"searchForm.search\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                bento-fm-submit\n" +
    "                ng-click=\"vm.onClickSearch()\"\n" +
    "                ng-disabled=\"vm.loadingData\"\n" +
    "                data-qe-id=\"search-button\">\n" +
    "            {{ 'Reports.EmployeePortalDocuments.Filters.Button.Search' | translate }}\n" +
    "        </button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </section>\n" +
    "\n" +
    "  <div ng-show=\"vm.ctx.data && vm.searched && !vm.loadingData\">\n" +
    "    <div bento-toolbar\n" +
    "      class=\"navbar navbar-default bento-toolbar\"\n" +
    "      toolbar-data=\"vm.buttons\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"bmp-wijmo-table-container\">\n" +
    "      <wj-flex-grid\n" +
    "        id=\"groupGrid\"\n" +
    "        items-source=\"vm.ctx.source\"\n" +
    "        control=\"vm.ctx.flexgrid\"\n" +
    "        class=\"bento-flex-grid\"\n" +
    "        bmp-set-height\n" +
    "        bmp-set-height-fill-vertical-height=\"true\"\n" +
    "        bmp-set-height-fill-vertical-height-other-height=\"30\"\n" +
    "        headers-visibility=\"Column\"\n" +
    "        selection-mode=\"None\"\n" +
    "        sticky-headers=\"true\"\n" +
    "        sort-row-index=\"0\">\n" +
    "        <!-- Selection Combobox column -->\n" +
    "        <wj-flex-grid-column\n" +
    "          header=\"\"\n" +
    "          allow-sorting=\"false\"\n" +
    "          allow-resizing=\"false\"\n" +
    "          width=\"40\"\n" +
    "          min-width=\"40\"\n" +
    "          css-class=\"col-select\"\n" +
    "          align=\"center\">\n" +
    "          <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "            <div class=\"col-select\">\n" +
    "              <i class=\"bento-flex-grid-checkbox\"\n" +
    "                ng-click=\"vm.actions.changeAllSelected()\"\n" +
    "                ng-class=\"{'bento-icon-minus-plain':vm.anySelected && !vm.allSelected,'bento-icon-checkmark':!vm.anySelected && vm.allSelected}\"></i>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index > 0\" class=\"col-select\"></div>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "          <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "            <i class=\"bento-flex-grid-checkbox bmp-wijmo-table-vertically-center\"\n" +
    "              ng-click=\"vm.actions.changeSelected($item)\"\n" +
    "              ng-class=\"{'bento-icon-checkmark':$item.selected}\">\n" +
    "            </i>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <!-- Actions column -->\n" +
    "        <wj-flex-grid-column\n" +
    "          is-read-only=\"true\"\n" +
    "          header=\"{{vm.actionsHeader}}\"\n" +
    "          width=\"70\"\n" +
    "          min-width=\"70\"\n" +
    "          align=\"left\">\n" +
    "          <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "            {{$col.header}}\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "          <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "            <div data-qe-id=\"col-actions-row-{{$row.index}}\"\">\n" +
    "                <span\n" +
    "                class=\"grid-action-icon\"\n" +
    "                data-qe-id=\"delete-item\"\n" +
    "                ng-click=\"vm.actions.deleteItem($row.dataItem)\"\n" +
    "                tooltip-placement=\"top\"\n" +
    "                uib-tooltip=\"{{vm.removeTooltipMessage}}\"\n" +
    "                tooltip-append-to-body=\"true\">\n" +
    "                <i class=\"bento-icon-remove\"></i>\n" +
    "              </span>\n" +
    "            </div>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <!-- Competency column -->\n" +
    "        <wj-flex-grid-column binding=\"competency\"\n" +
    "          is-read-only=\"true\"\n" +
    "          header=\"{{vm.competencyHeader}}\"\n" +
    "          align=\"left\">\n" +
    "          <div\n" +
    "            data-qe-id=\"col-competence-row-{{$row.index}}\"\n" +
    "            class=\"custom-ellipsis\">\n" +
    "            {{$item.competency}}\n" +
    "          </div>\n" +
    "          <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "            <!-- Column Headers in Row 0, manually add back sort icons -->\n" +
    "            <div ng-if=\"$row.index===0\">{{$col.header}}\n" +
    "              <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===2\">\n" +
    "              {{$col.header}}\n" +
    "            </div>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <!-- Type column -->\n" +
    "        <wj-flex-grid-column header=\"{{vm.typeHeader}}\" binding=\"type\" min-width=\"220\" width=\"220\">\n" +
    "           <div data-qe-id=\"col-type-row-{{$row.index}}\">\n" +
    "            {{ $item.type }}\n" +
    "          </div>\n" +
    "          <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "            <!-- Column Headers in Row 0, manually add back sort icons -->\n" +
    "            <div ng-if=\"$row.index===0\">{{$col.header}}\n" +
    "              <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===1\">\n" +
    "              <div id=\"filter-{{$col.binding}}\"\n" +
    "                bento-combobox\n" +
    "                data-qe-id=\"type-filter-{{$col.binding}}\"\n" +
    "                label-name=\"description\"\n" +
    "                get-data=\"vm.getListComboBoxDocumentsType()\"\n" +
    "                on-change=\"vm.changeComboTypeFilter(item)\"\n" +
    "                ng-model=\"vm.type\"\n" +
    "                searchable=\"true\"\n" +
    "                bento-append-to-parent=\".container-fluid\"\n" +
    "                ui-focus=\"{{vm.ctx.columnFocus['type']}}\"\n" +
    "                tabindex=\"0\">\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===2\">\n" +
    "              {{$col.header}}\n" +
    "            </div>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <!-- Published To column -->\n" +
    "        <wj-flex-grid-column header=\"{{vm.publishedToHeader}}\" binding=\"publishedTo\" min-width=\"250\" width=\"*\">\n" +
    "            <div data-qe-id=\"col-published-to-row-{{$row.index}}\">\n" +
    "                {{ $item.publishedTo }}\n" +
    "            </div>\n" +
    "          <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "            <!-- Column Headers in Row 0, manually add back sort icons -->\n" +
    "            <div ng-if=\"$row.index===0\">{{$col.header}}\n" +
    "              <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===1\">\n" +
    "              <input type=\"text\"\n" +
    "                class=\"form-control\"\n" +
    "                id=\"filter-{{$col.binding}}\"\n" +
    "                data-qe-id=\"publishedTo-filter-{{$col.binding}}\"\n" +
    "                fef-maxlength=\"250\"\n" +
    "                ng-keypress=\"vm.keyPressFilter($event, 'publishedTo')\"\n" +
    "                ng-change=\"vm.changeFilter('publishedTo')\"\n" +
    "                ng-model-options=\"{ debounce: 400 }\"\n" +
    "                ng-model=\"vm.publishedToFilter\"\n" +
    "                tabindex=\"0\"\n" +
    "                ui-focus=\"{{vm.ctx.columnFocus['publishedTo']}}\">\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===2\">\n" +
    "              {{$col.header}}\n" +
    "            </div>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <!-- Publication Date column -->\n" +
    "        <wj-flex-grid-column header=\"{{vm.publicationDateHeader}}\" binding=\"publicationDate\" min-width=\"200\" width=\"200\">\n" +
    "            <div data-qe-id=\"col-publication-date-row-{{$row.index}}\">\n" +
    "                {{ $item.publicationDate }}\n" +
    "            </div>\n" +
    "          <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "            <!-- Column Headers in Row 0, manually add back sort icons -->\n" +
    "            <div ng-if=\"$row.index===0\">{{$col.header}}\n" +
    "              <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===1\" bento-fm-form>\n" +
    "              <div class=\"form-group filters-inline-group\">\n" +
    "                <p class=\"input-group bento-datepicker\">\n" +
    "                  <input type=\"text\"\n" +
    "                    name=\"publicationDate\"\n" +
    "                    class=\"form-control\"\n" +
    "                    id=\"publicationDate\"\n" +
    "                    data-qe-id=\"publication-date\"\n" +
    "                    ng-change=\"vm.changeFilter('publicationDate')\"\n" +
    "                    uib-datepicker-popup=\"{{vm.datePickerFormat}}\"\n" +
    "                    datepicker-append-to-body=\"true\"\n" +
    "                    bento-datepicker-force-desktop\n" +
    "                    on-open-focus=\"false\"\n" +
    "                    datepicker-options=\"vm.generalDateOptions\"\n" +
    "                    show-button-bar=\"false\"\n" +
    "                    is-open=\"vm.dpOpenPublicationDate\"\n" +
    "                    ng-click=\"vm.dpOpenPublicationDate = !vm.dpOpenPublicationDate\"\n" +
    "                    ui-date\n" +
    "                    tabindex=\"0\"\n" +
    "                    ng-model=\"vm.publicationDate\" />\n" +
    "                    <span class=\"input-group-btn\">\n" +
    "                      <button type=\"button\"\n" +
    "                        data-qe-id=\"publication-date-button\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        ng-click=\"vm.dpOpenPublicationDate = !vm.dpOpenPublicationDate\">\n" +
    "                        <i class=\"bento-icon-calendar\"></i>\n" +
    "                      </button>\n" +
    "                  </span>\n" +
    "                </p>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===2\">\n" +
    "              {{$col.header}}\n" +
    "            </div>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <!-- View Date column -->\n" +
    "        <wj-flex-grid-column header=\"{{vm.viewDateHeader}}\" binding=\"viewDate\" min-width=\"200\" width=\"200\">\n" +
    "            <div data-qe-id=\"col-viewing-date-row-{{$row.index}}\">\n" +
    "                {{ $item.viewDate }}\n" +
    "            </div>\n" +
    "          <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "            <!-- Column Headers in Row 0, manually add back sort icons -->\n" +
    "            <div ng-if=\"$row.index===0\">{{$col.header}}\n" +
    "              <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===1\" bento-fm-form>\n" +
    "              <div class=\"form-group filters-inline-group\">\n" +
    "                <p class=\"input-group bento-datepicker\">\n" +
    "                  <input type=\"text\"\n" +
    "                    name=\"viewDate\"\n" +
    "                    class=\"form-control\"\n" +
    "                    id=\"viewDate\"\n" +
    "                    data-qe-id=\"viewed-date\"\n" +
    "                    uib-datepicker-popup=\"{{vm.datePickerFormat}}\"\n" +
    "                    ng-change=\"vm.changeFilter('viewDate')\"\n" +
    "                    datepicker-append-to-body=\"true\"\n" +
    "                    bento-datepicker-force-desktop\n" +
    "                    on-open-focus=\"false\"\n" +
    "                    datepicker-options=\"vm.generalDateOptions\"\n" +
    "                    show-button-bar=\"false\"\n" +
    "                    is-open=\"vm.dpOpenViewDate\"\n" +
    "                    ng-click=\"vm.dpOpenViewDate = !vm.dpOpenViewDate\"\n" +
    "                    ui-date\n" +
    "                    tabindex=\"0\"\n" +
    "                    ng-model=\"vm.viewDate\" />\n" +
    "                    <span class=\"input-group-btn\">\n" +
    "                      <button type=\"button\"\n" +
    "                        data-qe-id=\"viewed-date-button\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        ng-click=\"vm.dpOpenViewDate = !vm.dpOpenViewDate\">\n" +
    "                        <i class=\"bento-icon-calendar\"></i>\n" +
    "                      </button>\n" +
    "                  </span>\n" +
    "                </p>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"$row.index===2\">\n" +
    "              {{$col.header}}\n" +
    "            </div>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "      </wj-flex-grid>\n" +
    "      <div ng-if=\"vm.ctx.data.length\"\n" +
    "        bento-pagination\n" +
    "        page=\"vm.currentInfo.page\"\n" +
    "        direction-links=\"true\"\n" +
    "        boundary-links=\"true\"\n" +
    "        total-items=\"vm.currentInfo.totalItems\"\n" +
    "        items-per-page=\"vm.currentInfo.numItems\"\n" +
    "        items-array=\"vm.pageSizeOption\"\n" +
    "        on-change=\"vm.onChangePage(page)\"\n" +
    "        on-change-size=\"vm.onChangePageSize(size)\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div bento-busy-loader=\"vm.loadingData\" bento-busy-loader-size=\"small\"></div>\n" +
    "  <h3 ng-if=\"!vm.ctx.data.length && !vm.loadingData && vm.searched\" class=\"empty-message\">\n" +
    "    {{vm.emptyMessage}}\n" +
    "  </h3>\n" +
    "\n" +
    "  <div bento-alert bento-alert-object=\"alerts\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("reports/firm-management-reports/firm-management-reports-main.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("reports/firm-management-reports/firm-management-reports-main.html",
    "<app-firm-management-report-main></app-firm-management-report-main>");
}]);

angular.module("reports/firm-management-reports/firm-management-reports-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("reports/firm-management-reports/firm-management-reports-options.html",
    "<div>\n" +
    "    <bmrc-report-edit-options report-controller=\"vm\">\n" +
    "    </bmrc-report-edit-options>\n" +
    "</div>");
}]);

angular.module("reports/firm-management-reports/firm-management-reports.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("reports/firm-management-reports/firm-management-reports.html",
    "<div class=\"container-fluid no-left-padding view-container\">\n" +
    "    <h1 class=\"no-top-margin\" data-qe-id=\"header-title\">{{'Bluemoon.Shell.Navigation.FirmManagementReports' | translate}}</h1>\n" +
    "    <bmrc-report-list report-controller=\"vm.reportsListService\" ></bmrc-report-list>\n" +
    "</div>\n" +
    "");
}]);

angular.module("reports/onvio-usage/login-history-modal/login-history-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("reports/onvio-usage/login-history-modal/login-history-modal.2js.html",
    "<div id=\"login-history-modal\" class=\"bento-modal sample-terms terms-modal modal-scroll\" style=\"height: 500px;\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeSampleModal()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <span translate>Reports.OnvioUsage.LoginHistoryFor</span> {{vm.name}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\" style=\"max-height: 1000px;\">\n" +
    "        <div>\n" +
    "            <div class=\"datepick-options\">\n" +
    "                <div class=\"input-group bento-datepicker\">\n" +
    "                  <input\n" +
    "                        type=\"text\"\n" +
    "                        class=\"form-control\"\n" +
    "                        uib-datepicker-popup=\"{{format}}\"\n" +
    "                        ng-model=\"vm.startDate\"\n" +
    "                        is-open=\"vm.startDatePickerOpened\"\n" +
    "                        min=\"'2001-01-01'\"\n" +
    "                        datepicker-options=\"vm.startDatePickerOptions\"\n" +
    "                        show-button-bar=\"false\"\n" +
    "                        ng-required=\"false\"\n" +
    "                        ng-change=vm.dateRangeChanged(vm.selectedItem)\n" +
    "                        ng-click=\"vm.openStartDatePicker()\"\n" +
    "                  >\n" +
    "                  <span class=\"input-group-btn\">\n" +
    "                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openStartDatePicker()\">\n" +
    "                      <i class=\"bento-icon-calendar\"></i>\n" +
    "                    </button>\n" +
    "                  </span>\n" +
    "                </div>\n" +
    "                <div class=\"input-group bento-datepicker\">\n" +
    "                  <input\n" +
    "                        type=\"text\"\n" +
    "                        class=\"form-control\"\n" +
    "                        uib-datepicker-popup=\"{{format}}\"\n" +
    "                        ng-model=\"vm.endDate\"\n" +
    "                        is-open=\"vm.endDatePickerOpened\"\n" +
    "                        datepicker-options=\"vm.endDatePickerOptions\"\n" +
    "                        show-button-bar=\"false\"\n" +
    "                        ng-required=\"false\"\n" +
    "                        ng-change=vm.dateRangeChanged(vm.selectedItem)\n" +
    "                        ng-click=\"vm.openEndDatePicker()\"\n" +
    "                  >\n" +
    "                  <span class=\"input-group-btn\">\n" +
    "                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openEndDatePicker()\">\n" +
    "                      <i class=\"bento-icon-calendar\"></i>\n" +
    "                    </button>\n" +
    "                  </span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"navbar navbar-default bento-toolbar\" bento-toolbar toolbar-data=\"vm.toolbarButtons\">\n" +
    "            <ul class=\"nav navbar-right\" role=\"group\">\n" +
    "                <li>\n" +
    "                    <input\n" +
    "                        type=\"text\"\n" +
    "                        class=\"filter-input\"\n" +
    "                        ng-model=\"vm.filter\"\n" +
    "                        placeholder=\"{{'Bluemoon.Practice.Common.Label.Search' | translate}}\" \n" +
    "                    >\n" +
    "                </li>\n" +
    "                <li class=\"dropdown\" role=\"group\" uib-dropdown>\n" +
    "                    <button\n" +
    "                        class=\"btn btn-default btn-icon btn-toggle\"\n" +
    "                        uib-dropdown-toggle\n" +
    "                        tooltip-placement=\"bottom\"\n" +
    "                        uib-tooltip=\"{{ 'Reports.OnvioUsage.ShowHideColumns' | translate}}\"\n" +
    "                    >\n" +
    "                    <i class=\"bento-icon-cog\"></i>\n" +
    "                    <i class=\"bento-icon-arrow-down2\"></i>\n" +
    "                    </button>\n" +
    "                    <ul class=\"dropdown-menu\">\n" +
    "                        <li class=\"dropdown-item\" ng-repeat=\"column in vm.flex.columns\" ng-click=\"vm.toggleVisibility(column)\">\n" +
    "                            <div>{{column.header}}\n" +
    "                                <i ng-class=\"{false: 'bento-icon-checkbox', true: 'bento-icon-checkbox-filled', undefined:'bento-icon-checkbox'} [column.visible]\" style=\"float:right;\"></i>\n" +
    "                            </div>\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "            <wj-flex-grid ng-if=\"!vm.dateRangeExceeded\"\n" +
    "                auto-generate-columns=\"false\"\n" +
    "                class=\"bento-flex-grid\"\n" +
    "                control=\"vm.flex\"\n" +
    "                items-source=\"vm.gridData\"\n" +
    "                is-read-only=\"true\"\n" +
    "                sort-row-index=\"0\"\n" +
    "                show-sort=\"true\"\n" +
    "                min-height=\"300\"\n" +
    "                style=\"overflow: hidden\"\n" +
    "            >\n" +
    "                <wj-flex-grid-column binding=\"login\" header=\"{{vm.loginHeader}}\" width=\"*\">{{vm.email}}</wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column binding=\"name\" header=\"{{vm.fullNameHeader}}\" width=\"*\">{{vm.name}}</wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column binding=\"formattedLoginTime\" header=\"{{vm.loginTimeHeader}}\" width=\"200\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column binding=\"ipAddress\" header=\"{{vm.ipAddressHeader}}\" width=\"160\"></wj-flex-grid-column>\n" +
    "            </wj-flex-grid>\n" +
    "            <p ng-if=\"vm.gridData.items.length===0\" class=\"bmp-grid-view-centered-span\" data-translate=\"Bluemoon.Practice.Common.List.NoGridEntries\"></p>\n" +
    "            <br>\n" +
    "            <p ng-if=\"vm.dateRangeExceeded\" class=\"bmp-grid-view-centered-span\" translate=\"Reports.OnvioUsage.DateRangeExceeded\"></p>\n" +
    "            <div class=\"total-count\">\n" +
    "                <span>{{vm.gridData.items.length}}</span>\n" +
    "                <span translate=\"Onvio.Setup.Recurrence.InputAddon.Of\"></span>\n" +
    "                <span>{{vm.gridData.items.length}}</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.closeSampleModal()\" translate>\n" +
    "            Bluemoon.Practice.Common.Actions.Done\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("reports/onvio-usage/onvio-usage.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("reports/onvio-usage/onvio-usage.html",
    "<div id=\"usage-reports\" class=\"container-fluid\">\n" +
    "	<h1 tabindex=\"0\" translate>Bluemoon.Shell.Navigation.OnvioUsage</h1>\n" +
    "		<div class=\"usage-reports-container\" role=\"tablist\" aria-orientation=\"vertical\">\n" +
    "			<div ng-if=\"!vm.useSideNav\" class=\"report-select\" role=\"presentation\">\n" +
    "				<ul class=\"ul-no-padding\" role=\"presentation\">\n" +
    "					<li tabindex=\"0\" role=\"tab\"  class=\"grid-select\" ng-repeat=\"selection in vm.gridSelect\" ng-class=\"{true: 'grid-selected'}[selection.selected]\" aria-controls=\"panel-{{selection.report}}\" ng-click=\"vm.selectedItemChanged(selection)\"\n" +
    "                    aria-selected=\"{{selection.report === vm.selectedItem.report}}\" ng-keydown=\"vm.selectedItemKeydown($event, selection)\" aria-label=\"{{selection.name }}\" id=\"{{selection.report}}\">{{selection.name }}</li>\n" +
    "				</ul>\n" +
    "            </div>\n" +
    "            <div\n" +
    "                ng-if=\"vm.useSideNav\"\n" +
    "                bento-tree\n" +
    "                tree-id=\"onvio-usage-tree\"\n" +
    "                tree-model=\"vm.sideNavItems\"\n" +
    "                class=\"sidenav\"\n" +
    "                multi-select=\"false\"\n" +
    "                nav-mode=\"true\"\n" +
    "                select-model=\"selected\"\n" +
    "                tree-label=\"label\"\n" +
    "                select-callback=\"vm.sideNavSelectedItemChanged\">\n" +
    "            </div>\n" +
    "			<div class=\"report-container\" role=\"tabpanel\" tabindex=\"0\" id=\"panel-{{vm.selectedItem.report}}\" aria-labelledby=\"{{vm.selectedItem.report}}\">\n" +
    "				<div bento-busy-loader=\"isLoader1Busy\" bento-busy-loader-size=\"small\">\n" +
    "					<div class=\"report-header\">\n" +
    "						<h2 class=\"col-md-3 col-sm-4 col-xs-5\">{{vm.selectedItem.name}}</h2>\n" +
    "						<div ng-if=\"vm.selectedItem.datePickEnabled\" class=\"datepick-options\">\n" +
    "							<div class=\"input-group bento-datepicker\">\n" +
    "									<input\n" +
    "									type=\"text\"\n" +
    "									class=\"form-control\"\n" +
    "									uib-datepicker-popup=\"{{format}}\"\n" +
    "									ng-model=\"vm.startDate\"\n" +
    "									is-open=\"vm.startDatePickerOpened\"\n" +
    "									min=\"'2001-01-01'\"\n" +
    "									datepicker-options=\"vm.startDatePickerOptions\"\n" +
    "									show-button-bar=\"false\"\n" +
    "									ng-required=\"false\"\n" +
    "									ng-change=vm.dateRangeChanged(vm.selectedItem)\n" +
    "									ng-click=\"vm.openStartDatePicker()\"\n" +
    "									>\n" +
    "									<span class=\"input-group-btn\">\n" +
    "										<button type=\"button\" class=\"btn btn-default\" aria-label=\"{{'Reports.OnvioUsage.Calendar.StartDate.Open' | translate}}\" ng-click=\"vm.openStartDatePicker()\">\n" +
    "											<i class=\"bento-icon-calendar\"></i>\n" +
    "										</button>\n" +
    "									</span>\n" +
    "							</div>\n" +
    "								<div class=\"input-group bento-datepicker\">\n" +
    "									<input\n" +
    "									type=\"text\"\n" +
    "											class=\"form-control\"\n" +
    "											uib-datepicker-popup=\"{{format}}\"\n" +
    "											ng-model=\"vm.endDate\"\n" +
    "											is-open=\"vm.endDatePickerOpened\"\n" +
    "											datepicker-options=\"vm.endDatePickerOptions\"\n" +
    "											show-button-bar=\"false\"\n" +
    "											ng-required=\"false\"\n" +
    "											ng-change=vm.dateRangeChanged(vm.selectedItem)\n" +
    "											ng-click=\"vm.openEndDatePicker()\"\n" +
    "									>\n" +
    "									<span class=\"input-group-btn\">\n" +
    "										<button type=\"button\" class=\"btn btn-default\" aria-label=\"{{'Reports.OnvioUsage.Calendar.EndDate.Open' | translate}}\" ng-click=\"vm.openEndDatePicker()\">\n" +
    "											<i class=\"bento-icon-calendar\"></i>\n" +
    "										</button>\n" +
    "									</span>\n" +
    "								</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class=\"report-container\">\n" +
    "						<div class=\"navbar navbar-default bento-toolbar\" bento-toolbar toolbar-data=\"vm.toolbarButtons\">\n" +
    "							<ul class=\"nav navbar-right\" role=\"group\">\n" +
    "								<li class=\"dropdown\" role=\"group\" uib-dropdown keyboard-nav on-toggle=\"vm.onDropdownToggle(open)\" is-open=\"vm.isOpen\">\n" +
    "									<button\n" +
    "										class=\"btn btn-default btn-icon btn-toggle onvio-usage-dropdown\"\n" +
    "										ng-click=\"vm.isOpen = !vm.isOpen\"\n" +
    "										tooltip-placement=\"bottom\"\n" +
    "										ng-blur=\"vm.onDropdownBlur($event)\"\n" +
    "										uib-tooltip=\"{{ 'Reports.OnvioUsage.ShowHideColumns' | translate}}\"\n" +
    "									>\n" +
    "									<i class=\"bento-icon-cog\"></i>\n" +
    "									<i class=\"bento-icon-arrow-down2\"></i>\n" +
    "									</button>\n" +
    "									<ul class=\"dropdown-menu\" uib-dropdown-menu>\n" +
    "										<li class=\"dropdown-item onvio-usage-dropdown-menu\" ng-repeat=\"column in vm.flex.columns\">\n" +
    "											<a tabindex=\"0\" ng-click=\"vm.toggleVisibility(column)\" ng-keydown=\"vm.handleColumnKeydown($event, column)\" ng-blur=\"vm.onDropdownBlur($event)\" role=\"checkbox\" aria-checked=\"{{column.visible}}\">{{column.header}}\n" +
    "												<i ng-class=\"{false: 'bento-icon-checkbox', true: 'bento-icon-checkbox-filled', undefined:'bento-icon-checkbox'} [column.visible]\" style=\"float:right;\"></i>\n" +
    "											</a>\n" +
    "										</li>\n" +
    "									</ul>\n" +
    "								</li>\n" +
    "							</ul>\n" +
    "						</div>\n" +
    "						<div>\n" +
    "							<wj-flex-grid ng-if=\"!vm.dateRangeExceeded\"\n" +
    "								auto-generate-columns=\"false\"\n" +
    "								class=\"bento-flex-grid\"\n" +
    "								control=\"vm.flex\"\n" +
    "								items-source=\"vm.gridData\"\n" +
    "								is-read-only=\"true\"\n" +
    "								sort-row-index=\"0\"\n" +
    "								show-sort=\"true\"\n" +
    "								min-height=\"150\"\n" +
    "								style=\"overflow: hidden\"\n" +
    "							>\n" +
    "								<wj-flex-grid-column\n" +
    "									ng-repeat=\"column in vm.selectedItem.columns\"\n" +
    "									binding=\"{{column.binding}}\"\n" +
    "									header=\"{{column.header}}\"\n" +
    "									width=\"{{column.width}}\"\n" +
    "								>\n" +
    "								<wj-flex-grid-cell-template ng-if=\"column.isActions\" cell-type=\"Cell\">\n" +
    "									<span class=\"grid-action-icon bento-icon-info\" tooltip-placement=\"top\" tooltip-trigger=\"mouseenter\" uib-tooltip=\"{{vm.tooltip}}\" tooltip-append-to-body=\"true\" style=\"float:left; line-height:1.5;\" id=\"elem\"></span>\n" +
    "								</wj-flex-grid-cell-template>\n" +
    "								</wj-flex-grid-column>\n" +
    "							</wj-flex-grid>\n" +
    "							<div bento-pagination\n" +
    "								page=\"vm.page\"\n" +
    "								direction-links=\"true\"\n" +
    "								boundary-links=\"true\"\n" +
    "								total-items=\"vm.totalItems\"\n" +
    "								items-per-page=\"vm.pageSize\"\n" +
    "								items-array=\"vm.pageSizeOption\"\n" +
    "							    class=\"\">\n" +
    "							</div>\n" +
    "							<p ng-if=\"vm.gridData.items.length===0\" class=\"bmp-grid-view-centered-span\" data-translate=\"Bluemoon.Practice.Common.List.NoGridEntries\"></p>\n" +
    "							<br>\n" +
    "							<p ng-if=\"vm.dateRangeExceeded\" class=\"bmp-grid-view-centered-span\" translate=\"Reports.OnvioUsage.DateRangeExceeded\"></p>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("reports/onvio-usage/terms-modal/terms-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("reports/onvio-usage/terms-modal/terms-modal.2js.html",
    "<div class=\"bento-modal sample-terms terms-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeSampleModal()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <span translate>Onvio.Setup.Terms.Published.Title</span> {{vm.termsVersion}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"sample-view\" ng-bind-html=\"vm.sampleText\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.closeSampleModal()\" translate>\n" +
    "            Bluemoon.Practice.Common.Actions.Cancel\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("server-check/index.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("server-check/index.html",
    "<Status xmlns:i=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns=\"http://schemas.datacontract.org/2004/07/Cobalt.BlueMoonClients.Web.Models\">\n" +
    "    <Resources>\n" +
    "        <Result>OK</Result>\n" +
    "    </Resources>\n" +
    "</Status>\n" +
    "");
}]);

angular.module("setup/src/activities/activity-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/activities/activity-detail.html",
    "<div class=\"container-fluid no-left-padding view-container\" ng-class=\"{'modal-workspace-no-bottom-margin': vm.inWorkspaceModal}\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\" bento-busy-loader=\"vm.detail.isLoadingData()\" ng-style=\"{height: vm.detail.isLoadingData() ? '100vh' : ''}\" ng-class=\"{'modal-workspace-margin-left': vm.inWorkspaceModal, 'modal-workspace-container': vm.inWorkspaceModal,'activity-detail-container': vm.inWorkspaceModal}\">\n" +
    "            <form id=\"activityForm\" name=\"activityForm\">\n" +
    "                <bmp-page-header ng-class=\"{loading: vm.detail.isLoadingData()}\" ng-hide=\"vm.isOnIframe\" is-in-modal=\"vm.inWorkspaceModal\">\n" +
    "                    <bmp-page-header-left-content>\n" +
    "                        <h1 uib-tooltip=\"{{vm.activityLabel()}}\" tooltip-trigger=\"mouseenter\"\n" +
    "                         tooltip-placement=\"bottom\">{{vm.activityLabel()}}</h1>\n" +
    "                        <h1 ng-if=\"vm.detail.isLoadingData() && vm.activityLabel() === ''\">\n" +
    "                            {{vm.detail.busyText}}\n" +
    "                        </h1>\n" +
    "                    </bmp-page-header-left-content>\n" +
    "                    <bmp-page-header-right-content>\n" +
    "                        <button type=\"button\" data-fef-tab-stop=\"false\" id=\"activityForm.save\"\n" +
    "                                class=\"btn btn-primary\"\n" +
    "                                data-ng-click=\"vm.detail.save();\"\n" +
    "                                translate=\"Bluemoon.Practice.Common.Actions.Save\"\n" +
    "                                ng-disabled=\"vm.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\" id=\"activityForm.cancel\"\n" +
    "                                class=\"btn btn-default\"\n" +
    "                                data-ng-click=\"vm.detail.cancel()\"\n" +
    "                                translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                                ng-disabled=\"vm.detail.isLoadingData()\"></button>\n" +
    "                    </bmp-page-header-right-content>\n" +
    "                </bmp-page-header>\n" +
    "                <div ng-if=\"!vm.detail.isLoadingData()\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Code/ID -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.Activity.Code' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"code\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.Code' | translate | bmRequiredMark}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'code')\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\"\n" +
    "                                id=\"code\"\n" +
    "                                name=\"code\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-model=\"vm.data.code\"\n" +
    "                                data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                                data-ng-required=\"true\"\n" +
    "                                data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'code')\"\n" +
    "                                data-bmp-entity-code=\"\"\n" +
    "                                data-bmp-entity-code-id=\"vm.id\"\n" +
    "                                data-bmp-entity-code-type=\"activities\"\n" +
    "                                data-bm-focus-on-link=\"\"\n" +
    "                                data-fef-maxlength=\"20\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Name -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.Activity.Name' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"name\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.Name' | translate | bmRequiredMark}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\"\n" +
    "                                id=\"name\"\n" +
    "                                name=\"name\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-model=\"vm.data.name\"\n" +
    "                                data-ng-required=\"true\"\n" +
    "                                data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'name')\"\n" +
    "                                data-fef-maxlength=\"250\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Invoice description -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"invoiceDescription\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.InvoiceDescription' | translate }}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceDescription')\"\n" +
    "                            class=\"col-md-8 col-xs-12\">\n" +
    "                            <textarea id=\"invoiceDescription\"\n" +
    "                                    name=\"invoiceDescription\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    rows=\"3\"\n" +
    "                                    data-ng-model=\"vm.data.invoiceDescription\"\n" +
    "                                    data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'invoiceDescription')\"\n" +
    "                                    data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Type -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"activityType\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.ActivityType' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'activityType')\"\n" +
    "                            class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "                            <bmp-enum-radio-group enum=\"activity-types\" name=\"activityType\"\n" +
    "                                                ng-model=\"vm.data.$activityType\"></bmp-enum-radio-group>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Class -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"class\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.Class' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'class')\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <bmp-enum-radio-group enum=\"activity-classes\" name=\"class\"\n" +
    "                                                ng-model=\"vm.data.$class\"></bmp-enum-radio-group>\n" +
    "                        </div>\n" +
    "                        <!-- Administrative Type -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"adminType\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.AdminType' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'adminType')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showAdminType()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <bmp-enum-radio-group enum=\"{{vm.isExpense() ? 'activity-expense-admin-types' : 'activity-admin-types'}}\" name=\"adminType\"\n" +
    "                                                ng-model=\"vm.data.adminType\"></bmp-enum-radio-group>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Status -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"status\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.Status' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'status')\"\n" +
    "                            class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "                            <bmp-radio-button-group id=\"status\"\n" +
    "                                                    name=\"status\"\n" +
    "                                                    data-bmp-radio-button-group-tab-stop=\"true\"\n" +
    "                                                    data-ng-model=\"vm.data.status\"\n" +
    "                                                    data-bmp-radio-button-group-options=\"vm.statusOptions\"></bmp-radio-button-group>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- GL Account -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"generalLedgerAccount\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.GeneralLedgerAccount' | translate }}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'generalLedgerAccount')\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <input  type=\"text\"\n" +
    "                                id=\"generalLedgerAccount\"\n" +
    "                                name=\"generalLedgerAccount\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-model=\"vm.data.generalLedgerAccount\"\n" +
    "                                data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'generalLedgerAccount')\"\n" +
    "                                data-fef-maxlength=\"60\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <h3 class=\"col-md-6\">{{'Onvio.Setup.Activities.ActivityDetail.GroupingsSectionHeader' | translate }}</h3>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Activity Category -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"activityCategory\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.ActivityCategory' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'activityCategory')\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <bmp-select-combo list=\"activity-categories\" name=\"activityCategory\"\n" +
    "                                            ng-model=\"vm.data.activityCategory\"></bmp-select-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <h3 class=\"col-md-6\">{{'Onvio.Setup.Activities.ActivityDetail.RatesSectionHeader' | translate }}</h3>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Rate -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"rateType\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.RateType' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'rateType')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showTimeRate()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <bmp-enum-radio-group enum=\"rate-types\" name=\"rateType\"\n" +
    "                                                ng-model=\"vm.data.$rateType\"></bmp-enum-radio-group>\n" +
    "                        </div>\n" +
    "                        <!-- Staff Rate -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.Activity.EmployeeRateDescription' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"employeeRateDescription\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.EmployeeRateDescription' | translate | bmRequiredMark}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'employeeRateDescription')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showEmployeeRateDescription()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <bmp-select-combo list=\"employee-rate-descriptions\" list-style=\"basic\" name=\"employeeRateDescription\"\n" +
    "                                            ng-model=\"vm.data.employeeRateDescription\" data-ng-required=\"vm.showEmployeeRateDescription()\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                        <!-- Fixed Rate -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"unitPrice\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.FixedRate' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'unitPrice')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showFixedRate()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" class=\"form-control input-lg\" data-ng-model=\"vm.data.unitPrice\"\n" +
    "                                data-bmp-clear-value-when=\"!vm.showFixedRate()\"\n" +
    "                                data-bmp-clear-value=\"0\" data-bmp-big-number=\"'c2'\" bm-format-on-blur=\"\" data-bmp-big-number-range-validator\n" +
    "                                min=\"0\" max=\"99999\" data-bmp-control-group-field=\"Core.Captions.EngagementTemplate.FixedRate\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Unit Price -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"unitPrice\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.UnitPrice' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'unitPrice')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showExpenseRate()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" class=\"form-control input-lg\" data-ng-model=\"vm.data.unitPrice\"\n" +
    "                                data-bmp-clear-value-when=\"!vm.showExpenseRate()\"\n" +
    "                                data-bmp-clear-value=\"0\" data-bmp-big-number=\"'c4'\" bm-format-on-blur=\"\" data-bmp-big-number-range-validator\n" +
    "                                min=\"0\" max=\"99999\" data-bmp-control-group-field=\"Core.Captions.Activity.UnitPrice\" />\n" +
    "                        </div>\n" +
    "                        <!-- Unit Cost -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"unitCost\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.UnitCost' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'unitCost')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showExpenseRate()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" class=\"form-control input-lg\" data-ng-model=\"vm.data.unitCost\"\n" +
    "                                data-bmp-clear-value-when=\"!vm.showExpenseRate()\"\n" +
    "                                data-bmp-clear-value=\"0\" data-bmp-big-number=\"'c4'\" bm-format-on-blur=\"\" data-bmp-big-number-range-validator\n" +
    "                                min=\"0\" max=\"99999\" data-bmp-control-group-field=\"Core.Captions.Activity.UnitCost\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Round Amount -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"roundExtension\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'roundExtension')\"\n" +
    "                            class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "                            <div data-toggle=\"buttons-checkbox\">\n" +
    "                                <div>\n" +
    "                                    <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                        name=\"roundExtension\"\n" +
    "                                        id=\"roundExtension\"\n" +
    "                                        data-ng-model=\"vm.data.roundExtension\"\n" +
    "                                        data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'roundExtension')\">\n" +
    "                                    {{'Core.Captions.Activity.RoundExtension' | translate }}\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Surcharge Method -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"surchargeMethod\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.SurchargeMethod' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'surchargeMethod')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showSurchargeAndTaxCheckboxes()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <bmp-enum-combo enum=\"custom\" name=\"surchargeMethod\"\n" +
    "                                            ng-model=\"vm.data.$surchargeMethod\"\n" +
    "                                            required=\"true\"\n" +
    "                                            custom-items=\"vm.surchargeMethodOptions\"></bmp-enum-combo>\n" +
    "                        </div>\n" +
    "                        <!-- Surcharge Amount -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"surchargeAmount\"\n" +
    "                            data-bmp-control-group-label=\"{{vm.data.surchargeMethod.name}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'surchargeAmount')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showSurchargeAmount()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" class=\"form-control input-lg\" data-ng-model=\"vm.data.surchargeAmount\"\n" +
    "                                data-bmp-clear-value=\"0\" data-bmp-clear-value-when=\"!vm.showSurchargeAmount()\"\n" +
    "                                data-bmp-big-number=\"'c2'\" bm-format-on-blur=\"\" data-bmp-big-number-range-validator\n" +
    "                                min=\"0\" max=\"99999\" data-bmp-control-group-field=\"Core.Captions.Activity.SurchargeAmount\" />\n" +
    "                        </div>\n" +
    "                        <!-- Surcharge Percent -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"surchargePercent\"\n" +
    "                            data-bmp-control-group-label=\"{{vm.data.surchargeMethod.name}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(data, 'surchargePercent')\"\n" +
    "                            data-bmp-control-group-hide=\"!vm.showSurchargePercent()\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" class=\"form-control input-lg\" data-ng-model=\"vm.data.surchargePercent\"\n" +
    "                                data-bmp-clear-value=\"0\" data-bmp-clear-value-when=\"!vm.showSurchargePercent()\"\n" +
    "                                bmp-big-number=\"'p2'\" bm-format-on-blur=\"\" data-bmp-big-number-range-validator\n" +
    "                                min=\"0\" max=\"999\" data-bmp-control-group-field=\"Core.Captions.Activity.SurchargePercent\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <h3 class=\"col-md-6\" data-ng-hide=\"!vm.showSurchargeAndTaxCheckboxes()\">{{'Onvio.Setup.Activities.ActivityDetail.TaxCalculationsSectionHeader' | translate }}</h3>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"chargeSalesTax\"\n" +
    "                                data-bmp-control-group-hide=\"!vm.showSurchargeAndTaxCheckboxes()\"\n" +
    "                                class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "                                <div data-toggle=\"buttons-checkbox\">\n" +
    "                                    <!-- Charge Tax -->\n" +
    "                                    <div>\n" +
    "                                        <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                            name=\"chargeSalesTax\"\n" +
    "                                            id=\"chargeSalesTax\"\n" +
    "                                            data-ng-model=\"vm.data.chargeSalesTax\"\n" +
    "                                            data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'chargeSalesTax')\">\n" +
    "                                        {{'Core.Captions.Activity.ChargeSalesTax' | translate }}\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/bm-notifications/bm-notifications.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/bm-notifications/bm-notifications.html",
    "<app-bm-notifications></app-bm-notifications>");
}]);

angular.module("setup/src/client-notifications/client-notifications.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/client-notifications/client-notifications.html",
    "<div id=\"notifications-view\" class=\"no-left-padding bm-cn bm-client-notification-styling\">\n" +
    "    <h1 class=\"no-top-margin\" translate>Onvio.Shell.Navigation.ClientNotifications</h1>\n" +
    "    <uib-tabset class=\"tabs-top\">\n" +
    "        <!-- pahse 3 code -->\n" +
    "        <!-- <tab heading=\"{{ vm.notificationTabHeading }}\">\n" +
    "            notifications tab\n" +
    "        </tab> -->\n" +
    "        <uib-tab select=\"vm.styleTabSelect()\" deselect=\"vm.styleTabDeselect()\">\n" +
    "            <uib-tab-heading>\n" +
    "                <span aria-describedby=\"alert-indicator\">{{vm.stylingTabHeading}}</span><unsaved-indicator toggle=\"vm.hasUnsavedStyleChanges\"></unsaved-indicator>\n" +
    "            </uib-tab-heading>\n" +
    "            <uib-tabset type=\"pills\" class=\"no-top-padding\">\n" +
    "                <uib-tab ng-repeat=\"language in vm.languages\" deselect=\"vm.styleLanguageTabDeselect(language)\">\n" +
    "                    <uib-tab-heading>\n" +
    "                        <span>{{ language.translatedDescription }}</span><unsaved-indicator id=\"alert-indicator\" tabname=\"vm.stylingTabHeading\" toggle=\"language.hasUnsavedChanges\"></unsaved-indicator>\n" +
    "                    </uib-tab-heading>\n" +
    "                    <div class=\"common-detail-view-div\">\n" +
    "                        <bmt-client-notification-styling data=\"language\" environment=\"external\"></bmt-client-notification-styling>\n" +
    "                    </div>\n" +
    "                </uib-tab>\n" +
    "            </uib-tabset>\n" +
    "        </uib-tab>\n" +
    "        <uib-tab select=\"vm.wordingTabSelect()\" deselect=\"vm.wordingTabDeselect()\">\n" +
    "            <uib-tab-heading>\n" +
    "                <span>{{vm.wordingTabHeading}}</span><unsaved-indicator toggle=\"vm.hasUnsavedWordingChanges\"></unsaved-indicator>\n" +
    "            </uib-tab-heading>\n" +
    "            <uib-tabset type=\"pills\" class=\"no-top-padding\">\n" +
    "                <uib-tab ng-repeat=\"language in vm.languages\" select=\"vm.wordingLanguageTabSelect(language)\">\n" +
    "                    <uib-tab-heading>\n" +
    "                        <span>{{ language.translatedDescription }}</span><unsaved-indicator toggle=\"language.hasUnsavedTypes\" tabname=\"language.translatedDescription\"></unsaved-indicator>\n" +
    "                    </uib-tab-heading>\n" +
    "                    <client-notification-wording categories=\"vm.categoryList\" language=\"language\"></client-notification-wording>\n" +
    "                </uib-tab>\n" +
    "            </uib-tabset>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/client-notifications/wording/wording.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/client-notifications/wording/wording.html",
    "<form role=\"form\" name=\"vm.wordingSetupForm\" novalidate=\"\" class=\"css-form bm-notifications-wording\">\n" +
    "    <div class=\"row\">\n" +
    "        <nav class=\"bm-cn-tree-nav col-sm-4 col-md-3\">\n" +
    "            <!-- category/types navigation -->\n" +
    "            <ul class=\"bm-cn-tree-ul\">\n" +
    "                <li class=\"bm-cn-tree\" ng-repeat=\"category in vm.localCategories\">\n" +
    "                    <!-- category list -->\n" +
    "                    <button class=\"bm-cn-tree-cat-row\" ng-click=\"vm.setSyncCategoryMap(category)\" bm-flex-row aria-haspopup=\"true\" aria-expanded=\"{{category.open || false}}\">\n" +
    "                        <div class=\"bm-cn-tree-toggle\">\n" +
    "                            <i ng-class=\"{'bento-icon-caret-down': category.open, 'bento-icon-caret-right': !category.open}\"></i>\n" +
    "                        </div>\n" +
    "                        <div class=\"bm-cn-tree-cat\" bm-flex-grow>\n" +
    "                            <span uib-tooltip=\"{{vm.getDescriptionForUserLocal(category.names)}}\" tooltip-append-to-body=\"true\" tooltip-class=\"bm-notification-tooltip\" tooltip-popup-delay=\"1000\" tooltip-placement=\"right\">\n" +
    "                                {{vm.getNameForUserLocale(category.names)}}\n" +
    "                            </span>\n" +
    "                            <unsaved-indicator toggle=\"category.isDirty\" tabname=\"vm.getNameForUserLocale(category.names)\"></unsaved-indicator>\n" +
    "                        </div>\n" +
    "                    </button>\n" +
    "                    <!-- types collapsible -->\n" +
    "                    <div uib-collapse=\"!category.open\">\n" +
    "                        <ul class=\"bm-cn-tree-ul\">\n" +
    "                            <li class=\"bm-cn-tree-type-row text-nowrap\" ng-class=\"{'bm-cn-tree-selected': vm.selectedType.id === type.id}\" ng-repeat=\"type in category.types\" ng-click=\"vm.setSelectedType(type, true)\" bm-flex-row>\n" +
    "                                <!-- spacer icon only -->\n" +
    "                                <button class=\"bm-cn-tree-type\" bm-flex-grow aria-current=\"{{vm.selectedType.id === type.id}}\">\n" +
    "                                    <span uib-tooltip=\"{{vm.getDescriptionForUserLocal(type.names)}}\" tooltip-append-to-body=\"true\" tooltip-class=\"bm-notification-tooltip\" tooltip-popup-delay=\"1000\">\n" +
    "                                        {{vm.getNameForUserLocale(type.names)}}\n" +
    "                                    </span>\n" +
    "                                    <unsaved-indicator toggle=\"type.isDirty\" tabname=\"vm.getNameForUserLocale(type.names)\"></unsaved-indicator>\n" +
    "                                </button>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </nav>\n" +
    "        <div class=\"col-sm-8 col-md-9\">\n" +
    "            <h3 class=\"no-top-margin\">\n" +
    "                {{vm.getNameForUserLocale(vm.selectedType.names)}}\n" +
    "            </h3>\n" +
    "            <!-- alert display -->\n" +
    "            <uib-alert ng-repeat=\"alert in vm.alerts\" type=\"{{ alert.type }}\">{{ alert.msg }}</uib-alert>\n" +
    "            <!-- direct notification  -->\n" +
    "            <div ng-if=\"vm.selectedFieldState.showDirect\">\n" +
    "                <h6 translate>onvio.setup.notifications.inOnvioHeader</h6>\n" +
    "                <div class=\"bm-cn-channel-toggle\" ng-class=\"{'bm-cn-disabled-toggle' : !vm.selectedType.disableDirectAllowed}\">\n" +
    "                    <div bento-toggle aria-label=\"{{ 'onvio.setup.notifications.inOnvioHeader' | translate }}\" ng-model=\"vm.selectedTemplate.sendDirect\" on-change=\"vm.toggleDisableDirectNotifications(value)\" is-locked=\"!vm.selectedType.disableDirectAllowed\" tooltip-placement=\"top\" uib-tooltip=\"{{!vm.selectedType.disableDirectAllowed ? vm.disableDirectToolTipText : ''}}\"></div>\n" +
    "                    <i ng-if=\"!vm.selectedType.disableDirectAllowed\" class=\"bento-icon-lock\" tooltip-placement=\"top\" uib-tooltip=\"{{!vm.selectedType.disableDirectAllowed ? vm.disableDirectToolTipText : ''}}\"></i>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.selectedTemplate.sendDirect\" class=\"row\">\n" +
    "                    <div class=\"col-sm-10\">\n" +
    "                        <div class=\"form-group\" ng-class=\"{'has-error' : vm.wordingSetupForm.onvioText.$invalid && ((vm.wordingSetupForm.onvioText.$touched && vm.wordingSetupForm.onvioText.$dirty) || vm.wordingSetupForm.$submitted)}\">\n" +
    "                            <label for=\"onvioText\"><span translate=\"onvio.setup.notifications.message\"></span>*</label>\n" +
    "                            <input id=\"onvioText\" name=\"onvioText\" class=\"form-control\" type=\"text\" ng-model=\"vm.selectedTemplate.channels[1].body\" ng-disabled=\"vm.selectedFieldState.directTextDisabled\" required />\n" +
    "                            <div class=\"msg\" ng-messages=\"vm.wordingSetupForm.onvioText.$error\" ng-if=\"vm.wordingSetupForm.onvioText.$touched || vm.wordingSetupForm.$submitted\">\n" +
    "                                <span ng-message=\"required\">{{'onvio.setup.notifications.textRequired' | translate}}</span>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <!-- mobile push notification  -->\n" +
    "            <div ng-if=\"vm.selectedFieldState.showMobile\">\n" +
    "                <h6 style=\"display: inline-block\" translate>onvio.setup.notifications.mobilePushHeader</h6>\n" +
    "                <span tabindex=\"0\" class=\"glyphicon glyphicon-info-sign text-margin-right-lg\" tooltip-placement=\"top\" uib-tooltip=\"{{vm.useMobileToolTip || 'Could not find translation'}}\" tooltip-append-to-body=\"true\" tooltip-class=\"bm-notification-tooltip\"></span>\n" +
    "                <!-- mobile toggle -->\n" +
    "                <div class=\"bm-cn-channel-toggle\" ng-class=\"{'bm-cn-disabled-toggle' : !vm.selectedType.disableMobileAllowed}\">\n" +
    "                    <div bento-toggle aria-label=\"{{ 'onvio.setup.notifications.mobilePushHeader' | translate }}\" ng-model=\"vm.selectedTemplate.sendMobile\" on-change=\"vm.toggleDisableMobileNotifications(value)\" is-locked=\"!vm.selectedType.disableMobileAllowed\" tooltip-placement=\"top\" uib-tooltip=\"{{!vm.selectedType.disableMobileAllowed ? vm.disableMobileToolTipText : ''}}\"></div>\n" +
    "                    <i ng-if=\"!vm.selectedType.disableMobileAllowed\" class=\"bento-icon-lock\" tooltip-placement=\"top\" uib-tooltip=\"{{!vm.selectedType.disableMobileAllowed ? vm.disableMobileToolTipText : ''}}\"></i>\n" +
    "                </div>\n" +
    "                <!-- message -->\n" +
    "                <div ng-if=\"vm.selectedTemplate.sendMobile\" class=\"row\">\n" +
    "                    <div class=\"col-sm-10\">\n" +
    "                        <div class=\"form-group\" ng-class=\"{'has-error' : vm.wordingSetupForm.mobileText.$invalid && ((vm.wordingSetupForm.mobileText.$touched && vm.wordingSetupForm.mobileText.$dirty) || vm.wordingSetupForm.$submitted)}\">\n" +
    "                            <label for=\"mobileText\"><span translate=\"onvio.setup.notifications.message\"></span>*</label>\n" +
    "                            <input id=\"mobileText\" name=\"mobileText\" class=\"form-control\" type=\"text\" ng-maxlength=\"150\" ng-model=\"vm.selectedTemplate.channels[2].body\"  required />\n" +
    "                            <div class=\"msg\" ng-messages=\"vm.wordingSetupForm.mobileText.$error\" ng-if=\"(vm.wordingSetupForm.mobileText.$touched || vm.wordingSetupForm.$submitted) \">\n" +
    "                                <span ng-message=\"required\">{{'onvio.setup.notifications.textRequired' | translate}}</span>\n" +
    "                                <span ng-message=\"maxlength\">{{'onvio.setup.notifications.mobileText.body.error.maxlength' | translate}}</span>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <!-- email notification  -->\n" +
    "            <div ng-if=\"vm.selectedFieldState.showEmail\">\n" +
    "                <div class=\"bm-cn-email-frequency\">\n" +
    "                    <div class=\"bm-cn-email-toggle\">\n" +
    "                        <h6 translate>onvio.setup.notifications.emailHeader</h6>\n" +
    "                            <div class=\"bm-cn-channel-toggle\" ng-class=\"{'bm-cn-disabled-toggle' : !vm.selectedType.disableEmailAllowed}\">\n" +
    "                                <div bento-toggle aria-label=\"{{ 'onvio.setup.notifications.emailHeader' | translate }}\" ng-model=\"vm.selectedTemplate.sendEmail\" on-change=\"vm.toggleDisableEmailNotifications(value)\" is-locked=\"!vm.selectedType.disableEmailAllowed\" tooltip-placement=\"top\" uib-tooltip=\"{{!vm.selectedType.disableEmailAllowed ? vm.disableEmailToolTipText : ''}}\"></div>\n" +
    "                                <i ng-if=\"!vm.selectedType.disableEmailAllowed\" class=\"bento-icon-lock\" tooltip-placement=\"top\" uib-tooltip=\"{{!vm.selectedType.disableEmailAllowed ? vm.disableEmailToolTipText : ''}}\"></i>\n" +
    "                            </div>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.selectedTemplate.sendEmail && vm.selectedType.disableEmailAllowed && !!vm.selectedType.digestable && !vm.selectedType.disableDigestFrequency\" class=\"bm-cn-notification-frequency\">\n" +
    "                        <h6 translate>onvio.setup.notifications.frequency</h6>\n" +
    "                        <div class=\"btn-group title-case\">\n" +
    "                            <button type=\"button\" class=\"btn btn-default btn-toggle\" ng-model=\"vm.selectedTemplate.digestChannels[0].frequency\" uib-btn-radio=\"'OFF'\" translate>onvio.setup.notifications.frequency.realTime</button>\n" +
    "                            <button type=\"button\" class=\"btn btn-default btn-toggle\" ng-model=\"vm.selectedTemplate.digestChannels[0].frequency\" uib-btn-radio=\"'DAILY'\" translate>onvio.setup.notifications.frequency.dailyDigest</button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.selectedTemplate.sendEmail\">\n" +
    "                    <!-- global email toggle -->\n" +
    "                    <div class=\"row\" ng-if=\"vm.selectedFieldState.showGlobalToggle\">\n" +
    "                        <div class=\"col-sm-12 toggle-container form-group\">\n" +
    "                            <span class=\"text-padding-right\">\n" +
    "                                <span translate>onvio.setup.notifications.useGlobalAddresses</span>\n" +
    "                            </span>\n" +
    "                            <span tabindex=\"0\" class=\"glyphicon glyphicon-info-sign text-margin-right-lg\" tooltip-placement=\"top\" uib-tooltip=\"{{vm.useGlobalToolTip}}\" tooltip-append-to-body=\"true\" tooltip-class=\"bm-notification-tooltip\"></span>\n" +
    "                            <div bento-toggle aria-label=\"{{ 'onvio.setup.notifications.useGlobalAddresses' | translate }}\" ng-model=\"vm.selectedFieldState.useGlobal\" on-change=\"vm.onGlobalChange(value)\" is-locked=\"vm.selectedFieldState.globalDisabled\"></div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- sender name -->\n" +
    "                    <div class=\"row\" ng-if=\"!vm.selectedFieldState.hideSenderName\">\n" +
    "                        <div class=\"col-sm-6 form-group\">\n" +
    "                            <label for=\"senderName\" translate>onvio.setup.notifications.senderNameLabel</label>\n" +
    "                            <input id=\"senderName\" name=\"senderName\" class=\"form-control\" type=\"text\" ng-model=\"vm.selectedTemplate.senderName\" ng-disabled=\"vm.selectedFieldState.senderNameTextDisabled\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- sender email -->\n" +
    "                    <div class=\"row\" ng-if=\"!vm.selectedFieldState.hideSenderEmail\">\n" +
    "                        <div class=\"col-sm-6\">\n" +
    "                            <div class=\"form-group\" ng-class=\"{'has-error' : vm.wordingSetupForm.senderEmail.$invalid && ((vm.wordingSetupForm.senderEmail.$touched && vm.wordingSetupForm.senderEmail.$dirty) || vm.wordingSetupForm.$submitted)}\">\n" +
    "                                <label for=\"senderEmail\" translate>onvio.setup.notifications.senderEmailLabel</label>\n" +
    "                                <input id=\"senderEmail\" name=\"senderEmail\" class=\"form-control\" type=\"text\" ng-model=\"vm.selectedTemplate.senderEmail\" ng-model-options=\"{ debounce: 500, blur: 0 }\" ng-disabled=\"vm.selectedFieldState.senderEmailTextDisabled\" sender-email-validator/>\n" +
    "                                <div class=\"msg\" ng-messages=\"vm.wordingSetupForm.senderEmail.$error\" ng-if=\"vm.wordingSetupForm.senderEmail.$touched || vm.wordingSetupForm.$submitted\">\n" +
    "                                    <span ng-message=\"senderEmail\">{{'onvio.setup.notifications.senderEmail' | translate}}</span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <!-- ngMessages here -->\n" +
    "                    </div>\n" +
    "                    <!-- cc email -->\n" +
    "                    <div class=\"row\" ng-if=\"vm.selectedFieldState.displayCcRow && !vm.selectedFieldState.hideCc\">\n" +
    "                        <div class=\"col-sm-10 form-group\">\n" +
    "                            <label for=\"ccEmail\" translate>onvio.setup.notifications.emailCcLabel</label>\n" +
    "                            <textarea id=\"ccEmail\" name=\"ccEmail\" ng-model=\"vm.selectedTemplate.cc\" class=\"form-control bmt-notification-email\" ng-disabled=\"vm.selectedFieldState.ccTextDisabled\" bmt-email-list-formatter></textarea>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- bcc email  -->\n" +
    "                    <div class=\"row\" ng-if=\"vm.selectedFieldState.displayBccRow && !vm.selectedFieldState.hideBcc\">\n" +
    "                        <div class=\"col-sm-10 form-group\">\n" +
    "                            <label for=\"bccEmail\" translate>onvio.setup.notifications.emailBccLabel</label>\n" +
    "                            <textarea id=\"bccEmail\" name=\"bccEmail\" ng-model=\"vm.selectedTemplate.bcc\" class=\"form-control bmt-notification-email\" ng-disabled=\"vm.selectedFieldState.bccTextDisabled\" bmt-email-list-formatter></textarea>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- cc and bcc options -->\n" +
    "                    <div class=\"row bm-cn-cc-options\" ng-if=\"(!vm.selectedFieldState.displayCcRow && !vm.selectedFieldState.hideCc) || (!vm.selectedFieldState.displayBccRow && !vm.selectedFieldState.hideBcc)\">\n" +
    "                        <div class=\"col-sm-12 form-group clearfix\">\n" +
    "                            <div class=\"pull-left\" ng-if=\"!vm.selectedFieldState.displayCcRow && !vm.selectedFieldState.hideCc\">\n" +
    "                                <i class=\"bento-icon-add\"></i> <a role=\"button\" class=\"bm-add-icon-link btn btn-link\" ng-href=\"\" ng-click=\"vm.selectedFieldState.displayCcRow = true\" translate>onvio.setup.notifications.addCc</a>\n" +
    "                            </div>\n" +
    "                            <div class=\"pull-left\" ng-if=\"!vm.selectedFieldState.displayBccRow && !vm.selectedFieldState.hideBcc\">\n" +
    "                                <i class=\"bento-icon-add\"></i> <a role=\"button\" class=\"bm-add-icon-link btn btn-link\" ng-href=\"\" ng-click=\"vm.selectedFieldState.displayBccRow = true\" translate>onvio.setup.notifications.addBcc</a>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- subject -->\n" +
    "                    <div class=\"row bm-cn-cc-options\" ng-if=\"!vm.selectedFieldState.hideSubject && (!vm.selectedTemplate.digestChannels[0].frequency || vm.selectedTemplate.digestChannels[0].frequency === 'OFF')\">\n" +
    "                        <div class=\"col-sm-10\">\n" +
    "                            <div class=\"form-group\" ng-class=\"{'has-error' : vm.wordingSetupForm.subject.$invalid && ((vm.wordingSetupForm.subject.$touched && vm.wordingSetupForm.subject.$dirty) || vm.wordingSetupForm.$submitted)}\">\n" +
    "                                <label for=\"subject\"><span translate=\"onvio.setup.notifications.subjectlLabel\"></span>*</label>\n" +
    "                                <input id=\"subject\" name=\"subject\" class=\"form-control\" type=\"text\" ng-model=\"vm.selectedTemplate.channels[0].subject\" ng-disabled=\"vm.selectedFieldState.subjectTextDisabled\" required />\n" +
    "                                <div class=\"msg\" ng-messages=\"vm.wordingSetupForm.subject.$error\" ng-if=\"vm.wordingSetupForm.subject.$touched || vm.wordingSetupForm.$submitted\">\n" +
    "                                    <span ng-message=\"required\">{{'Bluemoon.DMS.Requests.AddEditForm.SubjectError' | translate}}</span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- digestSubject -->\n" +
    "                    <div class=\"row\" ng-if=\"!vm.selectedType.disableDigestSubject && vm.selectedTemplate.digestChannels[0].frequency === 'DAILY'\">\n" +
    "                        <div class=\"col-sm-10\">\n" +
    "                            <div class=\"form-group\" ng-class=\"{'has-error' : vm.wordingSetupForm.digestSubject.$invalid && ((vm.wordingSetupForm.digestSubject.$touched && vm.wordingSetupForm.digestSubject.$dirty) || vm.wordingSetupForm.$submitted)}\">\n" +
    "                                <label for=\"digestSubject\"><span translate=\"onvio.setup.notifications.digestSubject\"></span>*</label>\n" +
    "                                <input id=\"digestSubject\" name=\"digestSubject\" class=\"form-control\" type=\"text\" ng-model=\"vm.selectedTemplate.digestChannels[0].subject\" required />\n" +
    "                                <div class=\"msg\" ng-messages=\"vm.wordingSetupForm.digestSubject.$error\" ng-if=\"vm.wordingSetupForm.digestSubject.$touched || vm.wordingSetupForm.$submitted\">\n" +
    "                                    <span ng-message=\"required\">{{'Bluemoon.DMS.Requests.AddEditForm.SubjectError' | translate}}</span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- digestHeader -->\n" +
    "                    <div class=\"row\" ng-if=\"!vm.selectedType.disableDigestHeader && vm.selectedTemplate.digestChannels[0].frequency === 'DAILY'\">\n" +
    "                        <div class=\"col-sm-12\">\n" +
    "                            <div class=\"form-group\">\n" +
    "                                <label for=\"digestHeader\" translate>onvio.setup.notifications.digestHeader</label>\n" +
    "                                <div id=\"wording_{{vm.selectedTemplate.language}}_froala\">\n" +
    "                                    <textarea id=\"digestHeader\" name=\"digestHeader\" class=\"form-control\" froala=\"vm.froalaOptions\" ng-model=\"vm.selectedTemplate.digestChannels[0].header\"></textarea>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- body html -->\n" +
    "                    <div class=\"row\" ng-if=\"!vm.selectedFieldState.hideBody\">\n" +
    "                        <div class=\"col-sm-12\">\n" +
    "                            <div class=\"form-group\">\n" +
    "                                <label for=\"emailBody\" translate>onvio.setup.notifications.emailBodyLabel</label>\n" +
    "                                <div id=\"wording_{{vm.selectedTemplate.language}}_froala\">\n" +
    "                                    <textarea id=\"emailBody\" name=\"emailBody\" class=\"form-control\" froala=\"vm.froalaOptions\" ng-model=\"vm.selectedTemplate.channels[0].body\" ng-disabled=\"vm.selectedFieldState.bodyTextDisabled\"></textarea>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <!-- digestFooter -->\n" +
    "                    <div class=\"row\" ng-if=\"!vm.selectedType.disableDigestFooter && vm.selectedTemplate.digestChannels[0].frequency === 'DAILY'\">\n" +
    "                        <div class=\"col-sm-12\">\n" +
    "                            <div class=\"form-group\">\n" +
    "                                <label for=\"digestFooter\" translate>onvio.setup.notifications.digestFooter</label>\n" +
    "                                <div id=\"wording_{{vm.selectedTemplate.language}}_froala\">\n" +
    "                                    <textarea id=\"digestFooter\" name=\"digestFooter\" class=\"form-control\" froala=\"vm.froalaOptions\" ng-model=\"vm.selectedTemplate.digestChannels[0].footer\"></textarea>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-sm-12\">\n" +
    "                            <span translate=\"BlueMoon.Setup.Common.RequiredField\"></span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-12\">\n" +
    "                    <hr class=\"bm-section-divider\" />\n" +
    "                    <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.saveTemplate()\" translate>\n" +
    "                        Bluemoon.Practice.Common.Actions.Save\n" +
    "                    </button>\n" +
    "                    <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!vm.isValidTemplate || !vm.selectedTemplate.sendEmail\" ng-click=\"vm.sendTest()\" translate>\n" +
    "                        onvio.setup.notifications.sendTest\n" +
    "                    </button>\n" +
    "                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.restoreDefault()\" translate>\n" +
    "                        onvio.setup.notifications.restoreDefault\n" +
    "                    </button>\n" +
    "                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.resetTemplate()\" translate>\n" +
    "                        Bluemoon.Practice.Common.Actions.Cancel\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("setup/src/custom-fields/custom-fields-setup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/custom-fields/custom-fields-setup.html",
    "<app-custom-fields></app-custom-fields>");
}]);

angular.module("setup/src/engagement-templates/engagement-template-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/engagement-templates/engagement-template-detail.html",
    "<!--\n" +
    "    vm is SetupListDetailController\n" +
    "    vm.detail is IDetailVm\n" +
    "    vm.domainModel is EngagementTemplateDomainModel\n" +
    "\n" +
    "vm.data is EngagementTemplateV1Dto see: http://ci.onvio.us/swagger/#!/EngagementTemplateV1EngagementTemplateV1/EngagementTemplateV1_Get\n" +
    "companyId (string, optional): UUID for the company to which the engagement template belongs. This is provided in the Uri, and is not required in the Dto,\n" +
    "code (string): User-specified identifier for this engagement template,\n" +
    "officeGroup (NamedReferenceDto): Office Grouping Type that indicates how to determine which office will be assigned to generated engagements. See /api/core/v1/office-grouping-types for values.,\n" +
    "billerGroup (NamedReferenceDto): Employee Grouping Type that indicates how to determine which employee will be assigned to generated engagements. See /api/core/v1/engagement-template-employee-grouping-types for values.,\n" +
    "reviewerGroup (NamedReferenceDto): Employee Grouping Type that indicates how to determine which employee will be assigned to generated engagements. See /api/core/v1/engagement-template-employee-grouping-types for values.,\n" +
    "managerGroup (NamedReferenceDto): Employee Grouping Type that indicates how to determine which employee will be assigned to generated engagements. See /api/core/v1/engagement-template-employee-grouping-types for values.,\n" +
    "isDefault (boolean): Whether or not this engagement will be used as a default for new clients that are entered.,\n" +
    "name (string): A description of this engagement,\n" +
    "office (NamedReferenceDto, optional): The office for the engagement from /api/core/v1/companies/{companyId}/offices,\n" +
    "category (NamedReferenceDto, optional): The engagement category from /api/core/v1/companies/{companyId}/engagement-categories,\n" +
    "biller (NamedReferenceDto, optional): The biller employee,\n" +
    "reviewer (NamedReferenceDto, optional): The reviewer employee,\n" +
    "manager (NamedReferenceDto, optional): The manager employee,\n" +
    "status (NamedReferenceDto): See /api/core/v1/engagement-statuses for values.,\n" +
    "invoiceDescription (string, optional): User-specified description that will be available for inclusion on invoices and reports,\n" +
    "generalLedgerAccount (string, optional): Called GL account by analysts and users. Defines the GL Account to which this engagement will be exported,\n" +
    "rateType (NamedReferenceDto): The rate information associate with this item. Can be either \"None\", \"Fixed rate\", or \"Staff rate\",\n" +
    "fixedRate (string, optional): The fixed rate amount Required when RateType is \"Fixed Rate\",\n" +
    "employeeRateDescription (NamedReferenceDto, optional): An employee rate description from /api/core/v1/companies/{companyId}/employee-rate-descriptions,\n" +
    "markupFactor (string): A markup/down factor for this engagement that will be used to alter the calculated value,\n" +
    "surchargeMethod (NamedReferenceDto): Values can be \"No surcharge\", \"Based on Activity\", \"Fixed amount\",\n" +
    "surchargeAmount (string, optional): Surchage amount for type \"Fixed amount\" EngagementSurchargeMethod==FixedAmount Required when surchargeMethod is \"Fixed amount\",\n" +
    "id (string, optional): A globally unique string used to reference the object. This value is assigned by the server and ignored (if present) on Posts.,\n" +
    "apiVersion (string, optional): Represents the desired version of the service API in a request, and the version of the service API that's served in the response.,\n" +
    "lang (string, optional): Indicates the language of the rest of the properties in this object.,\n" +
    "created (string, optional): Indicates the item creation date/time (RFC 3339).,\n" +
    "updated (string, optional): Indicates the last date/time (RFC 3339) the item was updated.\n" +
    "}        -->\n" +
    "<div class=\"row\">\n" +
    "    <!--ID-->\n" +
    "    <!-- /* i18nextract */'Core.Captions.EngagementTemplate.Code' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"engagementTemplateCode\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.Code' | translate | bmRequiredMark}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'code')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"engagementTemplateCode\"\n" +
    "               name=\"engagementTemplateCode\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-disabled=\"vm.data.systemId\"\n" +
    "               data-ng-required=\"true\"\n" +
    "               data-ng-model=\"vm.data.code\"\n" +
    "               data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'code')\"\n" +
    "               data-bmp-entity-code=\"\"\n" +
    "               data-bmp-entity-code-id=\"vm.data.id\"\n" +
    "               data-bmp-entity-code-type=\"engagement-templates\"\n" +
    "               data-bmp-entity-code-company-id=\"vm.detail.getCurrentCompanyId()\"\n" +
    "               data-bm-focus-on-link=\"\"\n" +
    "               data-fef-maxlength=\"20\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Name-->\n" +
    "    <!-- /* i18nextract */'Core.Captions.Engagement.Name' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"engagementTemplateName\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.Name' | translate | bmRequiredMark}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"engagementTemplateName\"\n" +
    "               name=\"engagementTemplateName\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-required=\"true\"\n" +
    "               data-ng-disabled=\"vm.data.systemId\"\n" +
    "               data-ng-model=\"vm.data.name\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'name')\"\n" +
    "               data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Invoice Description-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"engagementTemplateInvoiceDescription\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.InvoiceDescription' | translate }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceDescription')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <textarea rows=\"3\"\n" +
    "                  id=\"engagementTemplateInvoiceDescription\"\n" +
    "                  name=\"engagementTemplateInvoiceDescription\"\n" +
    "                  class=\"form-control\"\n" +
    "                  data-ng-disabled=\"vm.data.systemId\"\n" +
    "                  data-ng-model=\"vm.data.invoiceDescription\"\n" +
    "                  data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'invoiceDescription')\"\n" +
    "                  data-ng-style=\"{'height':'auto'}\">\n" +
    "        </textarea>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Default for new clients checkbox-->\n" +
    "    <div class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "        <div data-toggle=\"buttons-checkbox\">\n" +
    "            <div>\n" +
    "                <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                       name=\"isDefault\"\n" +
    "                       id=\"isDefault\"\n" +
    "                       data-ng-model=\"vm.data.$isDefault\"\n" +
    "                       data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'isDefault')\">\n" +
    "                <label for=\"isDefault\">\n" +
    "                    <span translate=\"{{'Core.Captions.EngagementTemplate.IsDefault' | translate }}\"></span>\n" +
    "                </label>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Status -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"status\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.Status' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(data, 'status')\"\n" +
    "         class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "        <bmp-enum-radio-button-group name=\"status\"\n" +
    "                                 ng-model=\"vm.data.$status\"\n" +
    "                                 enum=\"engagement-statuses\">\n" +
    "        </bmp-enum-radio-button-group>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- GL Account -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"generalLedgerAccount\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.GeneralLedgerAccount' | translate }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'generalLedgerAccount')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"generalLedgerAccount\"\n" +
    "               name=\"generalLedgerAccount\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-model=\"vm.data.generalLedgerAccount\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'generalLedgerAccount')\"\n" +
    "               data-fef-maxlength=\"60\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Groupings header static text -->\n" +
    "    <!--TODO: should I make a duplicate string resource for \"Groupings\"? Recycle for now.-->\n" +
    "    <h2 class=\"col-md-6\">{{'Onvio.Setup.Activities.ActivityDetail.GroupingsSectionHeader' | translate }}</h2>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Engagement Category -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"engagementCategory\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.Category' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'category')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "        <bmp-select-combo list=\"engagement-categories\"\n" +
    "                          name=\"engagementCategory\"\n" +
    "                          ng-model=\"vm.data.category\">\n" +
    "        </bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Office Grouping -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "    data-bmp-control-group-field-id=\"officeGroup\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.OfficeGroup' | translate}}\"\n" +
    "       data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'officeGroup')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"office-grouping-types\"\n" +
    "                       name=\"officeGroup\"\n" +
    "                       ng-model=\"vm.data.officeGroup\"\n" +
    "                       required></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyOffice(vm.data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "    data-bmp-control-group-field-id=\"office\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Office.ClassOne' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'officeGroup')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"offices\" name=\"office\"\n" +
    "                              ng-model=\"vm.data.office\"></bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Biller Grouping -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "    data-bmp-control-group-field-id=\"billerGroup\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.BillerGroup' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'billerGroup')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"engagement-template-employee-grouping-types\"\n" +
    "                        name=\"billerGroup\"\n" +
    "                        ng-model=\"vm.data.billerGroup\"\n" +
    "                        required></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyBillerEmployee(vm.data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "    data-bmp-control-group-field-id=\"biller\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Employee.ClassOne' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'biller')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\" name=\"biller\"\n" +
    "                              ng-model=\"vm.data.biller\"></bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Reviewer Grouping -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "    data-bmp-control-group-field-id=\"reviewerGroup\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.ReviewerGroup' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'reviewerGroup')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"engagement-template-employee-grouping-types\"\n" +
    "                        name=\"reviewerGroup\"\n" +
    "                        ng-model=\"vm.data.reviewerGroup\"\n" +
    "                        required></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyReviewerEmployee(vm.data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"reviewer\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Employee.ClassOne' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'reviewer')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\" name=\"reviewer\"\n" +
    "                              ng-model=\"vm.data.reviewer\"></bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Manager Grouping -->\n" +
    "    <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"managerGroup\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.ManagerGroup' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'managerGroup')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"engagement-template-employee-grouping-types\"\n" +
    "                        name=\"managerGroup\"\n" +
    "                        ng-model=\"vm.data.managerGroup\"\n" +
    "                        required></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyManagerEmployee(vm.data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"manager\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Employee.ClassOne' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'manager')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\" name=\"manager\"\n" +
    "                              ng-model=\"vm.data.manager\"></bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Rates header static text-->\n" +
    "    <h2 class=\"col-md-6\">{{'Bluemoon.Core.Setup.EngagementTemplates.Common.EngagementTemplateDetail.RatesSectionHeader' | translate }}</h2>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <!--Rate-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"rateType\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.RateType' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'rateType')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "         <fieldset>\n" +
    "            <legend class=\"hide-legend-border\"\n" +
    "            aria-label=\"{{'Core.Captions.Engagement.RateType' | translate}}\"></legend>\n" +
    "\n" +
    "        <div data-toggle=\"buttons-checkbox\">\n" +
    "            <div>\n" +
    "                <!--No Rate radio-->\n" +
    "                <bmp-enum-radio enum=\"rate-types\"\n" +
    "                            name=\"rateType\"\n" +
    "                            value=\"NORATE\"\n" +
    "                            ng-model=\"vm.data.rateType\"\n" +
    "                            ng-change=\"vm.domainModel.onRateTypeChanged(vm.data)\">\n" +
    "                </bmp-enum-radio>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "                <!--Fixed Rate radio button-->\n" +
    "                <bmp-enum-radio enum=\"rate-types\"\n" +
    "                            name=\"rateType\"\n" +
    "                            value=\"FIXEDRATE\"\n" +
    "                            ng-model=\"vm.data.rateType\"\n" +
    "                            ng-change=\"vm.domainModel.onRateTypeChanged(vm.data)\">\n" +
    "                </bmp-enum-radio>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "                <!--Employee Rate radio button-->\n" +
    "                <bmp-enum-radio enum=\"rate-types\"\n" +
    "                            name=\"rateType\"\n" +
    "                            value=\"EMPLOYEERATE\"\n" +
    "                            ng-model=\"vm.data.rateType\"\n" +
    "                            ng-change=\"vm.domainModel.onRateTypeChanged(vm.data)\">\n" +
    "                </bmp-enum-radio>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        </fieldset>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyEmployeeRateDescription(vm.data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"employeeRateDescription\"\n" +
    "             data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.EngagementTemplates.Common.EngagementTemplateDetail.StaffRate' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'rateType')\"\n" +
    "             class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "\n" +
    "            <!--Employee Rate radio button's Employee Rate Description selector-->\n" +
    "            <bmp-select-combo list=\"employee-rate-descriptions\"\n" +
    "                              list-style=\"basic\"\n" +
    "                              name=\"employeeRateDescription\"\n" +
    "                              ng-model=\"vm.data.employeeRateDescription\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.showFixedRate(vm.data)\">\n" +
    "        <!-- Fixed Rate -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"fixedRate\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.FixedRate' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'fixedRate')\"\n" +
    "             class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   class=\"form-control input-lg\"\n" +
    "                   data-ng-model=\"vm.data.fixedRate\"\n" +
    "                   data-bmp-clear-value=\"0\"\n" +
    "                   data-bmp-big-number=\"'c2'\"\n" +
    "                   bm-format-on-blur=\"\"\n" +
    "                   data-bmp-big-number-range-validator\n" +
    "                   min=\"0\"\n" +
    "                   max=\"9999999\"\n" +
    "                   aria-label=\"{{'Core.Captions.EngagementTemplate.FixedRate' | translate}}\"\n" +
    "                   data-bmp-control-group-field=\"Core.Captions.EngagementTemplate.FixedRate\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Markup/down factor -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"markupFactor\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.MarkupFactor' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'markupFactor')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               class=\"form-control input-lg\"\n" +
    "               data-ng-model=\"vm.data.markupFactor\"\n" +
    "               data-bmp-clear-value=\"1\"\n" +
    "               data-bmp-big-number=\"'n4'\"\n" +
    "               bm-format-on-blur=\"\"\n" +
    "               data-bmp-big-number-range-validator\n" +
    "               min=\"0.0001\"\n" +
    "               max=\"99.9999\"\n" +
    "               aria-labelledby=\"markupFactor-label\"\n" +
    "               data-bmp-control-group-field=\"Core.Captions.Engagement.MarkupFactor\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div>\n" +
    "    <div class=\"row\" bm-if-has-access=\"OnvioIndirectTax.TaxGroups\">\n" +
    "        <div ng-if=\"vm.domainModel.showTaxGroup(vm.data)\">\n" +
    "            <!-- Tax Group -->\n" +
    "            <div bm-if-perm-some=\"['TimeAndBilling.AssessServiceCharges','TimeAndBilling.Billing','TimeAndBilling.PrintStatements','TimeAndBilling.ReceiptAndAdjustment','TimeAndBilling.ReviewInvoices','TimeAndBilling.TimeAndExpense']\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"taxgroup\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.TaxGroupId' | translate}}\"\n" +
    "                    data-bmp-data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taxgroupId')\"\n" +
    "                    class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"taxGroupList\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    name=\"taxgroup\"\n" +
    "                                    ng-model=\"vm.data.$taxGroup\" provider=\"vm.domainModel.indirectTaxProvider\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div>\n" +
    "    <div class=\"row\">\n" +
    "        <!--Surcharge header static text-->\n" +
    "        <h2 class=\"col-md-6\">{{'Bluemoon.Core.Setup.EngagementTemplates.Common.EngagementTemplateDetail.SurchargeSectionHeader' | translate }}</h2>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!--Surcharge Method-->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"surchargeMethod\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.Engagement.SurchargeMethod' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'surchargeMethod')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "            <fieldset>\n" +
    "                <legend class=\"hide-legend-border\"\n" +
    "                aria-label=\"{{'Core.Captions.Engagement.SurchargeMethod' | translate}}\"></legend>\n" +
    "            <div data-toggle=\"buttons-checkbox\">\n" +
    "                <div>\n" +
    "                    <!--Based on Activity radio button-->\n" +
    "                    <bmp-enum-radio enum=\"engagement-surcharge-methods\"\n" +
    "                                name=\"surchargeMethod\"\n" +
    "                                value=\"BASEDONACTIVITY\"\n" +
    "                                ng-model=\"vm.data.surchargeMethod\">\n" +
    "                    </bmp-enum-radio>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <!--Flat Amount radio-->\n" +
    "                    <bmp-enum-radio enum=\"engagement-surcharge-methods\"\n" +
    "                                name=\"surchargeMethod\"\n" +
    "                                value=\"FIXEDAMOUNT\"\n" +
    "                                ng-model=\"vm.data.surchargeMethod\"\n" +
    "                                ng-change=\"vm.domainModel.onFixedSurchargeChanged(vm.data)\">\n" +
    "                    </bmp-enum-radio>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <!--None radio button-->\n" +
    "                    <bmp-enum-radio enum=\"engagement-surcharge-methods\"\n" +
    "                                name=\"surchargeMethod\"\n" +
    "                                value=\"NOSURCHARGE\"\n" +
    "                                ng-model=\"vm.data.surchargeMethod\">\n" +
    "                    </bmp-enum-radio>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            </fieldset>\n" +
    "        </div>\n" +
    "        <div ng-show=\"vm.domainModel.showFixedSurcharge(vm.data)\">\n" +
    "            <!-- Flat amount surcharge -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"surchargeAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Enums.EngagementSurchargeMethod.FIXEDAMOUNT' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'surchargeAmount')\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                <input autocomplete=\"off\" type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.surchargeAmount\"\n" +
    "                    data-bmp-clear-value=\"0\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    data-bmp-big-number-range-validator\n" +
    "                    min=\"0\"\n" +
    "                    max=\"9999999.99\"\n" +
    "                    data-bmp-control-group-field=\"Core.Enums.EngagementSurchargeMethod.FIXEDAMOUNT\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/import-export-test/import-export-test.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/import-export-test/import-export-test.html",
    "<app-import-export-test bm-if-perm=\"OnvioSetup.DataServices\"></app-import-export-test>");
}]);

angular.module("setup/src/import-progress/import-progress.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/import-progress/import-progress.html",
    "<div class=\"ng-bento\">\n" +
    "    <import-status></import-status>\n" +
    "</div>");
}]);

angular.module("setup/src/import-wizard/import-ledger.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/import-wizard/import-ledger.html",
    "<div class=\"ng-bento\">\n" +
    "    <import-wizard\n" +
    "        type=\"ledger\"\n" +
    "        (finish-import)=\"vm.openProgressPage()\"\n" +
    "    ></import-wizard>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/import-wizard/import-wip.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/import-wizard/import-wip.html",
    "<div class=\"ng-bento\">\n" +
    "    <import-wizard\n" +
    "        type=\"wip\"\n" +
    "        (finish-import)=\"vm.openProgressPage()\"\n" +
    "    ></import-wizard>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/late-fee-templates/late-fee-template-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/late-fee-templates/late-fee-template-detail.html",
    "<div class=\"row\">\n" +
    "    <!--Name-->\n" +
    "    <!-- /* i18nextract */'Core.Captions.LateFeeTemplate.Name' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"lateFeeTemplateName\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.LateFeeTemplate.Name' | translate | bmRequiredMark}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "         class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"lateFeeTemplateName\"\n" +
    "               name=\"lateFeeTemplateName\"\n" +
    "               class=\"form-control\"\n" +
    "               data-bmp-entity-code=\"\"\n" +
    "               data-bmp-entity-code-id=\"vm.data.name\"\n" +
    "               data-bmp-entity-code-type=\"late-fees\"\n" +
    "               data-ng-required=\"true\"\n" +
    "               data-ng-disabled=\"vm.data.systemId\"\n" +
    "               data-ng-model=\"vm.data.name\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'name')\"\n" +
    "               data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Annual Rate-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"lateFeeTemplateAnnualRate\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.LateFeeTemplate.AnnualRate' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'annualRate')\"\n" +
    "         class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"lateFeeTemplateAnnualRate\"\n" +
    "               name=\"lateFeeTemplateAnnualRate\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-model=\"vm.data.$scaledAnnualRate\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'annualRate')\"\n" +
    "               data-bmp-clear-value=\"1.00\"\n" +
    "               data-bmp-big-number=\"'p2'\"\n" +
    "               bm-format-on-blur=\"\"\n" +
    "               data-bmp-big-number-range-validator\n" +
    "               min=\"0.01\"\n" +
    "               max=\"100\"\n" +
    "               data-bmp-control-group-field=\"Core.Captions.LateFeeTemplate.AnnualRate\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <label>\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                    ng-model=\"vm.data.roundAmount\" /> {{'Bluemoon.Setup.LateFeeTemplate.RoundAmount' | translate}}\n" +
    "        </label>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <label>\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                    id=\"lateFeeTemplateCompoundPrior\"\n" +
    "                    name=\"lateFeeTemplateCompoundPrior\"\n" +
    "                    data-ng-model=\"vm.data.compoundPrior\" /> {{'Core.Captions.LateFeeTemplate.CompoundPrior' | translate}}\n" +
    "        </label>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Grace Days-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"lateFeeTemplateGraceDays\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.LateFeeTemplate.GraceDays' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'graceDays')\"\n" +
    "         class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"number\"\n" +
    "               id=\"lateFeeTemplateGraceDays\"\n" +
    "               name=\"lateFeeTemplateGraceDays\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-model=\"vm.data.graceDays\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'graceDays')\"\n" +
    "               data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "               bmp-integer\n" +
    "               bm-format-on-blur=\"\"\n" +
    "               data-bmp-big-number-range-validator\n" +
    "               min=\"0\"\n" +
    "               max=\"999\"\n" +
    "               data-bmp-control-group-field=\"Core.Captions.LateFeeTemplate.GraceDays\"\n" +
    "               data-ng-required=\"true\"\n" +
    "               data-bmp-clear-value=\"0\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Late Fee Template Type ('Calculate from')-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"lateFeeTemplateTemplateType\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.LateFeeTemplate.LateFeeTemplateType' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'lateFeeTemplateType')\"\n" +
    "         class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"late-fee-template-types\"\n" +
    "                       name=\"lateFeeTemplateType\"\n" +
    "                       ng-model=\"vm.data.lateFeeTemplateType\"\n" +
    "                       required=\"true\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Minimum Balance-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"lateFeeTemplateMinimumBalance\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.LateFeeTemplate.MinimumBalance' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'minimumBalance')\"\n" +
    "         class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"lateFeeTemplateMinimumBalance\"\n" +
    "               name=\"lateFeeTemplateMinimumBalance\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-model=\"vm.data.minimumBalance\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'minimumBalance')\"\n" +
    "               data-bmp-clear-value=\"0\"\n" +
    "               data-bmp-big-number=\"'c2'\"\n" +
    "               bm-format-on-blur=\"\"\n" +
    "               data-bmp-big-number-range-validator\n" +
    "               min=\"0\"\n" +
    "               max=\"9999999\"\n" +
    "               data-bmp-control-group-field=\"Core.Captions.LateFeeTemplate.MinimumBalance\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Minimum Charge-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"lateFeeTemplateMinimumCharge\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.LateFeeTemplate.MinimumCharge' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'minimumCharge')\"\n" +
    "         class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"lateFeeTemplateMinimumCharge\"\n" +
    "               name=\"lateFeeTemplateMinimumCharge\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-model=\"vm.data.minimumCharge\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'minimumCharge')\"\n" +
    "               data-bmp-clear-value=\"0\"\n" +
    "               data-bmp-big-number=\"'c2'\"\n" +
    "               bm-format-on-blur=\"\"\n" +
    "               data-bmp-big-number-range-validator\n" +
    "               min=\"0\"\n" +
    "               max=\"9999999\"\n" +
    "               data-bmp-control-group-field=\"Core.Captions.LateFeeTemplate.MinimumCharge\"\n" +
    "               bmp-custom-validation=\"vm.domainModel.checkMaximumAndMinimumCharge(vm.data)\"\n" +
    "               bmp-custom-validation-message=\"Bluemoon.Setup.LateFeeTemplate.MinimumChargeGreaterError\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Maximum Charge-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"lateFeeTemplateMaximumCharge\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'maximumCharge')\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.LateFeeTemplate.MaximumCharge' | translate}}\"\n" +
    "         data-bmp-control-group-label-hide=\"true\"\n" +
    "         class=\"form-group col-md-4 col-sm-6 col-xs-12\">\n" +
    "        <label class=\"control-label inline\" for=\"lateFeeTemplateMaximumChargeChexbox\">\n" +
    "           <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                    id=\"lateFeeTemplateMaximumChargeChexbox\"\n" +
    "                    name=\"lateFeeTemplateMaximumChargeChexbox\"\n" +
    "                    data-ng-model=\"vm.data.$hasMaximumCharge\" /> {{'Core.Captions.LateFeeTemplate.MaximumCharge' | translate}}</label>\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"lateFeeTemplateMaximumCharge\"\n" +
    "               name=\"lateFeeTemplateMaximumCharge\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-disabled=\"!vm.data.$hasMaximumCharge\"\n" +
    "               data-ng-model=\"vm.data.maximumCharge\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'maximumCharge')\"\n" +
    "               data-bmp-clear-value=\"0\"\n" +
    "               data-bmp-big-number=\"'c2'\"\n" +
    "               bm-format-on-blur=\"\"\n" +
    "               data-bmp-big-number-range-validator\n" +
    "               min=\"0\"\n" +
    "               max=\"9999999\"\n" +
    "               data-bmp-control-group-field=\"Core.Captions.LateFeeTemplate.MaximumCharge\"\n" +
    "               bmp-custom-validation=\"vm.domainModel.checkMaximumAndMinimumCharge(vm.data)\"\n" +
    "               bmp-custom-validation-message=\"Bluemoon.Setup.LateFeeTemplate.MaximumChargeLessError\" />\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/file-cabinet/fclist-form-toolbar.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/file-cabinet/fclist-form-toolbar.2js.html",
    "<div bento-nav-toolbar class=\"navbar navbar-default bento-toolbar\" aria-controls=\"table2\">\n" +
    "\n" +
    "    <ul class=\"nav navbar-nav\">\n" +
    "        <li><a href=\"#/setup/migrations/file-cabinet/new\"><i class=\"glyphicon bento-icon-add\"></i>\n" +
    "            <span class=\"migration-toolbar-header\" translate>Onvio.Migrations.Title.NewMigration</span>\n" +
    "        </a></li>\n" +
    "    </ul>\n" +
    "\n" +
    "    <div ng-form class=\"navbar-form navbar-right\" role=\"search\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <label class=\"sr-only\" for=\"toolbarSearch\">{{'Bluemoon.Practice.Common.Label.Search' | translate}}</label>\n" +
    "            <input type=\"text\" id=\"toolbarSearch\" class=\"form-control\"\n" +
    "                   placeholder=\"{{'Bluemoon.Practice.Common.Placeholder.Search' | translate}}\"\n" +
    "                   bm-focus-on-link=\"\"\n" +
    "                   bento-reset=\"\"\n" +
    "                   ng-model=\"searchTerm\"\n" +
    "                   ng-model-options=\"{ debounce: 250 }\"\n" +
    "                   ng-change=\"onSearch()\"\n" +
    "                   data-qe-id=\"toolbar-search\"\n" +
    "                   size=\"40\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- This corresponds to ARIA of Toolbar above, for 508 Compliance -->\n" +
    "    <table id=\"table2\"></table>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/file-cabinet/fclist-form.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/file-cabinet/fclist-form.2js.html",
    "<div class=\"container-fluid no-left-padding view-container\">\n" +
    "\n" +
    "    <!-- TOOLBAR -->\n" +
    "    <file-cabinet-form-toolbar></file-cabinet-form-toolbar>\n" +
    "\n" +
    "	  <!-- CONTENT -->\n" +
    "  	<div bento-busy-loader=\"busyLoading\">\n" +
    "   	    <wj-flex-grid control=\"ctx.flexGrid\" items-source1=\"ctx.data\" class=\"bento-flex-grid\" selection-mode=\"Row\"\n" +
    "   	    item-formatter=\"itemFormatter\">\n" +
    "\n" +
    "        	<wj-flex-grid-column header=\"{{fctrans('Actions')}}\" binding=\"\" min-width=\"100\" width=\"130\" align=\"left\" is-read-only=\"true\">\n" +
    "        		<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "          			<i ng-if=\"$item.status === 'Complete'\" class=\"bento-icon-edit grid-action-icon\" ng-click=\"actions.editRow($item)\"\n" +
    "          				data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"Edit\" data-tooltip-append-to-body=\"true\">\n" +
    "          			</i>\n" +
    "          			<i ng-if=\"$item.status === 'Complete'\" class=\"bento-icon-edit-filled-doc grid-action-icon\"\n" +
    "          				ng-click=\"actions.editDocRow($item)\"\n" +
    "          				data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"Edit Document\"\n" +
    "          				data-tooltip-append-to-body=\"true\">\n" +
    "          			</i>\n" +
    "                <!--\n" +
    "          			<i ng-if=\"$item.status === 'In.Progress'\" class=\"bento-icon-pause grid-action-icon\" ng-click=\"actions.pauseRow($item)\"\n" +
    "          				data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"Pause\"\n" +
    "          				data-tooltip-append-to-body=\"true\">\n" +
    "          			</i>\n" +
    "                -->\n" +
    "          			<i ng-if=\"$item.status !== 'Complete'\" class=\"bento-icon-close-circle grid-action-icon\"\n" +
    "          				ng-click=\"actions.closeRow($item)\" data-tooltip-placement=\"top\"\n" +
    "          				data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"Close\" data-tooltip-append-to-body=\"true\">\n" +
    "          			</i>\n" +
    "          			<i class=\"bento-icon-info grid-action-icon\" ng-class=\"{active: dp.isDetailVisible($row)}\"\n" +
    "          				ng-click=\"actions.toggleDetail($row, dp)\" data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\"\n" +
    "          				data-uib-tooltip=\"Detail\" data-tooltip-append-to-body=\"true\">\n" +
    "          			</i>\n" +
    "          			<span ng-if=\"$item.status === 'Info.Needed'\" class=\"label label-warning migration-attention-label\"> {{fctrans('Attention')}}\n" +
    "          			</span>\n" +
    "        		</wj-flex-grid-cell-template>\n" +
    "      		</wj-flex-grid-column>\n" +
    "\n" +
    "      		<wj-flex-grid-column min-width=\"70\" width=\"90\" header=\"{{fctrans('StartDate')}}\" binding=\"startDate\"> {{getStartDate($item)}} </wj-flex-grid-column>\n" +
    "\n" +
    "      		<wj-flex-grid-column min-width=\"80\" width=\"*\" header=\"{{fctrans('Drawers')}}\" binding=\"uploadedDrawers\"></wj-flex-grid-column>\n" +
    "\n" +
    "      		<wj-flex-grid-column min-width=\"80\" width=\"*\" header=\"{{fctrans('Description')}}\" binding=\"description\"></wj-flex-grid-column>\n" +
    "\n" +
    "      		<wj-flex-grid-column min-width=\"70\" width=\"100\" header=\"{{fctrans('Status')}}\" binding=\"status\">{{getStatusText($item)}}</wj-flex-grid-column>\n" +
    "\n" +
    "      		<wj-flex-grid-column min-width=\"80\" width=\"120\" header=\"\" binding=\"progress\" align=\"left\">\n" +
    "      			<div uib-progressbar value=\"itemProgressPercent($item)\" type=\"{{itemProgressType($item)}}\" binding=\"progress\">{{itemProgressLabel($item)}}</div>\n" +
    "      		</wj-flex-grid-column>\n" +
    "\n" +
    "      		<wj-flex-grid-column min-width=\"80\" width=\"80\" header=\"{{fctrans('Size')}}\" binding=\"totalSize\" align=\"left\">{{$item.totalSize}} MB</wj-flex-grid-column>\n" +
    "\n" +
    "      		<wj-flex-grid-detail detail-visibility-mode=\"Code\" control=\"dp\">\n" +
    "        		<div class=\"table-cell width-full\">\n" +
    "          			<strong>{{fctrans('SelectedDrawers')}}:</strong>\n" +
    "          		</div>\n" +
    "        		<div class=\"table-cell width-full\">\n" +
    "                	{{$item.selectedDrawers}}\n" +
    "        		</div>\n" +
    "      		</wj-flex-grid-detail>\n" +
    "\n" +
    "      	</wj-flex-grid>\n" +
    "  	</div>\n" +
    "\n" +
    "    <!-- NO-RESULTS -->\n" +
    "    <span class=\"setup-common-list-grid-view-centered-span\"\n" +
    "          data-ng-show=\"!busyLoading && hasNoData()\"\n" +
    "          data-translate=\"Bluemoon.Practice.Common.List.NoResults\"\n" +
    "          data-qe-id=\"none-message\">\n" +
    "    </span>\n" +
    "\n" +
    "    <!-- FOOTER -->\n" +
    "    <div data-bento-pagination\n" +
    "         data-qe-id=\"pagination\"\n" +
    "         data-page=\"gridData.currentPage\"\n" +
    "         data-on-change=\"gridData.changePage(page)\"\n" +
    "         data-direction-links=\"true\"\n" +
    "         data-boundary-links=\"true\"\n" +
    "         data-hide-go=\"true\"\n" +
    "         data-total-items=\"gridData.totalItemCount\"\n" +
    "         data-items-array=\"gridData.pageSizeOption\"\n" +
    "         data-on-change-size=\"gridData.changePageSize(size)\"\n" +
    "         data-items-per-page=\"gridData.itemsPerPage\"\n" +
    "         data-go-to-text=\"{{'Bluemoon.Practice.Common.List.GoTo' | translate}}\"\n" +
    "         data-info-text=\"{{'Bluemoon.Practice.Common.List.Info' | translate}}\"\n" +
    "         data-info-page-text=\"{{'Bluemoon.Practice.Common.Label.PageInfo' | translate}}\">\n" +
    "    </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/file-cabinet/migration-creation/creation-main.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/file-cabinet/migration-creation/creation-main.2js.html",
    "<div id=\"new-migration-view\" class=\"no-left-padding bm-cn\">\n" +
    "\n" +
    "    <h1 class=\"no-top-margin\"><span translate>Onvio.Migrations.Title.NewMigration</span> -\n" +
    "      <small><span translate>Onvio.Migrations.Product.FileCabinet</span>:\n" +
    "      <span class=\"knowlesge-light\">{{migrationDescription}}</span></small></h1>\n" +
    "\n" +
    "    <div>\n" +
    "  	  	<div bento-wizard\n" +
    "        		on-change=\"onWizardChange(step)\"\n" +
    "        		on-finish=\"onWizardFinish()\"\n" +
    "       	 	  use-side-arrows=\"true\"\n" +
    "       		  current-step=\"step\"\n" +
    "       		  total-step=\"totalStep\"\n" +
    "            hide-previous-button=\"hidePreviousButton\"\n" +
    "            hide-next-button=\"hideNextButton\">\n" +
    "    	      <!-- Define step titles and descriptions -->\n" +
    "    	      <ol class=\"steps\">\n" +
    "      		      <li ng-disabled=\"stepDisabled[screens.appsNetwork]\">\n" +
    "        		        <span class=\"title\" translate=\"Onvio.Migrations.ApplicationsNetwork.Title\"></span>\n" +
    "        		        <span class=\"description\" translate=\"Onvio.Migrations.ApplicationsNetwork.Desc\"></span>\n" +
    "      		      </li>\n" +
    "      		      <li ng-disabled=\"disableDrawerSelection()\">\n" +
    "                    <span class=\"title\" translate=\"Onvio.Migrations.DrawerSelection.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Onvio.Migrations.DrawerSelection.Desc\"></span>\n" +
    "      		      </li>\n" +
    "                <li ng-disabled=\"stepDisabled[screens.confirmation]\">\n" +
    "                    <span class=\"title\" translate=\"Onvio.Migrations.Confirmation.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Onvio.Migrations.Confirmation.Desc\"></span>\n" +
    "                </li>\n" +
    "    	      </ol>\n" +
    "\n" +
    "            <!-- Define content for each step -->\n" +
    "    	      <ul class=\"contents no-margin-t no-padding-t\">\n" +
    "      		      <li><fc-apps-network-form></fc-apps-network-form></li>\n" +
    "      		      <li><fc-drawer-selection-form></fc-drawer-selection-form></li>\n" +
    "      		      <li><fc-confirmation-form></fc-confirmation-form></li>\n" +
    "            </ul>\n" +
    "\n" +
    "            <!-- Custom buttons -->\n" +
    "            <button class=\"btn btn-default pull-left\" ng-show=\"showCancelButton()\" ng-click=\"cancelNewMigration()\">\n" +
    "                <span translate=\"Onvio.Migrations.Actions.Cancel\"></span>\n" +
    "            </button>\n" +
    "            <button class=\"btn btn-primary pull-right\" ng-show=\"showStartMigrationButton()\" ng-disabled=\"disableStartMigrationButton()\" ng-click=\"startMigration()\">\n" +
    "                <span translate=\"Onvio.Migrations.Actions.StartMigration\"></span>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/file-cabinet/migration-creation/fcapp-network.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/file-cabinet/migration-creation/fcapp-network.2js.html",
    "<div>\n" +
    "	  <h4><strong><span translate=\"Onvio.Migrations.ApplicationsNetwork.Title\"></span></strong></h4>\n" +
    "\n" +
    "	  <form name=\"appsNetworkForm\" role=\"form\">\n" +
    "    <div class=\"row\">\n" +
    "    <div class=\"col-md-5\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error' : (appsNetworkForm.migrationDescription.$invalid && appsNetworkForm.migrationDescription.$dirty)}\">\n" +
    "            <label for=\"migrationDescription\"><span translate>Onvio.Migrations.New.Description</span> *</label>\n" +
    "            <input type=\"text\" id=\"migrationDescription\" name=\"migrationDescription\" class=\"form-control\"\n" +
    "                ng-model=\"migrationDescription\" bm-focus=\"true\" required ng-disabled=\"step === screens.confirmation\" />\n" +
    "            <div ng-show=\"appsNetworkForm.migrationDescription.$invalid && appsNetworkForm.migrationDescription.$dirty\" class=\"msg\" translate=\"BlueMoon.Setup.Common.RequiredField\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "    <div class=\"col-md-5\">\n" +
    "		    <div class=\"form-group\" ng-class=\"{'has-error': (appsNetworkForm.pathToData.$invalid && appsNetworkForm.pathToData.$dirty)}\">\n" +
    "			     <label for=\"pathToData\"><span translate=\"Onvio.Migrations.Path.To.Data\"></span> *</label>\n" +
    "		       <!--input id=\"pathToData\" name=\"pathToData\" class=\"form-control\" type=\"text\" ng-model=\"pathToData\" required /-->\n" +
    "\n" +
    "           <div data-bento-select>\n" +
    "               <select id=\"pathToData\" name=\"pathToData\" class=\"form-control\" ng-model=\"pathToData\" required>\n" +
    "                   <option ng-repeat=\"opt in dataPathOptions\" value=\"{{opt}}\">{{opt}}</option>\n" +
    "               </select>\n" +
    "           </div>\n" +
    "           <div ng-show=\"appsNetworkForm.pathToData.$invalid && appsNetworkForm.pathToData.$dirty\" class=\"msg\" translate=\"BlueMoon.Setup.Common.RequiredField\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "	 </form>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/file-cabinet/migration-creation/fcconfirmation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/file-cabinet/migration-creation/fcconfirmation.2js.html",
    "<div>\n" +
    "  <h4><strong><span translate=\"Onvio.Migrations.Confirmation.Success\"></span></strong></h4>\n" +
    "  <span class=\"description\" translate=\"Onvio.Migrations.Confirmation.Instruction\"></span>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/file-cabinet/migration-creation/fcdrawer-selection.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/file-cabinet/migration-creation/fcdrawer-selection.2js.html",
    "<div>\n" +
    "	  <div class=\"row\" bento-busy-loader=\"busyLoading\">\n" +
    "		  <div class=\"col-md-5\">\n" +
    "			  <h4><strong>\n" +
    "				  <span ng-show=\"!loadItemSetBusy\" translate=\"Onvio.Migrations.DrawerSelection.Title\"></span>\n" +
    "				  <span ng-show=\"loadItemSetBusy\" translate=\"Uploading Items Set\"></span>\n" +
    "			  </strong></h4>\n" +
    "		  </div>\n" +
    "	  </div>\n" +
    "  	<div class=\"row\">\n" +
    "  	  	<div class=\"col-md-12\">\n" +
    "  			<div ng-if=\"showAvailableDrawersNote()\">Your available drawers were uploaded from the path \"{{pathToData}}\".\n" +
    "  			</div>\n" +
    "  			<div ng-if=\"showEmptyDrawersNote()\"><span class=\"label label-warning\">Attention:</span>\n" +
    "          Your availabe drawers have not been uploaded yet from the path \"{{pathToData}}\".\n" +
    "  			</div>\n" +
    "  		</div>\n" +
    "  	</div>\n" +
    "  	<div class=\"row\">\n" +
    "  		<div class=\"col-md-5\">\n" +
    "  		</div>\n" +
    "  		<div>\n" +
    "  			<button type=\"button\" class=\"btn btn-default\" ng-click=\"loadItemSet()\" bento-busy-loader=\"loadItemSetBusy\">{{loadItemsButtonText()}}</button>\n" +
    "  			<div bento-alert bento-alert-object=\"loadItemSetAlerts\"></div>\n" +
    "        <div bento-alert bento-alert-object=\"migrationCreatedAlerts\"></div>\n" +
    "  		</div>\n" +
    "  	</div>\n" +
    "\n" +
    "  	<div ng-show=\"showUploadingStatus()\">\n" +
    "		<div class=\"row\">\n" +
    "  			<div class=\"col-md-12\">Drawers set uploading status: <span class=\"{{uploadingStatusClass}}\">{{currentUploadingStatus()}}</span></div>\n" +
    "  		</div>\n" +
    "  		<div class=\"row\">\n" +
    "  			<div class=\"col-md-12\">Drawers set uploaded count: <span class=\"count-highlight\">{{currentUploadingCount()}}</span></div>\n" +
    "  		</div>\n" +
    "  		<div class=\"row\">\n" +
    "  			<div class=\"col-md-12\">Lastest uploading time: {{latestUploadingTime()}}</div>\n" +
    "  		</div>\n" +
    "  		<div class=\"row\" ng-show=\"loadItemSetBusy\">\n" +
    "  			<div class=\"col-md-12\">Checking uploading status timeout: <span class=\"count-highlight\">{{timeoutCounterText}}</span></div>\n" +
    "  		</div>\n" +
    "  	</div>\n" +
    "\n" +
    "  	<div ng-show=\"!loadItemSetBusy\">\n" +
    "  		<div class=\"row\" ng-show=\"showUploadingContinue()\">\n" +
    "			<div class=\"col-md-12\">\n" +
    "				<span class=\"label label-info\">Your uploading is still running.</span> Click this button to refresh the view:\n" +
    "				<button type=\"button\" class=\"btn btn-default\" ng-click=\"refreshView()\">Refresh Drawers</button>\n" +
    "  			</div>\n" +
    "  		</div>\n" +
    "  		<div class=\"row\" ng-show=\"hasAvailableDrawers()\">\n" +
    "			<div class=\"col-md-12\">\n" +
    "  				<span class=\"description\" translate=\"Onvio.Migrations.DrawerSelection.Instruction\"></span>\n" +
    "  			</div>\n" +
    "  		</div>\n" +
    "  	</div>\n" +
    "\n" +
    "	<div ng-show=\"!loadItemSetBusy\">\n" +
    "	    <div bento-flexgrid-transferbox\n" +
    "	         box-one-item-source=\"availableDrawerList\"\n" +
    "	         box-two-item-source-old=\"drawerCtrl.gridDataTwo\"\n" +
    "	         box-two-item-source=\"selectedGridDataTwo\"\n" +
    "	         box-one-select-all=\"drawerCtrl.selectAllOne\"\n" +
    "	         box-two-select-all=\"drawerCtrl.selectAllTwo\"\n" +
    "	         column-definitions=\"drawerCtrl.config.columnDefinitions\"\n" +
    "	         box-one-title=\"{{drawerCtrl.config.availableTitle}}\"\n" +
    "	         box-two-title=\"{{drawerCtrl.config.selectedTitle}}\"\n" +
    "	         height=\"drawerCtrl.config.height\"\n" +
    "	         on-transfer=\"drawerCtrl.onTransfer(gridDataOne,gridDataTwo)\"\n" +
    "	         info-text=\"{{drawerCtrl.config.transferInfoText}}\"\n" +
    "	         pagination-info-text=\"{{drawerCtrl.config.paginationInfoText}}\"\n" +
    "	         pagination-info-page-text=\"{{drwaerCtrl.config.paginationInfoPageText}}\"\n" +
    "	         pagination-go-text=\"{{drawerCtrl.config.paginationGoText}}\"\n" +
    "	         transfer-btn-text=\"{{drawerCtrl.config.transferBtnText}}\"\n" +
    "	         show-filters=\"drawerCtrl.config.filtersShown\"\n" +
    "	         desktop-mode=\"drawerCtrl.desktopMode\"\n" +
    "	         lang=\"drwaerCtrl.config.language\">\n" +
    "	    </div>\n" +
    "	</div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/migration-new-client-reg.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/migration-new-client-reg.html",
    "<app-migration-client-registration></app-migration-client-registration>\n" +
    "");
}]);

angular.module("setup/src/migrations/migration-new.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/migration-new.html",
    "<app-setup-new-migration></app-setup-new-migration>");
}]);

angular.module("setup/src/migrations/migration-setup.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/migration-setup.2js.html",
    "<div id=\"notifications-view\" class=\"no-left-padding bm-cn\">\n" +
    "    <h1 class=\"no-top-margin\" translate>Onvio.Migrations.Title.DataMigration</h1>\n" +
    "    <div ng-show=\"noUtilityAppsInstalled()\">\n" +
    "        You have not installed any Onvio desktop utility programs.\n" +
    "        Please click <a target=\"_blank\" href=\"/ua/help/us-en/staff/core/documents/onvio-link.htm\">here</a> to install.\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!noUtilityAppsInstalled()\">\n" +
    "    <uib-tabset class=\"tabs-top\">\n" +
    "        <uib-tab deselect=\"vm.tabDeselect('fileCabinet')\">\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate>Onvio.Migrations.Title.FileCabinet</span><unsaved-indicator toggle=\"vm.hasUnsavedData\"></unsaved-indicator>\n" +
    "            </uib-tab-heading>\n" +
    "            <div class=\"common-detail-view-div no-margin-t\">\n" +
    "                <file-cabinet-migration-form migration-config=\"vm.migrationConfig\"></file-cabinet-migration-form>\n" +
    "            </div>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/new-migration/application-network.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/new-migration/application-network.2js.html",
    "<div>\n" +
    "	  <h4><strong><span translate=\"Onvio.Migrations.ApplicationsNetwork.Title\"></span></strong></h4>\n" +
    "\n" +
    "	  <form name=\"appsNetworkForm\" role=\"form\">\n" +
    "    <div class=\"row\">\n" +
    "    <div class=\"col-md-2\">\n" +
    "		    <div class=\"form-group\" ng-class=\"{'has-error': (appsNetworkForm.appToMigrate.$invalid && appsNetworkForm.appToMigrate.$dirty)}\">\n" +
    "			     <label for=\"appToMigrate\"><span translate=\"Onvio.Migrations.Application.To.Migrate\"></span> *</label>\n" +
    "      	   <div data-bento-select>\n" +
    "        	     <select name=\"appToMigrate\" class=\"form-control\" ng-model=\"appToMigrate\" required>\n" +
    "          			   <option ng-repeat=\"opt in appsMigrateOptions\" value=\"{{opt.value}}\">{{opt.name | translate}}</option>\n" +
    "        		   </select>\n" +
    "    	     </div>\n" +
    "    		   <div ng-show=\"appsNetworkForm.appToMigrate.$invalid && appsNetworkForm.appToMigrate.$dirty\" class=\"msg\" translate=\"BlueMoon.Setup.Common.RequiredField\"></div>\n" +
    "  		  </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "    <div class=\"col-md-5\" ng-show=\"selectFileCabinet()\">\n" +
    "		    <div class=\"form-group\" ng-class=\"{'has-error': (appsNetworkForm.pathToData.$invalid && appsNetworkForm.pathToData.$dirty)}\">\n" +
    "			     <label for=\"pathToData\"><span translate=\"Onvio.Migrations.Path.To.Data\"></span> *</label>\n" +
    "		       <!--input id=\"pathToData\" name=\"pathToData\" class=\"form-control\" type=\"text\" ng-model=\"pathToData\" required /-->\n" +
    "\n" +
    "           <div data-bento-select>\n" +
    "               <select id=\"pathToData\" name=\"pathToData\" class=\"form-control\" ng-model=\"pathToData\" required>\n" +
    "                   <option ng-repeat=\"opt in dataPathOptions\" value=\"{{opt}}\">{{opt}}</option>\n" +
    "               </select>\n" +
    "           </div>\n" +
    "           <div ng-show=\"appsNetworkForm.pathToData.$invalid && appsNetworkForm.pathToData.$dirty\" class=\"msg\" translate=\"BlueMoon.Setup.Common.RequiredField\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "	 </form>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/new-migration/confirmation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/new-migration/confirmation.2js.html",
    "<div>\n" +
    "  <h4><strong><span translate=\"Onvio.Migrations.Confirmation.Success\"></span></strong></h4>\n" +
    "  <span class=\"description\" translate=\"Onvio.Migrations.Confirmation.Instruction\"></span>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/new-migration/desktop-utility.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/new-migration/desktop-utility.2js.html",
    "<div>\n" +
    "  <h4><strong><span translate=\"Onvio.Migrations.DesktopUtility.Title\"></span></strong></h4>\n" +
    "  <span class=\"description\" translate=\"Onvio.Migrations.DesktopUtility.Instruction\"></span>\n" +
    "  <div bento-busy-loader=\"desktopUtilityChecking\">\n" +
    "  	  <div bento-alert bento-alert-object=\"connectionAlerts\">\n" +
    "  	  </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/new-migration/drawer-selection.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/new-migration/drawer-selection.2js.html",
    "<div>\n" +
    "	<h4><strong><span translate=\"Onvio.Migrations.DrawerSelection.Title\"></span></strong></h4>\n" +
    "  	<span class=\"description\" translate=\"Onvio.Migrations.DrawerSelection.Instruction\"></span>\n" +
    "\n" +
    "	<div>\n" +
    "	    <div bento-flexgrid-transferbox\n" +
    "	         box-one-item-source=\"availableDrawerList\"\n" +
    "	         box-two-item-source=\"drawerCtrl.gridDataTwo\"\n" +
    "	         box-one-select-all=\"drawerCtrl.selectAllOne\"\n" +
    "	         box-two-select-all=\"drawerCtrl.selectAllTwo\"\n" +
    "	         column-definitions=\"drawerCtrl.config.columnDefinitions\"\n" +
    "	         box-one-title=\"{{drawerCtrl.config.availableTitle}}\"\n" +
    "	         box-two-title=\"{{drawerCtrl.config.selectedTitle}}\"\n" +
    "	         height=\"drawerCtrl.config.height\"\n" +
    "	         on-transfer=\"drawerCtrl.onTransfer(gridDataOne,gridDataTwo)\"\n" +
    "	         info-text=\"{{drawerCtrl.config.transferInfoText}}\"\n" +
    "	         pagination-info-text=\"{{drawerCtrl.config.paginationInfoText}}\"\n" +
    "	         pagination-info-page-text=\"{{drwaerCtrl.config.paginationInfoPageText}}\"\n" +
    "	         pagination-go-text=\"{{drawerCtrl.config.paginationGoText}}\"\n" +
    "	         transfer-btn-text=\"{{drawerCtrl.config.transferBtnText}}\"\n" +
    "	         show-filters=\"drawerCtrl.config.filtersShown\"\n" +
    "	         desktop-mode=\"drawerCtrl.desktopMode\"\n" +
    "	         lang=\"drwaerCtrl.config.language\">\n" +
    "	    </div>\n" +
    "	</div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("setup/src/migrations/new-migration/new-main.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/migrations/new-migration/new-main.2js.html",
    "<div id=\"new-migration-view\" class=\"no-left-padding bm-cn\">\n" +
    "\n" +
    "    <h1 class=\"no-top-margin\" translate>Onvio.Migrations.Title.NewMigration</h1>\n" +
    "\n" +
    "    <form name=\"descriptionForm\" novalidate>\n" +
    "    <div class=\"row\">\n" +
    "    <div class=\"col-md-5\">\n" +
    "        <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error' : (descriptionForm.migrationDescription.$invalid && descriptionForm.migrationDescription.$dirty)}\">\n" +
    "            <label for=\"migrationDescription\"><span translate>Onvio.Migrations.New.Description</span> *</label>\n" +
    "            <input type=\"text\" id=\"migrationDescription\" name=\"migrationDescription\" class=\"form-control\"\n" +
    "                ng-model=\"migrationDescription\" bm-focus=\"true\" required ng-disabled=\"step === screens.confirmation\" />\n" +
    "            <div ng-show=\"descriptionForm.migrationDescription.$invalid && descriptionForm.migrationDescription.$dirty\" class=\"msg\" translate=\"BlueMoon.Setup.Common.RequiredField\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "    </form>\n" +
    "\n" +
    "    <div class=\"form-group col-md-8 col-sm-8 col-xs-10 no-margin-t\"  bento-busy-loader=\"busyLoading\">\n" +
    "        <strong><span class=\"migration-blue\">Migrations</span> / New Migration</strong>\n" +
    "    </div>\n" +
    "\n" +
    "    <div>\n" +
    "  	  	<div bento-wizard\n" +
    "        		on-change=\"onWizardChange(step)\"\n" +
    "        		on-finish=\"onWizardFinish()\"\n" +
    "       	 	  use-side-arrows=\"true\"\n" +
    "       		  current-step=\"step\"\n" +
    "       		  total-step=\"totalStep\"\n" +
    "            hide-previous-button=\"hidePreviousButton\"\n" +
    "            hide-next-button=\"hideNextButton\">\n" +
    "    	      <!-- Define step titles and descriptions -->\n" +
    "    	      <ol class=\"steps\">\n" +
    "      		      <li ng-disabled=\"stepDisabled[screens.appsNetwork]\">\n" +
    "        		        <span class=\"title\" translate=\"Onvio.Migrations.ApplicationsNetwork.Title\"></span>\n" +
    "        		        <span class=\"description\" translate=\"Onvio.Migrations.ApplicationsNetwork.Desc\"></span>\n" +
    "      		      </li>\n" +
    "      		      <li ng-disabled=\"disableDesktopUtility()\">\n" +
    "        		        <span class=\"title\" translate=\"Onvio.Migrations.DesktopUtility.Title\"></span>\n" +
    "        		        <span class=\"description\" translate=\"Onvio.Migrations.DesktopUtility.Desc\"></span>\n" +
    "      		      </li>\n" +
    "      		      <li ng-disabled=\"stepDisabled[screens.drawerSelection]\">\n" +
    "                    <span class=\"title\" translate=\"Onvio.Migrations.DrawerSelection.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Onvio.Migrations.DrawerSelection.Desc\"></span>\n" +
    "      		      </li>\n" +
    "                <li ng-disabled=\"stepDisabled[screens.confirmation]\">\n" +
    "                    <span class=\"title\" translate=\"Onvio.Migrations.Confirmation.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Onvio.Migrations.Confirmation.Desc\"></span>\n" +
    "                </li>\n" +
    "    	      </ol>\n" +
    "\n" +
    "            <!-- Define content for each step -->\n" +
    "    	      <ul class=\"contents no-margin-t no-padding-t\">\n" +
    "      		      <li><new-apps-network-form></new-apps-network-form></li>\n" +
    "      		      <li><new-desktop-util-form></new-desktop-util-form></li>\n" +
    "      		      <li><new-drawer-selection-form></new-drawer-selection-form></li>\n" +
    "      		      <li><new-confirmation-form></new-confirmation-form></li>\n" +
    "            </ul>\n" +
    "\n" +
    "            <!-- Custom buttons -->\n" +
    "            <button class=\"btn btn-default pull-left\" ng-show=\"showCancelButton()\" ng-click=\"cancelNewMigration()\">\n" +
    "                <span translate=\"Onvio.Migrations.Actions.Cancel\"></span>\n" +
    "            </button>\n" +
    "            <button class=\"btn btn-primary pull-right\" ng-show=\"showStartMigrationButton()\" ng-click=\"startMigration()\">\n" +
    "                <span translate=\"Onvio.Migrations.Actions.StartMigration\"></span>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("setup/src/models/accounting-costs/accounting-costs.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/models/accounting-costs/accounting-costs.html",
    "<div class=\"setup-accounting-costs ng-bento\">\n" +
    "    <setup-accounting-costs (router-changed)=\"vm.navigateTo($event)\" [template-id]=\"vm.templateId\"></setup-accounting-costs>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/models/add-costs-calculation/add-costs-calculation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/models/add-costs-calculation/add-costs-calculation.html",
    "<div class=\"add-costs-calculation\">\n" +
    "    <app-add-costs-calculation (router-changed)=\"vm.navigateTo($event)\" [template-id]=\"vm.templateId\"></app-add-costs-calculation>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/permission-groups/permission-groups-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/permission-groups/permission-groups-detail.html",
    "<bm-permission-groups-detail></bm-permission-groups-detail>");
}]);

angular.module("setup/src/permission-groups/permission-groups.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/permission-groups/permission-groups.html",
    "<bm-permission-groups-list></bm-permission-groups-list>");
}]);

angular.module("setup/src/security/setting-security.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/security/setting-security.html",
    "<app-setting-security></app-setting-security>");
}]);

angular.module("setup/src/terms/terms-setup/enable-terms/terms-enable-confirm-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/terms/terms-setup/enable-terms/terms-enable-confirm-modal.2js.html",
    "<div class=\"bento-modal\">\n" +
    "    <div class=\"modal-body modal-confirm-body\">\n" +
    "        <i class=\"glyphicons warning_sign modal-confirm-icon\"></i>\n" +
    "        <span class=\"modal-confirm-message\" translate>\n" +
    "            Onvio.Setup.Terms.Enable.Text\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.saveConfirm()\" translate>\n" +
    "            Onvio.Setup.Common.Actions.Confirm\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.cancelConfirm()\" translate>\n" +
    "            Bluemoon.Practice.Common.Actions.Cancel\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/terms/terms-setup/published-terms/published-terms-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/terms/terms-setup/published-terms/published-terms-modal.2js.html",
    "<div class=\"bento-modal published-terms terms-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closePublishedModal()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\">\n" +
    "      <span translate>Onvio.Setup.Terms.Published.Title</span> {{ vm.versionNumber }}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"sample-view\" ng-bind-html=\"vm.publishedText\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "      <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.closePublishedModal()\" translate>\n" +
    "          Bluemoon.Practice.Common.Actions.Cancel\n" +
    "      </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/terms/terms-setup/sample-terms/sample-terms-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/terms/terms-setup/sample-terms/sample-terms-modal.2js.html",
    "<div class=\"bento-modal sample-terms terms-modal\" role=\"dialog\">\n" +
    "    <button type=\"button\" class=\"close\" aria-label=\"close\" ng-click=\"vm.closeSampleModal()\" >\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" role=\"heading\" translate>\n" +
    "        Onvio.Setup.Terms.Sample.Title\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <span translate>\n" +
    "            Onvio.Setup.Terms.Sample.Instructions\n" +
    "        </span>\n" +
    "        <hr class=\"section-divider\" />\n" +
    "        <div class=\"sample-view\" ng-bind-html=\"vm.sampleText\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.copySample()\" translate>\n" +
    "            Onvio.Setup.Terms.Sample.Copy\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.closeSampleModal()\" translate>\n" +
    "            Bluemoon.Practice.Common.Actions.Cancel\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/terms/terms-setup/term-setup-form.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/terms/terms-setup/term-setup-form.2js.html",
    "<form role=\"form\" name=\"termSetup{{ vm.language }}\" novalidate=\"\" class=\"css-form\">\n" +
    "    <div ng-if=\"vm.publishedText\">\n" +
    "        <h3 class=\"no-top-margin\" translate>Onvio.Setup.Terms.Form.Title</h3>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-12 toggle-container\">\n" +
    "                <span class=\"text-padding-right\">\n" +
    "                    <span translate>Onvio.Setup.Terms.Form.Enable</span>\n" +
    "                </span>\n" +
    "                <span class=\"glyphicon glyphicon-info-sign text-margin-right-lg\" tooltip-placement=\"right\" uib-tooltip=\"{{ vm.tooltipText }}\" tooltip-append-to-body=\"true\"></span>\n" +
    "                <div role=\"switch\" bento-toggle tabindex=\"0\" ng-model=\"vm.toggleState\" on-change=\"vm.onToggleChange(value)\"\n" +
    "                ng-keyup=\"vm.toggleSwitch($event, vm.toggleState)\"></div> <!-- space bar key press event -->\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <h3 ng-class=\"{'no-top-margin': !vm.publishedText }\" translate>Onvio.Setup.Terms.Form.PublishedTitle</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <!-- Need published terms for display -->\n" +
    "            <ul class=\"list-inline\" ng-if=\"vm.publishedText\">\n" +
    "                <li><span translate>Onvio.Setup.Terms.Form.VersionLabel</span> {{ vm.versionNumber }}</li>\n" +
    "                <li>\n" +
    "                    <a tabindex=\"0\" ng-click=\"vm.openPublishedTermsModal()\" translate>\n" +
    "                        Onvio.Setup.Terms.Form.ViewPublished\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "            <!-- Display for no terms -->\n" +
    "            <div ng-if=\"!vm.publishedText\" translate>\n" +
    "                Onvio.Setup.Terms.Form.NoTerms\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <h3 translate>Onvio.Setup.Terms.Form.NewTitle</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\">\n" +
    "                <textarea class=\"form-control\" id=\"tempTermsText\" froala=\"vm.froalaOptions\" ng-model=\"vm.newText\" froala-event-content-changed=\"vm.froalaContentUpdated\"></textarea>\n" +
    "            </div>\n" +
    "            <a tabindex=\"0\" ng-click=\"vm.openSampleTermsModal()\" translate>\n" +
    "                Onvio.Setup.Terms.Form.ViewSample\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row bottom-margin\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <hr class=\"section-divider\" />\n" +
    "            <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.isDirtyText === false\" ng-click=\"vm.publishTerms()\" translate>\n" +
    "                Onvio.Setup.Terms.Form.PublishButton\n" +
    "            </button>\n" +
    "            <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.isDirtyText === false\" ng-click=\"vm.saveDraft(true)\" translate>\n" +
    "                Onvio.Setup.Terms.Form.SaveButton\n" +
    "            </button>\n" +
    "            <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.isDirtyText === false\" ng-click=\"vm.discardDraft()\" translate>\n" +
    "                Onvio.Setup.Terms.Form.DiscardButton\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("setup/src/terms/terms.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/terms/terms.html",
    "<div class=\"container-fluid no-left-padding terms-container\">\n" +
    "    <h1 class=\"no-top-margin\" translate>Onvio.Setup.Terms.Title</h1>\n" +
    "    <uib-tabset class=\"tabs-top\" active=vm.selectedTab>\n" +
    "        <uib-tab ng-repeat=\"language in vm.languages\" heading=\"{{ language.translatedDescription }}\" deselect=\"vm.tabDeselect(language)\" select=\"vm.tabSelect(language)\">\n" +
    "            <terms-setup-form data=\"language\"></terms-setup-form>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/themes/appearance-setup.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/themes/appearance-setup.2js.html",
    "<div id=\"notifications-view\" class=\"no-left-padding bm-cn\">\n" +
    "    <h1 class=\"no-top-margin\" translate>onvio.setup.theme.titles.appearanceSetup</h1>\n" +
    "    <uib-tabset class=\"tabs-top\">\n" +
    "        <uib-tab deselect=\"vm.tabDeselect('theme')\">\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate>onvio.setup.theme.titles.clientCenterSetup</span><unsaved-indicator toggle=\"vm.themeData.hasUnsavedTheme\"></unsaved-indicator>\n" +
    "            </uib-tab-heading>\n" +
    "            <div class=\"common-detail-view-div\">\n" +
    "                <theme-setup-form theme-setup-data=\"vm.themeData\"></theme-setup-form>\n" +
    "            </div>\n" +
    "        </uib-tab>\n" +
    "        <uib-tab deselect=\"vm.tabDeselect('signIn')\">\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate>onvio.setup.theme.titles.signInOptions</span><unsaved-indicator toggle=\"vm.themeData.hasUnsavedSignIn\"></unsaved-indicator>\n" +
    "            </uib-tab-heading>\n" +
    "            <div class=\"common-detail-view-div\">\n" +
    "                <sign-in-options-form options-data=\"vm.themeData\"></sign-in-options-form>\n" +
    "            </div>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/themes/sign-in-options.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/themes/sign-in-options.2js.html",
    "<div id=\"signInOptionsContainer\" class=\"container-fluid no-left-padding view-container\">\n" +
    "<form role=\"form\" name=\"vm.signInSettingsForm\" novalidate=\"\" class=\"css-form\">\n" +
    "    <fieldset>\n" +
    "      <div class=\"row bottom-margin\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "          <h3 translate>\n" +
    "            onvio.setup.appearance.signInBackground\n" +
    "          </h3>\n" +
    "          <!-- background select -->\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-sm-4 bm-dropdown-col\">\n" +
    "                <div class=\"bm-dropdown-thumbnail bm-{{vm.selected.name}}\"></div>\n" +
    "                <span class=\"dropdown center bento-dropdown\" uib-dropdown>\n" +
    "                  <a role=\"button\" class=\"dropdown-toggle btn btn-link\" uib-dropdown-toggle><span\n" +
    "                    class=\"dropdown-text\" translate>onvio.setup.appearance.changeImage</span><i class=\"bento-icon-chevron-down\"></i>\n" +
    "                  </a>\n" +
    "                  <!-- PROVIDES SCROLLING LIST IN BENTO 1.2 -->\n" +
    "                  <div class=\"dropdown-menu\">\n" +
    "                    <ul class=\"dropdown-scroll bm-thumbnail-list\">\n" +
    "                    <!-- <ul class=\"dropdown-menu bm-thumbnail-list\"> -->\n" +
    "                      <li ng-repeat=\"background in vm.backgrounds\" ng-if=\"!background.active\">\n" +
    "                        <a ng-click=\"vm.selectBackground(background)\">\n" +
    "                          <div class=\"bm-dropdown-thumbnail bm-{{background.name}}\"></div>\n" +
    "                        </a>\n" +
    "                      </li>\n" +
    "                    </ul>\n" +
    "                  </div>\n" +
    "                </span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <!-- sign out url -->\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-sm-6 form-group\" ng-class=\"{'has-error' : vm.signInSettingsForm.signoutLocation.$invalid && vm.signInSettingsForm.signoutLocation.$touched}\">\n" +
    "              <h3 translate>\n" +
    "                onvio.setup.appearance.signoutUrlHeader\n" +
    "              </h3>\n" +
    "              <label for=\"signoutLocation\" translate>onvio.setup.appearance.signoutUrlLabel</label>\n" +
    "              <input type=\"url\" name=\"signoutLocation\" id=\"signoutLocation\" ng-model=\"vm.signoutUrl\" ng-model-options=\"{ debounce: 500, blur: 0 }\" class=\"form-control bm-inline-control\" placeholder=\"{{vm.rootUrl}}\" setup-contact-editor-url-protocol-defaulter=\"\" bm-format-on-blur=\"\" url-validator>\n" +
    "              <a role=\"button\" target=\"_blank\" class=\"bm-theme-url-preview\" ng-href=\"{{vm.signoutUrl === '' ? vm.rootUrl : vm.signoutUrl}}\" ng-class=\"{'bm-disabled-link':vm.signInSettingsForm.signoutLocation.$invalid}\"><i class=\"bento-icon-newtab\"></i></a>\n" +
    "              <div class=\"msg\" ng-messages=\"vm.signInSettingsForm.signoutLocation.$error\" ng-if=\"vm.signInSettingsForm.signoutLocation.$touched || vm.signInSettingsForm.$submitted\">\n" +
    "                    <span ng-message=\"invalidUrl\">{{ 'onvio.setup.appearance.invalidSignoutUrl' | translate }}</span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <!-- sign in html -->\n" +
    "          <div class=\"row\">\n" +
    "            <h2 class=\"col-xs-12\" translate=\"onvio.setup.appearance.signinForm.client.title\"></h2>\n" +
    "            <div class=\"col-lg-6\">\n" +
    "            <p translate=\"onvio.setup.appearance.signinForm.client.instructions\"></p>\n" +
    "            <div class=\"code-preview\">\n" +
    "                <div class=\"bar\">\n" +
    "                    <h2 translate=\"onvio.setup.appearance.signinForm.code.title\"></h2>\n" +
    "                    <button ng-click=\"vm.copyToClipboard(vm.clientCenterSigninHTML)\" class=\"btn btn-outline-primary\" translate=\"onvio.setup.appearance.signinForm.code.copy\"></button>\n" +
    "                </div>\n" +
    "                <pre>{{vm.clientCenterSigninHTML}}</pre>\n" +
    "            </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-lg-6\">\n" +
    "            <h3 translate=\"onvio.setup.appearance.signinForm.preview\"></h3>\n" +
    "            <div class=\"sign-in-preview\" ng-bind-html=\"vm.clientCenterSigninHTML\"></div>\n" +
    "            </div>\n" +
    "\n" +
    "            <h2 class=\"col-xs-12\"\n" +
    "                translate=\"onvio.setup.appearance.signinForm.staff.title\"></h2>\n" +
    "            <div class=\"col-lg-6\">\n" +
    "            <p translate=\"onvio.setup.appearance.signinForm.staff.instructions\"></p>\n" +
    "            <div class=\"code-preview\">\n" +
    "                <div class=\"bar\">\n" +
    "                    <h2 translate=\"onvio.setup.appearance.signinForm.code.title\"></h2>\n" +
    "                    <button ng-click=\"vm.copyToClipboard(vm.onvioSigninHTML)\" class=\"btn btn-outline-primary\" translate=\"onvio.setup.appearance.signinForm.code.copy\"></button>\n" +
    "                </div>\n" +
    "                <pre>{{vm.onvioSigninHTML}}</pre>\n" +
    "            </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-lg-6\">\n" +
    "            <h3 translate=\"onvio.setup.appearance.signinForm.preview\"></h3>\n" +
    "            <div class=\"sign-in-preview\" ng-bind-html=\"vm.onvioSigninHTML\"></div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-9\">\n" +
    "            <hr class=\"section-divider\" />\n" +
    "            <button class=\"btn btn-primary\" ng-click=\"vm.saveSettings()\" translate>\n" +
    "                onvio.setup.appearance.saveSettings\n" +
    "            </button>\n" +
    "            <button class=\"btn btn-default\" ng-click=\"vm.resetSettings()\" translate>\n" +
    "                Bluemoon.Practice.Common.Actions.Cancel\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("setup/src/themes/theme-setup-image-preview.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/themes/theme-setup-image-preview.html",
    "<div class=\"col-sm-8\">\n" +
    "    <h4 class=\"header-sm-top-margin\" translate=\"Onvio.Setup.Theme.Titles.Preview\"></h4>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-11 header-preview\" ng-style=\"{ 'background-color': vm.selectedTheme.headerFill['background-color'], 'color': vm.selectedTheme.headerText['background-color']}\">\n" +
    "            <div class=\"pull-left clearfix\" ng-if=\"vm.selectedImageSrc\">\n" +
    "                <img class=\"header-image-preview\" ng-src=\"{{ vm.selectedImageSrc }}\" />\n" +
    "            </div>\n" +
    "            <div class=\"header-preview-text\" ng-if=\"vm.textPreview === vm.toggleSettings.text\">\n" +
    "                <div>\n" +
    "                    {{ vm.selectedHeaderText.lineOne }}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("setup/src/themes/theme-setup-next.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/themes/theme-setup-next.html",
    "<app-site-settings></app-site-settings>\n" +
    "");
}]);

angular.module("setup/src/themes/theme-setup.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("setup/src/themes/theme-setup.2js.html",
    "<div id=\"themeContainer\" class=\"container-fluid no-left-padding view-container\">\n" +
    "    <div class=\"row bottom-margin\" ng-if=\"vm.themeSettings\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <form role=\"form\" name=\"vm.themeSetupForm\" novalidate=\"\" class=\"css-form\">\n" +
    "                <h2 bm-if-has-no-access=\"BR_DisableSiteSetupOptions\" class=\"no-top-margin\" translate=\"Onvio.Setup.Theme.Titles.SiteColors\"></h2>\n" +
    "                <!-- Color Schemes -->\n" +
    "                <fieldset class=\"bottom-margin\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-sm-4\">\n" +
    "                            <h3 class=\"header-sm-top-margin\" bm-if-has-no-access=\"BR_DisableSiteSetupOptions\" translate=\"Onvio.Setup.Theme.Titles.DefaultThemesSection\"></h3>\n" +
    "                            <div class=\"form-group\" bm-if-has-no-access=\"BR_DisableSiteSetupOptions\">\n" +
    "                                <span class=\"theme-color\" ng-style=\"vm.selectedColorScheme.headerFill\"></span>\n" +
    "                                <span class=\"theme-color\" ng-style=\"vm.selectedColorScheme.headerText\"></span>\n" +
    "                                <span class=\"theme-color\" ng-style=\"vm.selectedColorScheme.buttonFill\"></span>\n" +
    "                                <span class=\"theme-color last-color\" ng-style=\"vm.selectedColorScheme.buttonText\"></span>\n" +
    "                                <span class=\"dropdown center theme-menu-icon text-nowrap\" uib-dropdown>\n" +
    "                                    <a class=\"dropdown-toggle plain-text bento-icon-chevron-medium-down\" uib-dropdown-toggle></a>\n" +
    "                                    <ul class=\"dropdown-menu\">\n" +
    "                                        <li ng-repeat=\"scheme in vm.cannedThemes\">\n" +
    "                                            <a class=\"theme-color-row\" ng-click=\"vm.setSelectedColorScheme(scheme, true)\">\n" +
    "                                                <span class=\"theme-color\" ng-style=\"scheme.headerFill\"></span>\n" +
    "                                                <span class=\"theme-color\" ng-style=\"scheme.headerText\"></span>\n" +
    "                                                <span class=\"theme-color\" ng-style=\"scheme.buttonFill\"></span>\n" +
    "                                                <span class=\"theme-color\" ng-style=\"scheme.buttonText\"></span>\n" +
    "                                            </a>\n" +
    "                                        </li>\n" +
    "                                    </ul>\n" +
    "                                </span>\n" +
    "                            </div>\n" +
    "                            <div class=\"row color-picker-row\">\n" +
    "                                <div class=\"col-sm-7 col-md-7 col-lg-6 color-picker-label\" translate=\"Onvio.Setup.Theme.Labels.HeaderFill\"></div>\n" +
    "                                <spectrum-colorpicker id=\"headerFill\" ng-model=\"vm.selectedTheme.headerFill['background-color']\" options=\"vm.pickerOptions\" format=\"'hex'\"></spectrum-colorpicker>\n" +
    "                            </div>\n" +
    "                            <div class=\"row color-picker-row\">\n" +
    "                                <div class=\"col-sm-7 col-md-7 col-lg-6 color-picker-label\" translate=\"Onvio.Setup.Theme.Labels.HeaderText\"></div>\n" +
    "                                <spectrum-colorpicker id=\"headerText\" ng-model=\"vm.selectedTheme.headerText['background-color']\" options=\"vm.pickerOptions\" format=\"'hex'\"></spectrum-colorpicker>\n" +
    "                            </div>\n" +
    "                            <div class=\"row color-picker-row\" bm-if-has-no-access=\"BR_DisableSiteSetupOptions\">\n" +
    "                                <div class=\"col-sm-7 col-md-7 col-lg-6 color-picker-label\" translate=\"Onvio.Setup.Theme.Labels.ButtonFill\"></div>\n" +
    "                                <spectrum-colorpicker id=\"buttonFill\" ng-model=\"vm.selectedTheme.buttonFill['background-color']\" options=\"vm.pickerOptions\" format=\"'hex'\"></spectrum-colorpicker>\n" +
    "                            </div>\n" +
    "                            <div class=\"row color-picker-row\" bm-if-has-no-access=\"BR_DisableSiteSetupOptions\">\n" +
    "                                <div class=\"col-sm-7 col-md-7 col-lg-6 color-picker-label\" translate=\"Onvio.Setup.Theme.Labels.ButtonText\"></div>\n" +
    "                                <spectrum-colorpicker id=\"buttonText\" ng-model=\"vm.selectedTheme.buttonText['background-color']\" options=\"vm.pickerOptions\" format=\"'hex'\"></spectrum-colorpicker>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-sm-5\" bm-if-has-no-access=\"BR_DisableSiteSetupOptions\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-sm-10\">\n" +
    "                                     <h4 class=\"header-sm-top-margin\" translate=\"Onvio.Setup.Theme.Titles.Preview\"></h4>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row no-left-margin\">\n" +
    "                                <div class=\"col-sm-10 thumb-header\" ng-style=\"{ 'background-color': vm.selectedTheme.headerFill['background-color'], 'color': vm.selectedTheme.headerText['background-color']}\" translate=\"Onvio.Setup.Theme.Preview.HeaderText\"></div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row no-left-margin\">\n" +
    "                                <div class=\"col-sm-10 thumb-content\">\n" +
    "                                    <div class=\"row\">\n" +
    "                                        <div class=\"col-sm-10 col-sm-offset-2 thumb-login\">\n" +
    "                                            <h2 translate=\"Onvio.Setup.Theme.Preview.PageText\"></h2>\n" +
    "                                            <button type=\"button\" class=\"btn btn-primary thumb-button\" ng-style=\"{ 'background-color': vm.selectedTheme.buttonFill['background-color'], 'color': vm.selectedTheme.buttonText['background-color']}\" translate=\"Onvio.Setup.Theme.Preview.Button\"></button>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div bm-if-has-access=\"BR_DisableSiteSetupOptions\" ng-include=\"vm.imageTemplatePreview\"></div>\n" +
    "                    </div>\n" +
    "                </fieldset>\n" +
    "                <h3 class=\"header-sm-top-margin\" translate=\"Onvio.Setup.Common.Titles.Header\"></h3>\n" +
    "                <fieldset class=\"bottom-margin\">\n" +
    "                    <div class=\"form-group no-bottom-margin\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-sm-4\">\n" +
    "                                <h4 class=\"header-sm-top-margin\" translate=\"Onvio.Setup.Theme.Titles.Options\"></h4>\n" +
    "                                <div class=\"row\">\n" +
    "                                    <div class=\"col-sm-12\">\n" +
    "                                        <div class=\"checkbox no-top-margin\">\n" +
    "                                            <label>\n" +
    "                                                <input type=\"checkbox\" ng-model=\"vm.imagePreview\" ng-true-value=\"'image'\" ng-false-value=\"'none'\" ng-change=\"vm.headerImageChange()\" /> <span translate=\"Onvio.Setup.Theme.Labels.AddImage\"></span>\n" +
    "                                            </label>\n" +
    "                                        </div>\n" +
    "                                        <div class=\"checkbox\">\n" +
    "                                            <label>\n" +
    "                                                <input type=\"checkbox\" name=\"line1Toggle\" ng-model=\"vm.textPreview\" ng-true-value=\"'text'\" ng-false-value=\"'none'\" ng-change=\"vm.headerTextChange()\" /> <span translate=\"Onvio.Setup.Theme.Labels.AddText\"></span>\n" +
    "                                            </label>\n" +
    "                                        </div>\n" +
    "                                        <div ng-if=\"vm.textPreview === vm.toggleSettings.text\">\n" +
    "                                            <div class=\"form-group theme-checkbox-panel\">\n" +
    "                                                <input type=\"text\" id=\"line1\" ng-model=\"vm.selectedHeaderText.lineOne\" class=\"form-control\" />\n" +
    "                                            </div>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div bm-if-has-no-access=\"BR_DisableSiteSetupOptions\" ng-include=\"vm.imageTemplatePreview\"></div>\n" +
    "                        </div>\n" +
    "                        <bm-image-upload-modal api=\"vm.imageUploadApi\"></bm-image-upload-modal>\n" +
    "                    </div>\n" +
    "                </fieldset>\n" +
    "                <div class=\"row\" bm-if-has-no-access=\"BR_DisableSiteSetupOptions\">\n" +
    "                    <div class=\"col-sm-9\">\n" +
    "                        <a role=\"button\" class=\"btn btn-link btn-lg theme-preview-link\" ng-href=\"\" ng-click=\"vm.previewTheme()\">\n" +
    "                            <span translate=\"Onvio.Setup.Theme.Buttons.PreviewTheme\"></span> <i class=\"bento-icon-newtab\"></i>\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-sm-9\">\n" +
    "                        <hr class=\"section-divider\" />\n" +
    "                        <button class=\"btn btn-primary\" ng-click=\"vm.saveTheme()\" translate>\n" +
    "                            Onvio.Setup.Theme.Buttons.SaveTheme\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-default\" ng-click=\"vm.resetTheme()\" translate>\n" +
    "                            Onvio.Setup.Theme.Buttons.DiscardChanges\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/main/dashboard-tour.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/main/dashboard-tour.html",
    "<div class=\"tour-confirmation-modal\">\n" +
    "    <div class=\"modal-header\"\n" +
    "         translate=\"onvio.dashboard.tour.welcome\"></div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p translate=\"onvio.dashboard.tour.pitch\"></p>\n" +
    "        <p class=\"strong\"\n" +
    "           translate=\"onvio.dashboard.tour.question\"></p>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary\"\n" +
    "                ng-click=\"conf.startTour()\"\n" +
    "                translate=\"onvio.dashboard.tour.start\"></button>\n" +
    "        <button class=\"btn btn-default\"\n" +
    "                ng-click=\"conf.askNextTime()\"\n" +
    "                translate=\"onvio.dashboard.tour.nexttime\"></button>\n" +
    "        <button class=\"btn btn-default\"\n" +
    "                ng-click=\"conf.noThanks()\"\n" +
    "                translate=\"onvio.dashboard.tour.nothanks\"></button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("views/main/preview-tour.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/main/preview-tour.html",
    "<div class=\"modal-header\">\n" +
    "    <h1 id=\"bm-preview-header\" translate=\"onvio.preview.tour.primaryHeader\"></h1>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <div class=\"bento-alert-container\">\n" +
    "        <div class=\"alert bento-alert alert-warning\" role=\"alert\">\n" +
    "            <span class=\"strong\" translate=\"onvio.preview.tour.warning\"></span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <h5 translate=\"onvio.preview.tour.secondaryHeader\"></h5>\n" +
    "    <p translate=\"onvio.preview.tour.body\"></p>\n" +
    "    <p translate=\"onvio.preview.tour.nextSteps\"></p>\n" +
    "    <p><span translate=\"onvio.preview.tour.legal\"></span> <a ng-href=\"{{conf.previewTerms}}\" translate=\"onvio.preview.tour.legal.link\"></a><span ng-if=\"conf.fr\" translate=\"onvio.preview.tour.legal.postLink\"></span>.</p>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"conf.startTour()\" translate=\"onvio.dashboard.tour.start\"></button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"conf.noThanks()\" translate=\"onvio.dashboard.tour.nothanks\"></button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/main/purchase-confirmation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/main/purchase-confirmation.html",
    "<div class=\"purchase-image\">\n" +
    "</div>\n" +
    "<div class=\"modal-header\">\n" +
    "    <h1 id=\"bm-purchase-confirmation-header\"\n" +
    "        translate=\"onvio.purchase.confirmation.primaryHeader\"></h1>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <p translate=\"onvio.purchase.confirmation.body.reminder\"></p>\n" +
    "    <p translate=\"onvio.purchase.confirmation.body.trial\"></p>\n" +
    "    <p translate=\"onvio.purchase.confirmation.body.whereToStart\"></p>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\"\n" +
    "            ng-click=\"conf.getStarted()\"\n" +
    "            translate=\"onvio.tour.donebtn\"></button>\n" +
    "</div>");
}]);

angular.module("views/main/setup-widget.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/main/setup-widget.html",
    "<div bento-alert\n" +
    "     bento-alert-object=\"set.setupWidgetFormAlert\"\n" +
    "     bento-alert-close=\"closeAlert($index)\"></div>\n" +
    "<div class=\"setup-widget-modal\">\n" +
    "    <div class=\"setup-tr-logo\"></div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <p class=\"setup-40\">\n" +
    "            <span translate=\"onvio.setup.widget.header.youre\"></span>\n" +
    "            <span class=\"setup-widget-orange\"\n" +
    "                  translate=\"onvio.setup.widget.header.in\"></span>\n" +
    "        </p>\n" +
    "        <p translate=\"onvio.setup.widget.header.questions\"></p>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <form name=\"setupWidgetForm\">\n" +
    "            <div class=\"setup-question-blocks\">\n" +
    "                <div class=\"circle\"\n" +
    "                     ng-class=\"{complete: set.firmnameComplete}\">\n" +
    "                    <i ng-if=\"set.firmnameComplete\"\n" +
    "                       class=\"bento-icon-checkmark\"></i>\n" +
    "                    <div ng-if=\"!set.firmnameComplete\">1</div>\n" +
    "                </div>\n" +
    "                <div class=\"setup-question-content\">\n" +
    "                    <i class=\"bento-icon-buildings\"></i>\n" +
    "                    <p class=\"setup-center\"\n" +
    "                       translate=\"onvio.setup.widget.body.question.firmname\"></p>\n" +
    "                    <div class=\"form-group\"\n" +
    "                         ng-class=\"{'has-error': set.firmname}\">\n" +
    "                        <input required\n" +
    "                               name=\"firmname\"\n" +
    "                               type=\"text\"\n" +
    "                               class=\"bento-input form-control\"\n" +
    "                               ng-maxlength=\"250\"\n" +
    "                               ng-model=\"set.firmnameValue\"\n" +
    "                               ng-focus=\"set.onFirmnameFocus()\"\n" +
    "                               ng-blur=\"set.onFirmnameBlur()\" />\n" +
    "                        <p class=\"msg\"\n" +
    "                           ng-show=\"setupWidgetForm.firmname.$error.required\"\n" +
    "                           translate=\"onvio.setup.widget.body.error.firmname.required\"></p>\n" +
    "                        <p class=\"msg\"\n" +
    "                           ng-show=\"setupWidgetForm.firmname.$error.maxlength\"\n" +
    "                           translate=\"onvio.setup.widget.body.error.firmname.maxlength\"></p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"setup-question-blocks\">\n" +
    "                <div class=\"circle\"\n" +
    "                     ng-class=\"{complete: set.staffComplete}\">\n" +
    "                    <i ng-if=\"set.staffComplete\"\n" +
    "                       class=\"bento-icon-checkmark\"></i>\n" +
    "                    <div ng-if=\"!set.staffComplete\">2</div>\n" +
    "                </div>\n" +
    "                <div class=\"setup-question-content\">\n" +
    "                    <i class=\"bento-icon-users\"></i>\n" +
    "                    <p class=\"setup-center\"\n" +
    "                       translate=\"onvio.setup.widget.body.question.staff\"></p>\n" +
    "                    <div class=\"setup-question-radio-container\">\n" +
    "                        <div class=\"setup-question-staff-yes\">\n" +
    "                            <input type=\"radio\"\n" +
    "                                   name=\"staff\"\n" +
    "                                   id=\"staffYes\"\n" +
    "                                   ng-model=\"set.staffyes\"\n" +
    "                                   ng-change=\"set.onStaffChange()\"\n" +
    "                                   value=\"staff_yes\" />\n" +
    "                            <label for=\"staffYes\"\n" +
    "                                   translate=\"Onvio.Setup.Common.Buttons.Yes\"></label>\n" +
    "                        </div>\n" +
    "                        <div class=\"setup-question-staff-no\">\n" +
    "                            <input type=\"radio\"\n" +
    "                                   name=\"staff\"\n" +
    "                                   id=\"staffNo\"\n" +
    "                                   ng-model=\"set.staffno\"\n" +
    "                                   ng-change=\"set.onStaffChange()\"\n" +
    "                                   value=\"staff_no\" />\n" +
    "                            <label for=\"staffNo\"\n" +
    "                                   translate=\"Onvio.Setup.Common.Buttons.No\"></label>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"setup-question-blocks\">\n" +
    "                <div class=\"circle\"\n" +
    "                     ng-class=\"{complete: set.servicesComplete}\">\n" +
    "                    <i ng-if=\"set.servicesComplete\"\n" +
    "                       class=\"bento-icon-checkmark\"></i>\n" +
    "                    <div ng-if=\"!set.servicesComplete\">3</div>\n" +
    "                </div>\n" +
    "                <div class=\"setup-question-content\">\n" +
    "                    <i class=\"bento-icon-briefcase\"></i>\n" +
    "                    <p translate=\"onvio.setup.widget.body.question.services\"></p>\n" +
    "                    <div class=\"setup-question-services-container\">\n" +
    "                        <span>\n" +
    "                            <input type=\"checkbox\"\n" +
    "                                   class=\"services-checkboxes\"\n" +
    "                                   ng-change=\"set.onServicesChange()\"\n" +
    "                                   value=\"accounting\"\n" +
    "                                   ng-model=\"set.accounting\"\n" +
    "                                   id=\"accounting\" />\n" +
    "                            <label for=\"accounting\">\n" +
    "                                <span translate=\"onvio.setup.widget.question.services.accounting\"></span>\n" +
    "                            </label>\n" +
    "                        </span>\n" +
    "                        <span>\n" +
    "                            <input type=\"checkbox\"\n" +
    "                                   class=\"services-checkboxes\"\n" +
    "                                   ng-change=\"set.onServicesChange()\"\n" +
    "                                   value=\"attestation\"\n" +
    "                                   ng-model=\"set.attestation\"\n" +
    "                                   id=\"attestation\" />\n" +
    "                            <label for=\"attestation\">\n" +
    "                                <span translate=\"onvio.setup.widget.question.services.attestation\"></span>\n" +
    "                            </label>\n" +
    "                        </span>\n" +
    "                        <span>\n" +
    "                            <input type=\"checkbox\"\n" +
    "                                   class=\"services-checkboxes\"\n" +
    "                                   ng-change=\"set.onServicesChange()\"\n" +
    "                                   value=\"payroll\"\n" +
    "                                   ng-model=\"set.payroll\"\n" +
    "                                   id=\"payroll\" />\n" +
    "                            <label for=\"payroll\">\n" +
    "                                <span translate=\"onvio.setup.widget.question.services.payroll\"></span>\n" +
    "                            </label>\n" +
    "                        </span>\n" +
    "                        <span>\n" +
    "                            <input type=\"checkbox\"\n" +
    "                                   class=\"services-checkboxes\"\n" +
    "                                   ng-change=\"set.onServicesChange()\"\n" +
    "                                   value=\"individual_tax\"\n" +
    "                                   ng-model=\"set.individual_tax\"\n" +
    "                                   id=\"individual_tax\" />\n" +
    "                            <label for=\"individual_tax\">\n" +
    "                                <span translate=\"onvio.setup.widget.question.services.individualTax\"></span>\n" +
    "                            </label>\n" +
    "                        </span>\n" +
    "                        <span>\n" +
    "                            <input type=\"checkbox\"\n" +
    "                                   class=\"services-checkboxes\"\n" +
    "                                   ng-change=\"set.onServicesChange()\"\n" +
    "                                   value=\"business_tax\"\n" +
    "                                   ng-model=\"set.business_tax\"\n" +
    "                                   id=\"business_tax\" />\n" +
    "                            <label for=\"business_tax\">\n" +
    "                                <span translate=\"onvio.setup.widget.question.services.businessTax\"></span>\n" +
    "                            </label>\n" +
    "                        </span>\n" +
    "                        <span>\n" +
    "                            <input type=\"checkbox\"\n" +
    "                                   class=\"services-checkboxes\"\n" +
    "                                   ng-change=\"set.onServicesChange()\"\n" +
    "                                   value=\"consulting\"\n" +
    "                                   ng-model=\"set.consulting\"\n" +
    "                                   id=\"consulting\" />\n" +
    "                            <label for=\"consulting\">\n" +
    "                                <span translate=\"onvio.setup.widget.question.services.consulting\"></span>\n" +
    "                            </label>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary\"\n" +
    "                ng-click=\"set.done()\"\n" +
    "                ng-disabled=\"!set.firmnameComplete || !set.staffComplete || !set.servicesComplete\"\n" +
    "                translate=\"onvio.tour.donebtn\"></button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("views/not-found/not-found.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/not-found/not-found.html",
    "<div class=\"container-fluid\">\n" +
    "    <div class=\"row\">\n" +
    "        <h4 data-translate=\"Onvio.Shell.NotFound.MainText\"></h4><br/>\n" +
    "        <a class=\"btn btn-primary\" href=\"#/\" data-translate=\"Onvio.Shell.NotFound.GoToDashboard\"></a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/test/hybrid-playground.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/test/hybrid-playground.html",
    "<div class=\"row hybrid-playground\">\n" +
    "    <div class=\"col-md-6\">\n" +
    "        <h1>Bento NG</h1>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <app-bento-combobox-ng [data]=\"$ctrl.data\"></app-bento-combobox-ng>\n" +
    "                <app-bento-alert-ng></app-bento-alert-ng>\n" +
    "                <div class=\"ng-bento\">\n" +
    "                    <ol class=\"breadcrumb\">\n" +
    "                        <li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li>\n" +
    "                        <li class=\"breadcrumb-item\"><a href=\"#\">Library</a></li>\n" +
    "                        <li class=\"breadcrumb-item active\">Data</li>\n" +
    "                    </ol>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <app-wijmo-grid-ng [data]=\"$ctrl.gridData\"></app-wijmo-grid-ng>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-6\">\n" +
    "        <h1>Bento Modern</h1>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <bento-combobox get-data=\"$ctrl.getData()\"\n" +
    "                                ng-model=\"$ctrl.legacyModel\"\n" +
    "                                placeholder=\"Select Here...\"\n" +
    "                                label-name=\"name\">\n" +
    "                </bento-combobox>\n" +
    "                <uib-accordion class=\"bento-accordion\">\n" +
    "                    <div uib-accordion-group>\n" +
    "                        <uib-accordion-heading>\n" +
    "                            Header\n" +
    "                        </uib-accordion-heading>\n" +
    "                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a enim dapibus, sollicitudin\n" +
    "                        felis sed, ultricies ex. Proin\n" +
    "                        molestie fermentum urna vel molestie. Aliquam porttitor vulputate lobortis. Praesent ac ex\n" +
    "                        ipsum. Ut pellentesque,\n" +
    "                        turpis sed molestie dictum, justo orci lacinia est, nec consectetur elit nunc ac metus. Aliquam\n" +
    "                        porttitor\n" +
    "                        vulputate lobortis. Praesent ac ex ipsum. Ut pellentesque, turpis sed molestie dictum.\n" +
    "                    </div>\n" +
    "                    <div uib-accordion-group>\n" +
    "                        <uib-accordion-heading>\n" +
    "                            Header\n" +
    "                        </uib-accordion-heading>\n" +
    "                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a enim dapibus, sollicitudin\n" +
    "                        felis sed, ultricies ex. Proin\n" +
    "                        molestie fermentum urna vel molestie. Aliquam porttitor vulputate lobortis. Praesent ac ex\n" +
    "                        ipsum. Ut pellentesque,\n" +
    "                        turpis sed molestie dictum, justo orci lacinia est, nec consectetur elit nunc ac metus. Aliquam\n" +
    "                        porttitor\n" +
    "                        vulputate lobortis. Praesent ac ex ipsum. Ut pellentesque, turpis sed molestie dictum.\n" +
    "                    </div>\n" +
    "                </uib-accordion>\n" +
    "                <div>\n" +
    "                    <div bento-alert\n" +
    "                         bento-alert-object=\"$ctrl.alerts\"\n" +
    "                         bento-alert-close=\"$ctrl.closeAlert($index)\"></div>\n" +
    "                    <button class=\"btn btn-default\"\n" +
    "                            ng-click=\"$ctrl.addAlert()\">Add Persistent Alert</button>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <ol class=\"breadcrumb\">\n" +
    "                        <li><a href>Home</a></li>\n" +
    "                        <li><a href>Category</a></li>\n" +
    "                        <li class=\"active\">Sub-Category</li>\n" +
    "                    </ol>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <wj-flex-grid control=\"$ctrl.flexGrid\"\n" +
    "                              items-source=\"$ctrl.gridData\"\n" +
    "                              sticky-headers=\"true\"\n" +
    "                              class=\"bento-flex-grid\">\n" +
    "                    <wj-flex-grid-cell-template cell-type=\"RowHeader\">{{$row.index+1}}</wj-flex-grid-cell-template>\n" +
    "                    <wj-flex-grid-column ng-repeat=\"key in $ctrl.columnBindings\"\n" +
    "                                         ng-if=\"key!=='selected'&&key!=='id'\"\n" +
    "                                         min-width=\"120\"\n" +
    "                                         width=\"*\"\n" +
    "                                         header=\"{{key}}\"\n" +
    "                                         binding=\"{{key}}\"></wj-flex-grid-column>\n" +
    "                </wj-flex-grid>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);
